const resources = {
  translation: {
    DASHBOARD: {
      LOCATION_CARD: {
        HEADER: {
          SUBTITLE: {
            NO_DATA: '0',
            ALARM: 'Alarma {{count}}',
            ALARM_plural: '{{count}} Alarmas',
            ALARM_noData: '0 Alarmas',
            NORMAL: 'Normal',
},
          INFO: {
            SEPARATOR : ' ,',
            DEVICE: '{{count}} Dispositivo',
            DEVICE_plural: '{{count}} dispositivos',
            SITE: '{{count}} Sitio',
            SITE_plural                    : '{{count}} Sitios',
            DEVICE_noData: '0 dispositivos',
            SITE_noData  : '0 sitios',
},
},
        BODY: {
          ALARMS: 'Alarma {{count}}',
          ALARMS_plural: '{{count}} Alarmas',
          EVENTS: '{{count}} Event',
          EVENTS_plural: '{{count}} Eventos',
          ALARMS_noData: '0 Alarmas',
          EVENTS_noData: '0 eventos',
},
        FOOTER: {
          VIEW_LOCATION: 'Ver ubicación',
},
},
      SITE_CARD: {
        HEADER: {
          SUBTITLE: {
            NO_DATA: '--',
},
          INFO: {
            DEVICE: '{{count}} Dispositivo',
            DEVICE_plural: '{{count}} dispositivos',
            DEVICE_noData: '0 dispositivos',
},
},
        BODY: {
          ONLINE_noData: '--\'',
          ALARMS: 'Alarma {{count}}',
          ALARMS_plural: '{{count}} Alarmas',
          EVENTS: '{{count}} Event',
          EVENTS_plural: '{{count}} Eventos',
          ALARMS_noData: '0 Alarmas',
          EVENTS_noData: '0 eventos',
          OFFLINE: 'Desconectado',
          ONLINE: 'En línea',
},
        FOOTER: {
          VIEW_LOCATION: 'Ver sitio',
},
},
      TIMELINE_DETAILS: {
        ACKNOWLEDGED: 'ADMITIDO',
        OPEN: 'ACTIVO',
        CLOSED: 'CERRADO',
        EARLIER: 'Más temprano',
        FUTURE: 'Futuro',
        INACTIVE: 'INACTIVO',
        LAST_WEEK: 'La semana pasada',
        THIS_WEEK: 'Esta semana',
        TIMELINE: 'Cronología',
        TODAY: 'Hoy',
        UNACKNOWLEDGED: 'NO RECONOCIDO',
        YESTERDAY: 'Ayer',
},
      ADD_BUILDING: ' Añadir edificio a',
      AUTO_REDIRECT_BANNER: {
        ADD_LOCATION_BUTTON: 'Agregar ubicación',
        DISMISS: 'Despedir',
        MESSAGE: 'Has sido redirigido automáticamente a {{location}} ya que no tienes otras ubicaciones de nivel superior.',
},
      USERS_ADMIN: 'Administración',
      USERS_ADMIN_S: 'Administradores',
      ADMINS_TITLE: 'Administradores',
      SITE_DETAILS: {
        READING_CARDS: {
          ALARM: 'Alarma',
          BATTERY: 'Batería',
          FULL: 'Lleno',
          OFFLINE: 'Desconectado',
          ONLINE: 'En línea',
          PENDING: 'Pendiente',
          UNKNOWN: 'Desconocido',
          VIEW_ALL: 'Ver todo',
},
        ALL_DETAILS: 'Todos los detalles',
        ALL_DEVICES: 'Todos los dispositivos',
        TRENDS_CARD: {
          CHANNELS: 'Canales',
          DAY: 'Día',
          DAYS: 'Días',
          TITLE: 'Tendencias',
          TRENDVIEWER: 'Visor de tendencias',
          VIEW_ALL: 'Ver el visor de tendencias completo',
},
        DEVICES_CARD: {
          TITLE: 'Dispositivos',
          VIEW_ALL: 'Ver todos los dispositivos',
},
        TIMELINE_CARD: {
          TITLE: 'Cronología',
          VIEW_ALL_EVENTS: 'Ver todos los eventos',
},
},
      ALL_BUILDINGS_COUNT: 'Todos los edificios ({{count}})',
      ALL_LOCATIONS: 'Todas las ubicaciones',
      ALL_ORGANIZATION: 'Todas las organizaciones',
      ALL_DEVICES_COUNT: 'Todos los sistemas ({{count}})',
      ADMINS_AND: 'y',
      DASHBOARD_ASSETS_TITLE: 'Activos',
      STATUS_BLOCKED: 'Obstruido',
      STATUS_COUNT_BLOCKED: 'Bloqueado ({{count}})',
      BUILDING_CONTACT: 'Contacto del edificio',
      BUILDING_CONTACT_DETAILS_LABEL: 'Datos de contacto del edificio',
      CHOOSE_LOCATION: 'Elija la ubicación',
      CONTACT_MANAGER: ' Comuníquese con su administrador de cuenta o',
      ADD_ORGANIZATION: 'Crear organización',
      OVERVIEW_TITLE: 'Panel',
      DASHBOARD_TITLE: 'Panel',
      DEVICES_TITLE: 'Dispositivos',
      EARLIER: 'Más temprano',
      EDIT_CONTACT_BUTTON: 'Editar datos de contacto',
      BUILDING_DETAIL_EMAIL: 'Correo electrónico',
      STATUS_EMPTY: 'Vacío',
      STATUS_COUNT_EMPTY: 'Vacío ({{count}})',
      ERROR_LOADING_CHANNELS: 'Error al cargar canales',
      ERROR_LOADING_DATA: 'Error al cargar datos',
      ERROR_LOADING_DEVICES: 'Error al cargar dispositivos',
      ERROR_LOADING_EVENT: 'Error al cargar el evento',
      ERROR_LOADING_EVENTS: 'Error al cargar eventos',
      ERROR_LOADING_LOCATION: 'Error al cargar la ubicación',
      ERROR_LOADING_LOCATIONS: 'Error al cargar ubicaciones',
      ERROR_LOADING_ORGANIZATION: 'Error al cargar la organización',
      ERROR_LOADING_SITE: 'Error al cargar el sitio',
      ERROR_LOADING_SITES: 'Error al cargar sitios',
      ERROR_LOADING_TRENDS: 'Error al cargar tendencias',
      EVENT_NOT_FOUND: 'Evento no encontrado',
      STATUS_ANOMALY: 'En Anomalía',
      STATUS_COUNT_ANOMALY: 'En Anomalía ({{count}})',
      LAST_90_DAYS: 'Últimos 90 días',
      LATEST_LOGS: 'Últimos registros',
      LOCATION_NOT_FOUND: 'Ubicación no encontrada',
      LOCATIONS_TITLE: 'Ubicaciones',
      LOCATION: 'Ubicaciones',
      DASHBOARD_LOGBOOK_TITLE: 'Cuaderno',
      MAIN_CONTACT_LABEL: 'Contacto del edificio principal',
      ADMINS_MORE: 'más',
      DASHBOARD_MANAGE_ORGANIZATION_TITLE: 'Mis organizaciones',
      NO_FOUND: 'No se encontró ninguna {{entidad}}',
      NO_EVENTS: 'Sin alarmas',
      NO_CHANNELS: 'Sin canales',
      NO_CHANNELS_ENABLED: 'No hay canales habilitados',
      NO_DATA: 'Sin datos',
      NO_DATA_POINTS: 'No hay datos para el rango de fechas especificado',
      NO_DEVICES: 'Sin dispositivos',
      NO_LOCATION_SELECTED: 'No se ha seleccionado ninguna ubicación',
      NO_LOCATIONS: 'Sin ubicaciones',
      NO_ORGANIZATION_SELECTED: 'No se ha seleccionado ninguna organización',
      NO_SITES: 'Sin sitios',
      NO_TRENDS: 'Sin tendencias',
      NO_USER_DATA: 'Sin datos de usuario',
      STATUS_COUNT_OFFLINE: 'SIN CONEXIÓN ({{count}})',
      ORGANIZATION_TITLE: 'ORGANIZACIÓN',
      ORGANIZATION_NOT_FOUND: 'Organización no encontrada',
      ORGANIZATION: 'Organizaciones',
      BUILDING_DETAIL_PHONE: 'Teléfono',
      PLATFORM_USER_DASHBOARD_WARNING: 'Acceda a la aplicación web para explorar todas sus funcionalidades.',
      PROJECT: 'PROYECTO',
      STATUS_READY: 'Listo',
      STATUS_COUNT_READY: 'Listo ({{count}})',
      DASHBOARD_REPORTS_TITLE: 'Informes',
      SAVE_USER_DETAILS: 'Guardar detalles del usuario',
      SECONDARY_CONTACT_LABEL: 'Contacto del edificio secundario',
      SITE_NOT_FOUND: 'Sitio no encontrado',
      SITE: 'sitios',
      TIMELINE_TITLE: 'Cronología',
      NEW_SITE: 'para unirse o crear una nueva {{entidad}}.',
      UNKNOWN_DEVICE_TYPE: 'Desconocido',
      EDIT_USER_DETAILS: 'Detalles del usuario',
      USERS_TITLE: 'Usuarios',
      VIEW_LOGBOOK: 'Ver el libro de registro',
      USERS_VIEWER: 'Espectador',
      USERS_VIEWER_S: 'Espectador',
      NOT_ACCESS: 'Aún no tienes acceso a ninguna {{entity}}.',
      STARRED_ORGANIZATIONS: 'Mostrar solo organizaciones destacadas',
},
    EVENT_DETAILS: {
      UNKNOWN: '--',
      ACKNOWLEDGE: 'Reconocer',
      ACKNOWLEDGED: 'Admitido',
      ACKNOWLEDGE_BY: ' Reconocido por {{user}} en',
      ACKNOWLWEGED_ERROR: ' No se pudo comunicar el acuse de recibo con el dispositivo final el {{errorDate}}. Si el problema persiste, llame a nuestro equipo de soporte al {{phoneno}} o envíe un correo electrónico',
      DEVICE_MODEL: 'Modelo del dispositivo',
      DEVICE_SERIAL: 'Número de serie del dispositivo',
      ERROR_LOADING_DEVICE_DETAILS: 'Error al cargar los detalles del dispositivo',
      ERROR_LOADING_EVENT_DETAILS: 'Error al cargar detalles del evento',
      TITLE: 'Detalles del evento',
      ALARM_STATUS: 'Estado de alarma inicial',
      LAST_DATA_RECEIVED: 'Última actualización de alarma recibida',
      NO_DEVICE_DETAILS: 'Sin detalles del dispositivo',
      NO_EVENT_DETAILS: 'No hay detalles del evento',
      PLEASE_RETRY: ' Por favor, vuelva a intentarlo:',
      SENDING: 'Envío…',
      SET_POINT: 'Punto de ajuste (umbral)',
      THRESHOLD: 'Límite',
      TIME_ALARM_SENT: 'Hora de envío de la alarma inicial',
},
    DEVICE_DETAILS: {
      EMPTY_VALUE: '--\'',
      USERS_ADMINS: 'admin',
      USERS_VIEWER: 'espectador',
      FIRMWARE_AVAILABLE_GUIDE_LINK: '(Guía)',
      USERS_COUNTS: '{{adminCount}} administrador, {{viewerCount}} espectador',
      FIRMWARE_AVAILABLE_GUIDE: '{{availableVersion}} Disponible',
      LUMINARY_ATSD: 'ATSD #',
      CONNECTION_TYPE_BLE: 'BLE',
      BLOCK: 'Obstruido',
      BUILDING: 'Edificio',
      CONNECTION_TYPE_CELLULAR: 'Celular',
      LUMINARY_CIRCUIT: 'Circuito',
      LUMINARY_CIRCUIT_HASH: 'Circuito #',
      CITY: 'Ciudad',
      CONNECTED: 'Conectado',
      CONNECTION_TYPE: 'Tipo de conexión',
      DATE_COMMISSIONED: 'Fecha de puesta en servicio',
      DEVICE_MODEL: 'Modelo del dispositivo',
      DEVICE_SERIAL: 'Número de serie del dispositivo',
      DURATION_TEST: ' Prueba de duración',
      DURATION_TEST_DURATION: 'Duración de la prueba Duración',
      ERROR: 'Error',
      CHANNEL_DATA_ERROR: 'Error al cargar los datos del canal',
      DEVICE_CONNECTION_ERROR: 'Error al cargar datos de conexión',
      DEVICE_DETAILS_ERROR: 'Error al cargar los detalles del dispositivo',
      CONNECTION_TYPE_ETHERNET: 'Ethernet',
      EVENT: 'Evento',
      FIRMWARE_VERSION: 'Versión de firmware',
      FUNCTIONAL_TEST: 'Prueba funcional',
      DELAY_FUNCTIONAL_TEST: 'Retraso de la prueba funcional',
      GATEWAY_ADDRESS: 'Dirección de gateway',
      GATEWAY_NAME: 'Nombre de la gateway',
      GATEWAY_COUNT: 'gateway del sistema {{systemCount}}',
      GATEWAY_COUNT_SYSTEMS: 'gateway de {{systemCount}} sistemas',
      GATEWAYS: 'gateway',
      HOSTNAME: 'Nombre de host',
      LUMINARY_DETAIL_INFO: 'Información',
      IPADDRESS: 'Dirección IP',
      LAST_DATA: 'Últimos datos',
      LUMINAIRE: 'Luminaria',
      LUMINARY_ADDRESS: 'Dirección de la luminaria',
      LUMINAIRES: 'Luminarias',
      LUMINARIES_COUNTS: 'Luminarias',
      MAC_ADDRESS: 'Dirección MAC',
      CONNECTION_TYPE_MODBUS: 'Modbus',
      LUMINARY_MODEL: 'Modelo',
      CONNECTION_TYPE_MQTT: 'MQTT',
      LUMINARY_NAME: 'Nombre',
      NAME: 'Nombre',
      NETWORK_DETAILS: 'Detalles de la red',
      NEXT: 'Próximo',
      LUMINARY_DISCRIPTION: 'Comienza la próxima prueba de duración',
      NEXT_DURATION_TEST: 'Comienza la próxima prueba de duración',
      NEXT_FUNCTIONAL_TEST: 'Comienza la próxima prueba funcional',
      NO_CHANNEL_DATA: 'No hay datos del canal',
      NO_DEVICE_CONNECTION: 'No hay datos de conexión del dispositivo',
      NO_DEVICE_DETAILS: 'No hay datos de detalles del dispositivo',
      OFFLINE: 'Desconectado',
      ONLINE: 'En línea',
      ORGANIZATION: 'Organización',
      PART_NUMBER: 'Número de pieza',
      PREVIOUS: 'Anterior',
      PREVIOUS_DURATION_TEST: 'Prueba de duración anterior iniciada',
      PREVIOUS_FUNCTIONAL_TEST: 'Prueba funcional anterior iniciada',
      READY: 'Listo',
      CONNECTION_TYPE_RS485: 'RS485',
      SERIAL_NUMBER: 'Número de serie',
      GATEWAY_SHOW_ALL: 'Mostrar todo',
      STATUS: 'Estado',
      LUMINARY_STATUS: 'Estado',
      SUBNET_MASK: 'Máscara de subred',
      SYSTEM: 'SISTEMA',
      SYSTEMS: 'Sistemas',
      LUMINARY_DETAIL_TEST: 'Pruebas',
      TYPE: 'Tipo',
      LUMINARY_TYPE: 'Tipo',
      UPDATE_REQUIRED: 'ACTUALIZACIÓN REQUERIDA',
      USERS: 'Usuarios',
      WARNING: 'Advertencia',
      CONNECTION_TYPE_WIFI: 'Wi-Fi',
      CONNECTION_TYPE_WIREPASS: 'Pasador de alambre',
      UNASSIGNED: 'Sin asignar',
},
    FORMS: {
      OPTIONAL: '(Opcional)',
      BUILDING_COMPANY_ADDRESS: 'Dirección Línea 1',
      BUILDING_COMPANY_ADDRESS2: 'Línea de dirección 2 (opcional)',
      BUILDING_DETAILS: 'Detalles del edificio',
      CITY: 'Ciudad',
      USER_ADDRESS_1: 'Dirección de la empresa, línea 1',
      USER_ADDRESS_2: 'Dirección de la empresa, línea 2',
      COMPANY_NAME: 'nombre de empresa',
      CONFIRM_PASSWORD: 'confirmar Contraseña',
      COUNTRY: 'País *',
      HELPING_TEXT: 'Los campos con un asterisco (*) son obligatorios',
      FIRST_NAME: 'Nombre de pila',
      LAST_NAME: 'Apellido',
      LOCAL_PRIMARY_EMAIL: 'Dirección de correo electrónico del contacto principal local',
      LOCAL_PRIMARY_CONTACT_INFO: ' Información de contacto principal local',
      LOCAL_SECONDARY_EMAIL: 'Dirección de correo electrónico de contacto local secundario',
      LOCAL_SECONDARY_CONTACT_INFO: ' Información de contacto secundaria local',
      ORGANIZATION_ADDRESS_HEADER: 'Dirección de la organización',
      COMPANY_ADDRESS: 'Dirección de la organización Línea 1',
      ADDRESS_LINE_2: 'Dirección de la organización Línea 2',
      ORGANIZATION_DETAILS_HEADER: 'Detalles de la organización',
      PASSWORD: 'Contraseña',
      PASS_MATCH_ERROR: 'Las contraseñas no coinciden',
      PHONE_NUMBER: 'Número de teléfono',
      INVALID_CUSTOMER_NUMBER: 'Proporcione un número de cliente válido',
      INVALID_EMAIL_ERROR: 'Proporcione una dirección de correo electrónico válida',
      INVALID_DETAILS: 'Proporcione parámetros de entrada válidos',
      INVALID_PHONE_NUMBER: 'Por favor proporcione un número de teléfono válido',
      INVALID_POSTAL_CODE: 'Por favor proporcione un código postal válido',
      INVALID_SLA_NUMBER: 'Proporcione un número de SLA válido de al menos 8 caracteres',
      POSTAL_CODE: 'Código Postal',
      PRIMARY_CONTACT_INFORMATION: 'Información de contacto principal',
      RESET_PASSWORD: 'Restablecer contraseña',
      TOGGLE_PASSWORD_VISIBILITY: 'Activar o desactivar la visibilidad de la contraseña',
      VERIFICATION_CODE: 'Código de verificación',
},
    DUALSMART: {
      DS_LUMINARIES_FOUND: 'Luminarias encontradas',
      DS_CIRCUIT_READY: 'Circuito listo',
      DS_COMMUNICATION_FAILURE: 'Fallo de comunicación',
      DS_DIMM_ERROR: 'Error de DIMM',
      DS_OVERCURRENT: 'Sobrecorriente',
      DS_SAVE_UPDATE_BUTTON: ' Guardar Actualizar',
      DS_SYNC_DATE_AND_TIME: 'Programación de pruebas de sincronización',
      DS_CONNECTED_POWER_INFO: '10 W/15 VA',
      DS_SYSTEM_COMPONENTS_COUNT: '7 componentes',
      DS_LUMINARIES_FOUND_TITLE: 'En este sistema se encontraron luminarias.',
      DS_AE_ERROR: 'Error de Ae',
      DS_ALL_STATUSES: 'Todos los estados',
      DS_ALL_TESTS_PASSED: 'Todas las pruebas pasaron',
      DS_ESTIMED_GUIDELINE_ONE: 'Aproximadamente 10 años a 20 °C',
      DS_ESTIMED_GUIDELINE_THREE: 'Aproximadamente 5 años a 30 °C',
      DS_ESTIMED_GUIDELINE_TWO: 'Aproximadamente 7 años a 25 °C',
      DS_BATTERY_CHARGER: 'Batería / Cargador',
      DS_BATTERY_CHARGE: 'Carga de la batería',
      DS_BATTERY_OPERATION: 'Funcionamiento con batería',
      DS_BLOCK_DEVICE: 'Dispositivo de bloqueo',
      DS_BLOCK_DEVICE_INFO: 'Dispositivo de bloqueo Bloquea la función de emergencia y apaga el circuito.',
      DS_BLOCK_SUCCESS: 'El bloqueo se realizó con éxito',
      DS_BULB_ERROR_AC: 'Error de bombilla CA',
      DS_BULB_ERROR_DC: 'Error de bombilla CC',
      DS_CAPACITY: 'Capacidad',
      DS_CHARGER_LEVEL: 'Nivel de carga:',
      DS_CHARGING_ERROR: 'Error de carga',
      DS_FUNCTIONAL_GUIDELINE: 'Elija un tiempo entre 20 y 800 segundos para que el sistema se comunique cuando cambie al funcionamiento con batería para realizar una prueba.',
      DS_CIRCUIT: 'Circuito',
      DS_CIRCUIT_FAILURE: 'Fallo del circuito',
      DS_CIRCUITS_INFO_HEADER: 'Información del circuito:',
      DS_CIRCUITS_NO: 'Circuito No.',
      DS_CIRCUITS: 'Circuitos',
      DS_COMPONENTS_DETAIL: 'Detalles del componente',
      DS_CONNECTED_POWER: 'Energía conectada:',
      DS_CRYSTALWAY: 'Camino de cristal 20m',
      DS_DAYS_BETWEEN_THE_TEST: 'Días entre pruebas',
      DS_DC1: ' DC 1',
      DS_DC2: 'DC2',
      DS_KEEP_DEEP_DISCHARGE: 'Protección activa contra descarga profunda',
      DS_DELAY_ON_MAINS_RETURN: 'Retraso en el retorno a la red eléctrica',
      DS_ESTIMED_GUIDELINE: 'Dependiendo de la temperatura ambiente y las condiciones del sitio:',
      DS_DESCRIPTION: 'Descripción',
      DS_END_DURATION_TEST_POPUP: '¿Quieres detener la prueba de duración?',
      DS_DOUBLE_ADDRESS: 'Doble dirección',
      DS_DT_FORERUN: 'DT antes de la carrera',
      DS_DEVICE_COMMISSIONING: 'Puesta en servicio inteligente dual',
      DS_PASSWORD: 'Contraseña inteligente dual',
      DS_DURATION: 'Duración',
      DS_DURATION_TEST: 'Prueba de duración',
      DS_DURATION_TEST_SCHEDULE: 'Duración del programa de pruebas',
      DS_EDIT_BATTERY_DETAILS: 'Editar detalles de la batería',
      DS_DASH_EMPTY: 'Vacío',
      DS_ESTIMED_LIFESPAN: 'Esperanza de vida estimada',
      DS_EXIT_SIGN: 'Señal de salida',
      DS_FAN_OPERATING_HOURS: 'Horas de funcionamiento del ventilador',
      DS_FOUND: 'Encontró',
      DS_FT_FORERUN: 'Previa a la carrera del FT',
      DS_FUNCTIONAL: 'Funcional',
      DS_FUNCTIONAL_LEAD_AND_TIME: 'Plazo de ejecución funcional',
      DS_FUNCTION_TEST: 'Prueba funcional',
      DS_FUNCTIONAL_TEST_SCHEDULE: 'Programa de pruebas funcionales',
      DS_SYNC_DATE_AND_TIME_SUBTITLE: 'Oficina principal de “G-North”',
      DS_CIRCUITS_DESCRIPTION: 'Ayúdame con la descripción',
      DS_SEARCH_LUM_INFO_TEXT: ' Si solo necesita agregar luminarias, utilice la opción Buscar nuevas luminarias',
      DS_SEARCH_LUMS_POPUP_SUB_TITLE: 'Si solo necesita agregar nuevas luminarias, utilice la opción Buscar nuevas luminarias.',
      DS_INSTALLATION_DATE: 'Fecha de instalación',
      DS_INTERVAL: 'Intervalo',
      DS_CIRCUITS_INFO: 'Se necesita clave. ¡Área restringida! Es necesario registrarse.',
      DS_LAST_DURATION_TEST_TIME: 'Última prueba de duración',
      DS_LIGHTANDBUILDING: 'Luz y Construcción 2024',
      DS_LUMINAIRE_FAILURE: 'Fallo de luminaria',
      DS_LUMINAIRE_NAME: 'Nombre de la luminaria',
      DS_LUMINARIES: 'luminarias',
      DS_MAINS_OPERATION: 'Funcionamiento de la red eléctrica',
      DS_NEXT_TEST_DATE: 'Próxima fecha de examen',
      DS_NO_OPERATION_POSSIBLE: 'No es posible ninguna operación',
      DS_NORMAL_OPERATION: 'Funcionamiento normal',
      DS_OPERATION_FAILED: 'Operación fallida',
      DS_OVERTEMPERATURE: 'Sobretemperatura',
      DS_OVERVOLTAGE: 'Sobrevoltaje',
      DS_PREV: 'Anterior',
      DS_READY_ON: 'Listo para empezar',
      DS_RELEASE_DEVICE: 'Dispositivo de liberación',
      DS_RELEASE_DEVICE_INFO: 'El dispositivo de liberación vuelve al funcionamiento.',
      DS_RELASE_SUCCESS: 'La liberación se realizó con éxito',
      DS_SEARCH_LUM_WARNING_TEXT: 'Recuperando datos. Espere unos segundos e intente cortar o copiar nuevamente.',
      DS_CIRCUIT_LUMINARIES_DESC: 'Recuperando datos. Espere unos segundos e intente cortar o copiar nuevamente.',
      DS_SEARCH_COMPLETE: 'Búsqueda completa',
      DS_SEARCH_GUIDLINE_ONE_TEXT: 'Busque todas las luminarias instaladas y direccionadas',
      DS_SEARCH_ALL_LUMINARIES: 'Buscar todas las luminarias',
      DS_SEARCH_LUM_TEXT: 'Buscar todas las luminarias creará una nueva configuración haciendo lo siguiente:',
      DS_SEARCH_LUMS_POPUP_TITLE: 'Al iniciar la búsqueda se eliminarán de su configuración todas las luminarias activadas que presenten un defecto.',
      DS_SEARCH_GUIDLINE_TWO_TEXT: 'Al iniciar la búsqueda se eliminarán de su configuración todas las luminarias defectuosas y activadas.',
      DS_STARTS: 'Comienza',
      DS_SUMMARY_FT: 'Resumen de la prueba de función',
      DS_SYSTEM_COMPONENTS: 'Componentes del sistema',
      DS_SYNC_DATE_AND_TIME_TITLE: 'Fechas y horarios de los exámenes',
      DS_TEST_INTERVAL: 'Intervalo de prueba',
      DS_TEST_LENGTH: 'Duración de la prueba',
      DS_VIEW_CIRCUITS: 'Ver por circuito',
      DS_W: 'Yo:',
      DS_SEARCH_FOR_NEW_LUMINARIES: 'Búsqueda de nuevas luminarias',
      DS_SEARCH_LUM_NEW_TEXT: 'Busque nuevas luminarias para agregar a su configuración de iluminación:',
      DS_SEARCH_NEW_LUM_GUIDLINE_ONE_TEXT: 'Esto asignará automáticamente direcciones a luminarias nuevas o reemplazadas en su configuración de iluminación.',
      DS_SEARCH_NEW_LUM_INFO_TEXT: 'Si solo necesita agregar luminarias, utilice la opción Buscar nuevas luminarias',
      DS_NEW: 'Nuevo',
      DS_MODULE_TYPE: 'Tipo de módulo',
      DS_SEARCH_IO_MODULES: 'Buscar módulos I-Bus',
      DS_SEARCH_FOR_IO_MODULES: 'Búsqueda de módulos IO',
      DS_SEARCH_IO_MODULES_TEXT: 'Busque módulos IO y cree una nueva configuración haciendo lo siguiente:',
      DS_SEARCH_GUIDELINE_IO_MODULES_TEXT: 'Busca todos los módulos instalados en el bus para configurarlos y programarlos.',
      DS_SEARCH_IO_MODULES_BTN_TEXT: 'Búsqueda de módulos IO',
      DS_SEARCH_IO_MODULES_POPUP_TITLE: 'Si los módulos no están conectados correctamente, alterará permanentemente la configuración aplicada.',
      DS_SEARCH_IO_MODULES_POPUP_SUB_TITLE: 'Asegúrese de que todas las conexiones sean correctas antes de comenzar la búsqueda.',
      DS_PHYSICAL_MODULES: 'Módulos físicos',
      DS_SUBSCRIBED_MODULES: 'Suscrito',
      DS_MODULES_FOUND: 'Módulos encontrados',
      DS_MODULE_NUMBER: 'Módulo No.',
      DS_SEARCHING: 'Búsqueda...',
      DS_TIMER: 'Minutero',
      DS_SET_TIMER: 'Establecer temporizador',
      DS_SUBMIT_CHANGES: 'Enviar cambios',
      DS_TIMER_1: 'Temporizador 1',
      DS_TIMER_2: 'Temporizador 2',
      DS_TIME_TITLE: 'Título del temporizador (opcional)',
      DS_DAYS: 'Días de la semana y hora',
      DS_ACTIVE_DAYS: 'Seleccione los días de la semana en que desea que ___ esté activo.',
      DS_START_TIME: 'Hora de inicio',
      DS_END_TIME: 'Fin del tiempo',
      DS_SET_RELAY_BUZZER: 'Establecer el zumbador del relé',
      DS_RESET_TO_DEFAULT_VALUES: 'Restablecer valores predeterminados',
      DS_RESET_TO_DEFAULT_VALUES_INFO: 'Seleccione la salida a la que desea asignarle funciones. Pulse “Guardar” cuando haya terminado.',
      DS_SEARCH_NEW_LUMINARIES_INFO: 'Utilice estos resultados para crear y compartir una nueva configuración de iluminación mediante “Exportar”.',
      DS_RELAY_NO: 'Relé No.',
      DS_RESET_RELAY_BUZZER_POPUP_TITLE: 'Por favor confirme',
      DS_RESET_RELAY_ONE_TO_DEFAULT: 'Restablecer el relé 1 a los valores predeterminados',
      DS_RESET_RELAY_BUZZER_TO_DEFAULT: 'Restablecer relés y zumbador a valores predeterminados',
      DS_UNSAVED_CHANGES_POPUP_TITLE: 'Hay cambios sin guardar',
      DS_UNSAVED_CHANGES_POPUP_SUB_TITLE: 'No has guardado los cambios en el Relé 1. ¿Quieres guardarlos?',
      DS_DISCARED_CHANGES: 'Descartar cambios',
      DS_CIRCUIT_TITLE: 'Las luminarias que se encienden o apagan en esta ventana volverán a su estado configurado después de que el sistema complete su próxima operación de conmutación.',
      DS_EMPTY: 'Vacío / En fallo',
      LUM_TITLE: 'Toque las luminarias para encenderlas y apagarlas',
      ALL_OFF: 'Todo fuera',
      DS_RESET_TITLE: 'Restablecer a valores predeterminados',
      DS_CONTROL_LUM: 'Luminarias de control',
      DS_LUM_BUTTON: 'Encender/apagar luminarias',
      DS_APPLY: 'Aplicar',
      DS_SET_IO_BUS_MODULES_TITLE: 'Conjunto de módulos I-Bus',
      DS_NEXT_MODULE: 'Guardar y pasar al siguiente módulo',
      DS_MODULE_DETAILS: 'Detalles del módulo',
      DS_MODULE_NAME: 'Nombre del módulo',
      DS_LOCAL_ONLY: 'Solo local',
      DS_PUBLISH: 'Publicar',
      DS_SUBSCRIBE: 'Suscribir',
      DS_ACU_BUS_ID: 'Identificación del autobús ACU',
      DS_BUS_MODULE: 'Módulo de bus',
      DS_INPUTS: 'Entradas',
      DS_CONFIGURED_MODULE_TITLE: 'Actualmente no hay entradas de monitoreo de fase configuradas en este módulo.',
      DS_CONFIGURE_INPUTS: 'Configurar entradas',
      DS_BLOCK: 'Bloquear',
      DS_RELEASE: 'Liberar',
      DS_BLOCK_GUIDLINE: 'Esto bloquea la función de emergencia y apaga los circuitos.',
      DS_RUN_TESTS: 'Ejecutar pruebas',
      DS_LUMINARIE_CONTROLS: 'Controles de luminarias',
      DS_LUMINARIE_CONTROLS_GUIDELINE: 'Estas funciones le permiten anular la programación configurada de la luminaria hasta que se desactiven.',
      DS_ALL_LUMINARIES_ON: 'Todas las luminarias encendidas',
      DS_INACTIVE: 'Inactivo',
      DS_MAINTAINED_LUMINARIES_OFF: 'Luminarias mantenidas apagadas',
      DS_NON_MAINTAINED_LUMINARIES_OFF: 'Luminarias sin mantenimiento encendidas',
      DS_RESET_SYSTEM_STATE: 'Restablecer el estado del sistema',
      DS_MANUAL_RESET: 'Reinicio manual',
      DS_RESET_ISO_FAILURE: 'Error al restablecer la ISO',
      DS_RECHARGE_DEEP_DISCHARGE_PROTECTION: 'Restablecer la protección contra descarga profunda',
      DS_SIMULATE_MAINS_FAILURE: 'Simular fallo de red',
      DS_SEARCH_ISO_FAILURE: 'Error en la búsqueda de ISO',
      DS_SET_I_BUS_MODULES: 'Conjunto de módulos I-Bus',
      DS_COMMISSIONING: 'Puesta en servicio',
      DS_DATE_AND_TIME: 'Fecha y hora',
      DS_RESET_SERVICE_CENTER: 'Restablecer contador de servicios',
      DS_ALERT_LEVEL: 'Nivel de alerta',
      DS_DRY_CONTACT: 'Contacto seco',
      DS_BUILDING_MANAGMENT_SYSTEM: 'Sistema de gestión de edificios (BMS)',
      DS_MODBUS: 'Modbus',
      MANAGE_INTERNET_CONNECTION: 'Administrar la conexión a Internet',
      INTERNET_CONNECTION: 'Conexión a Internet',
      SUB_LOCATION: 'Sububicación',
      TIME_PERIOD_NINTY_DAYS: 'Cada 90 días',
      DS_SEARCH_ISO_FAILURE_TITLE: '¿Busca fallos de aislamiento?',
      DS_SEARCH_ISO_FAILURE_BODY: 'Presione “Buscar” para determinar los circuitos afectados si recibe un mensaje de fallo ISO.',
      DS_SEARCH: 'Buscar',
      DS_MAIN_FAILURE_MSG: 'Esto simulará el funcionamiento de CC y durará aproximadamente 5 segundos antes de volver al funcionamiento normal.',
      DS_START: 'Comenzar',
      DS_DEEP_DISCHARGE: 'Reconocimiento de protección contra descargas profundas',
      DS_DEEP_DISCHARGE_MSG: 'Al seleccionar “Reconocer”, usted está verificando que fue testigo de cómo las baterías del sistema entraron en un estado de descarga profunda.',
      DS_ACKNOWLEDGE: 'Reconocer',
      DS_RESET_ISO: '¿Error al restablecer el aislamiento?',
      DS_RESET_ISO_MSG: 'Esto restablecerá el mensaje de fallo de aislamiento.\n\nSi el error ISO vuelve a ocurrir y no se puede identificar ninguna causa después de verificar los circuitos finales, comuníquese con el departamento de servicio.',
      DS_RESET: 'Reiniciar',
      DS_MANUAL_RESET_TITLE: '¿Realizar reinicio manual?',
      DS_MANUAL_RESET_MSG: 'Todas las luminarias de seguridad volverán al funcionamiento normal según su programación.',
      DS_BLOCK_TITLE: '¿Bloquear el sistema y finalizar la prueba de duración?',
      DS_CONFIRM_BLOCK: 'Confirmar y bloquear',
      DS_BLOCK_TEXT: 'La batería necesitará al menos 24 horas para recargarse antes de realizar otra prueba de duración.',
      TRIGGERS: 'Desencadenantes',
      DEFAULT_TRIGGERS

   : 'Desencadenantes predeterminados',
      OPTIONAL_TRIGGERS: 'Desencadenantes opcionales',
      ADD_TRIGGER: 'Agregar disparador',
      SELECT_TRIGGERS: 'Seleccionar activadores',
      ASSIGN_TRIGGERS: 'Asignar activadores',
      SELECTED: 'Seleccionado',
      INSTALLED: 'Instalado',
      SCENARIO: 'Guión',
      LUMINARIES_COUNT: '10 de 10 Luminarias',
      DS_INPUT_OF_PHASE_MONITOR: 'Entrada de un monitor de fase',
      DS_CIRCUIT_TRIGGERS_SUCCESSFULLY_LINE: 'Los disparadores del circuito n.° 1 se configuraron correctamente.',
      DS_SET_OTHER_CIRCUIT_TRIGGERS: 'Establecer otros activadores de circuito',
      DS_ASSIGN_DEFAULT_TRIGGERS_GUIDELINE: 'Toque o arrastre sobre las luminarias para asignarlas a este disparador.',
      DS_ASSIGN_TRIGGERS_GUIDELINE_TWO: 'Por favor, confirme cada disparador del circuito 1.',
      DS_NON_MAINTAINED_LIGHT: 'Luz no mantenida',
      DS_MAINTAINED_LIGHT: 'Luz mantenida',
      DS_INSTALLED_LUMINARIES: 'Luminarias instaladas',
      DS_TIMER_SCHEDULE: 'Horario de días laborables',
      DS_DEEP_DISCHARGE_TITLE: 'Descarga profunda',
      DS_STIMULATE_MAIN_FAILURE: 'Estimular el fallo principal',
      DS_START_FUNCTIONAL_TEST: 'Iniciar prueba funcional',
      DS_SHORT_LEAD_TIME: 'Utilice un plazo de entrega corto',
      DS_ASSIGNED_PHASE_MONITORING_INPUT: 'Entradas de monitoreo de fase asignadas',
      DS_INPUT_CONFIGURATION_TITLE: 'Configuración de entrada',
      DS_ASSIGNED_FUNCTION: 'Función asignada',
      DS_PHASE_MONITORING_INPUT: 'Entradas de monitorización de fase L1/L2/L3',
      DS_RESET_OPTION: 'Opción de reinicio',
      DS_LENGTH_OF_TIME: 'Duración del tiempo (minutos)',
      DS_PHASE_MONITOR: ':Monitor de fase',
      NO_FUNCTION: 'Sin función',
      ALL_LUM_ON: 'Todas las luminarias encendidas',
      MANNUAL_RESET: 'Reinicio manual',
      INVERSE_SWWITCH: 'interruptor inverso',
      SWITCH_OFF_MAINTAINED_LIGHT: 'apagar la luz mantenida',
      ALL_LUMINARIES_ON: 'Todas las luminarias encendidas',
      VENTILATION_MONITORING: 'Monitoreo de la ventilación',
      EXT_MONITOR: 'Monitor externo',
      SWITCH: 'cambiar',
      DELAY_ON_MAINS_RETURN: 'Retraso en el retorno a la red eléctrica',
      VIA_THE_APP: 'A través de la aplicación',
      DS_INPUT_NAME: 'Nombre de entrada',
      DS_VALIDATION_TXT_MSG_FOR_SETIOBUS: 'Complete los campos obligatorios: nombre del módulo, tipo de configuración y entradas de configuración.',
      DS_VALIDATION_TXT_MSG_FOR_INPUT_CONFIG: 'Por favor, rellene los campos obligatorios: nombres de entrada, nombre de la fase, funciones asignadas, opción de reinicio y duración.',
      DS_SET_IO_MODULES_LIST_SUBTITLE: 'Se configuraron exitosamente 10 módulos.',
      DS_CONFIGURATION_TYPE_ERROR_MSG: 'El tipo de configuración no está seleccionado',
      DS_INPUT_NAME_ERROR_MSG: ' InputName está vacío en el índice',
      DS_ASSIGNED_FUCNTION_ERROR_MSG: 'AssignedFunctionValue está vacío en el índice',
      DS_PHASE_MONITORING_INPUT_NAME_ERROR_MSG: 'El nombre de entrada de monitoreo de fase está vacío.',
      DS_RESET_OPTION_ERROR_MSG: 'El valor de la opción Restablecer está vacío.',
       DS_LENGTH_OF_TIME_ERROR_MSG: 'El valor del período de tiempo está vacío.',
      SAVE_FAILED: 'Falló el guardado',
      MAINS_FAILURE: 'Fallo de red',
      DS_CONTINUOUSLY_OPERATIONAL: 'Operativo continuo',
      DS_WAITING_FOR_PSU_FAILURE: 'Esperando fallo de fuente de alimentación',
      DS_LUMINAIRE_ON: 'Luminaria encendida',
      DS_LUMINAIRE_OFF: 'Luminaria apagada',
      DS_DEFAULT: 'PREDETERMINADO',
      DS_CUSTOM_TRIGGERS: 'Disparadores personalizados',
      DS_INPUT_OF_IBUS_MODULE: 'Entrada de un módulo I-Bus',
      DS_EXIT_SIGNS_LUMINAIRES: 'Luminarias de señales de salida',
      DS_MANAGE_TRIGGERS: 'Administrar disparadores',
      DS_CUSTOM_TRIGGER_ADDRESS: 'Módulo n.° 3',
      DS_CUSTOM_TRIGGER_ADDRESS_1: '8 p. m., entrada n.° 2',
      DS_CUSTOM: 'PERSONALIZADO',
      SNTP_1: 'SNTP 1',
      SNTP_2: 'SNTP 2',
      SNTP_3: 'SNTP 3',
      SERVICE: 'Servicio',
      CONFIGURE_SNTP: 'Configurar SNTP',
      DS_SIMPLE_NETWORK_TIME_PROTOCOL: 'Protocolo simple de tiempo de red (SNTP)',
      DS_ENTER_VALID_SNTP_1_ADDRESS: 'Introduzca una dirección SNTP 1 válida',
      DS_ENTER_VALID_SNTP_2_ADDRESS: 'Introduzca una dirección SNTP 2 válida',
      DS_ENTER_VALID_SNTP_3_ADDRESS: 'Introduzca una dirección SNTP 3 válida',
      DS_ENABLED: 'Habilitado (recomendado)',
      DS_SET_SNTP: 'Configurar SNTP',
      FUNCTIONAL_TEST_RESULTS: 'Resultados de la prueba funcional',
      DURATION_TEST_COMPLETE: 'Prueba de duración completada',
      FUNCTIONAL_TEST_COMPLETE: 'Prueba funcional completada',
      DS_GNORTH_LPSMART: 'LP-Smart',
      DS_CREATE_CUSTOM_TRIGGER: 'Crear un disparador personalizado',
      DS_CONFIGURE_TRIGGERS: 'Configurar disparadores',
      DS_ASSIGN_CIRCUIT_TRIGGERS_TITLE: 'Asignar disparadores del circuito {{circuitNo}}',
      DS_ASSIGN_TRIGGERS_GUIDELINE_THREE: 'Desplácese hacia abajo para asignar los disparadores predefinidos a las luminarias haciendo clic en ellos.',
      DS_AVAILABLE: 'Disponible',
      DS_OCCUPIED: 'Ocupado',
      DS_DELETE_CUSTOM_TRIGGER: 'Eliminar disparador personalizado',
      DS_LBL_VA: 'VA',
      DS_LBL_W: 'W',
      DS_CIRCUIT_MONITORING_MODE_RESERVE: 'Reserva',
      DS_CIRCUIT_MONITORING_MODE_CG: 'CG',
      DS_CUSTOM_TRIGGER: 'Disparador personalizado',
      DS_CUSTOM_TRIGGER_SUB_TITLE: '¿Qué tipo de disparador necesita?',
      DS_CREATE_NEW_TRIGGER: 'Crear un nuevo disparador',
      DS_MANUALLY_CONFIGURE_TRIGGER: 'Configurar disparador manualmente',
      DS_COPY_EXISTING_TRIGGER: 'Copiar un disparador existente',
      DS_COPY_EXISTING_TRIGGER_SUB_TITLE: 'Importar y copiar disparadores de otro circuito',
      MODBUS_SET_COMMAND_FAIL: 'Error al establecer la configuración Modbus',
      MODBUS_GET_COMMAND_FAIL: 'Error al obtener la configuración Modbus',
      MODBUS_SETUP: 'Configuración BMS',
      BUILD_MANAGEMENT_SYSTEM: 'Sistema de gestión de edificios',
      GENERAL: 'General',
      ADVANCED: 'Avanzado',
      MODBUS_TCP_PORT: 'Puerto TCP Modbus',
      TCP_CONNECTION: 'Conexión TCP',
      MODBUS: {
        MODBUS_SETTINGS: 'Configuración Modbus',
        ADVANCED_SETTINGS_TITLE: 'Los comandos extendidos se implementarán a través de Modbus si se activan a continuación. Prueba de duración de inicio/parada',
        START_STOP_DURATION_TEST: 'Prueba de duración de inicio/parada',
        MANUAL_RESET: 'Reinicio manual',
        BLOCK_RELEASE: 'Bloqueo/liberación',
        RESET_DEEP_DISCHRGE_PROTECTION: 'Reinicio de la protección contra descarga profunda',
        ALL_LUMINARIES_ON: 'Estado de todas las luminarias encendidas/Estado de todas las luminarias en conmutación',
        BMS_SWITCH: 'Conmutación BMS',
        MODBUS_TPC: 'Modbus TPC',
},
      DS_OPTIONAL_TRIGGER: 'Disparador opcional',
      DS_SELECT_TRIGGER_TYPE: 'Seleccione el tipo de disparador.',
      DS_SELECT_CORRECT_MODULE: 'Seleccione el módulo correcto.',
      DS_SELECT_PHASE_MONITORING_INPUT: 'Seleccione la entrada de monitorización de fase.',
      DS_INPUT_ELECTION: 'Elección de entrada',
      DS_INFO_OPTIONAL_TRIGGER: 'Las opciones avanzadas de disparador se pueden configurar en Ajustes generales.',
      DS_BMS_SWITCH: 'Interruptor BMS',
      DS_INPUT_SYSTEM: 'Entrada del sistema',
      DS_INPUT_PHASE_MONITOR: 'Entrada de un monitor de fase',
      GENERAL_SETTINGS: 'Ajustes generales',
      GENERAL_SETTINGS_LAUNCH_FT_TITLE: 'Iniciar prueba funcional tras la liberación de entrada',
      GENERAL_SETTINGS_LAUNCH_FT_SUBTITLE: 'El sistema realizará una prueba funcional una vez liberada.',
      GENERAL_SETTINGS_SHUTDOWN_ATSD_TITLE: 'Operación de emergencia segura',
      GENERAL_SETTINGS_SHUTDOWN_ATSD_SUBTITLE: 'Desactivar la operación de emergencia segura significa que las luces se encenderán mediante control de fase en caso de un corte de energía.',
      GENERAL_SETTINGS_ENABLED_DIM_TITLE: 'Habilitar valor de atenuación en la configuración del escenario',
      GENERAL_SETTINGS_ENABLED_DIM_SUBTITLE: 'Esto permite aplicar valores de atenuación en la configuración del disparador del circuito.',
      DS_BMS_SWITCHES: 'Conmutadores BMS',
      DS_SELECT_BMS_SWITCHES: 'Seleccione cualquier conmutador BMS configurado',
      DS_LBL_ENABLED: 'ACTIVADO',
      DS_LBL_DISABLED: 'DESACTIVADO',
      DS_INPUT_SELECTION: 'Selección de entrada',
      DS_INPUT_OF_SYSTEM: '“Entrada del sistema”',
      DS_PUBLISHED: 'PUBLICADO',
      DS_DEFAULT_INPUTS: 'Entradas predeterminadas',
      DS_OPTIONAL_INPUTS: 'Entradas opcionales',
      DS_SELECT_THE_TIMER: 'Por favor seleccione el temporizador',
      DS_DAYS_WEEK_SCHEDULE_ACTIVE: 'Días de la semana en que este horario está activo:',
      DS_3PM_5I: '3PM / 5-I',
      DS_8PM: '8 p. m.',
      DS_5DLS_3PM: '5DLS + 3PM',
      DS_Input_1_Floor_1: 'Entrada n.° 1',
      DS_Input_2_Floor_1: 'N° 2',
      DS_Input_Number: 'No.',
      DS_Input_4_Floor_3: 'Entrada n.º 4',
      DS_MANUAL_RESET_VIA_APP: 'Reinicio manual a través de la aplicación',
      DS_OPTIONAL_DESCRIPTION: 'Esta es la descripción opcional',
      DS_EXIT_SIGN_LUMINAIRES: 'Luminarias de señalización de salida',
      DS_SWITCH_1_CUSTOM_NAME: 'Interruptor 1.',
      DS_OPTIONAL_DESCRIPTION_1: 'Soy la descripción opcional',
      DS_S1_S2: 'S1 / S2',
      DS_BLOCK_SYSTEM_CUSTOM_NAME: 'Bloquear el sistema',
      DS_S3_S4: 'S3 / S4',
      DS_MAINS_FAILURE_CUSTOM_NAME: 'Faiure de la red eléctrica',
      DS_OPTIONAL_DESC: 'Descripción opcional',
      DS_INPUT_1_CUSTOM_NAME: 'Entrada n.° 1',
      DS_NOT_CONFIGURED: 'No configurado',
      DS_START_DT: 'Prueba de duración de inicio',
      DS_TIMER_TITLE: 'Título del temporizador',
      DS_TEMP_START_TIME: '7:40 a.m.',
      DS_TEMP_END_TIME: '21:00 horas.',
      DS_ORDERING_NUMBER: 'Número de pedido',
      CIRCUITS: 'circuitos',
      ZONES: 'zonas',
      LUMINARY_TOTAL: 'total de luminarias',
      DS_SEARCH_IBUS_MODULES_TEXT: 'Busque módulos I-Bus y cree una nueva configuración haciendo lo siguiente:',
      DS_DC_DC1: 'CC / CC1',
      DS_DC_DC2: 'CC / CC2',
      DS_I_BUS_MODULE: 'Módulo I-Bus',
      DS_NOT_INSTALLED: 'No instalado',
      DS_SET_MODULES: 'Conjunto de módulos',
      DS_INPUTS_RELAYS: 'Entradas y relés',
      DS_INPUTS_RELAYS_PAGE_TITLE: 'Entradas y relés del sistema',
      DS_RELAYS: 'Relés',
      DS_FUNCTIONS: 'Funciones',
      DS_FUNCTION: 'Función',
      DS_NO_FUNCTIONS_ASSIGNED: 'Sin funciones asignadas',
      DS_SUBSCRIBED: 'SUSCRITO',
      DS_ENERGIZED: 'Energizado',
      DS_DE_ENERGIZED: 'Desenergizado',
      DS_S1_S2_NOT_BLOCKED_DESC: 'Sistema no bloqueado sobre S1/S2',
      DS_S1_S2_BLOCKED_DESC: 'Sistema bloqueado sobre S1/S2',
      DS_S3_S4_MAINS_FAILURE_DESC: 'Se detectó un fallo de red S3/S4',
      DS_S3_S4_NO_MAINS_FAILURE_DESC: 'Sin fallo de red',
      CHANNEL: 'Canal',
      DS_CHANNEL_1_ERROR_MSG: 'El canal 1 está vacío.',
      DS_CHANNEL_2_ERROR_MSG: 'El canal 2 está vacío.',
      DS_SYSTEM_OPTIONAL_INPUT: 'Entrada opcional del sistema',
      DS_SWITCH_NUMBER: 'Interruptor N°',
      EXT_ISO: 'Monitor ISO externo',
      EXT_BATTERY: 'Monitor de batería externo',
      AE_SCENARIO_ACTIVE: 'Escenario AE activo',
      AE_FAILURE: 'Fallo de AE',
      DS_SET_SYSTEM_INPUTS_TITLE: 'Establecer entradas del sistema',
      DS_INFO_SET_SYSTEM_INPUTS: 'Toque “Configurar entradas” para editar o agregar funciones a las entradas del sistema.',
      DS_BLOCK_THE_SYSTEM: 'Bloquear el sistema',
      DS_MAINS_FAILURE: 'Fallo de red',
      DS_INPUT_NUMBER: 'Número de entrada',
      DS_MAINS_FAILURE_SETTINGS: 'Configuración de fallo de red',
      DS_EMERGENCY_SETTINGS_LABLE_S3_S4: 'Cambiar a operación de emergencia si un dispositivo conectado al bus CAN detecta una falla de energía a través de la entrada S3/S4.',
      DS_EMERGENCY_SETTINGS_LABLE_I_BUS_MODULE: 'Cambiar a operación de emergencia si un dispositivo conectado a CAN-bus detecta un fallo de energía a través de un módulo I-Bus.',
      DS_INFO_MAINS_FAILURE_SETTINGS: 'Establecer las causas de emergencia para escenarios de múltiples sistemas',
      DS_EMERGENCY_CAUSES: 'Causas de emergencia',
      DS_NEXT_INPUT: 'Siguiente entrada',
      DS_FINISH: 'Finalizar',
      DS_COMMUNICATION_METHOD: 'Método de comunicación',
      DS_DS_BUS_ID: 'Identificación del autobús Ds',
      DS_INPUT_ID: 'ID de entrada',
      DS_FUNCTION_LBL: 'Función:',
      DS_LENGTH_OF_TIME_LBL: 'Duración del tiempo',
      DS_MINUTE: 'Minuto',
      DS_MINUTES: 'Minutos',
      DS_NO_FUNCTION: 'Sin función',
      DS_VENTILATION_MONITORING: 'Monitoreo de la ventilación',
      DS_SWITCH_OFF_MAINTAINED_LIGHT: 'Apagar la luz mantenida',
      DS_RESET_DEEP_DISCHARGE: 'Restablecer descarga profunda',
      DS_EXT_ISO_MONITOR: 'Monitor ISO externo',
      DS_SWITCH_ON_NON_MAINTAINED_LIGHT: 'Encender luz no mantenida',
      DS_START_FT: 'Iniciar FT',
      DS_EXT_BATTERY_MONITOR: 'Monitor de batería externo',
      DS_ALL_LUMINAIRES_ON: 'Todas las luminarias encendidas',
      DS_SWITCH: 'Cambiar',
      DS_INVERSE_SWITCH: 'Interruptor inverso',
      DS_START_DURATION_TEST: 'Iniciar DT',
      DS_CANCEL_DT_FT: 'Cancelar DT/FT',
      DS_EXT_MONITOR: 'Monitor externo',
      DS_AE_SCENARIO_ACTIVE: 'Escenario AE activo',
      DS_AE_FAILURE: 'Fallo de AE',
      DS_INFO_CONFIGURE_INPUT: 'Toque para editar o agregar funciones a las entradas del sistema.',
      DS_SELECT_INPUT_FUNCTION: 'Seleccione la función de entrada.',
      DS_BLOCKING: 'Bloqueo',
      DS_ASSIGNED_INPUT_FUNCTIONS: 'Función de entrada asignada',
      DS_IDENTIFY_CONNECTED_LUMINARIES_ON: 'Identificar luminarias conectadas',
      DS_IDENTIFY_CONNECTED_LUMINARIES_OFF: 'Identificar luminarias conectadas desactivadas',
      DS_IDENTIFY_REGISTERED_LUMINARIES_ON: 'Identificar luminarias registradas en',
      DS_IDENTIFY_REGISTERED_LUMINARIES_OFF: 'Identificar luminarias registradas desactivadas',
      LIFECYCLE: 'Ciclo vital',
      COMPONENT: 'Componente',
      REPLACEMENT_COMPLETE: 'Reemplazo completo',
      NAME_TYPE: 'Nombre/Tipo',
      EXPIRATION_ESTIMATE: 'Estimación de vencimiento',
      ESTIMATE_OPERATION_TIME: 'Estimar el tiempo de operación',
      WARRANTY_CONTRACT_END: 'Fin de garantía/contrato',
      BATTERY_DETAILS: 'Detalles de la batería',
      CHARGER_DETAILS: 'Detalles del cargador',
      ESTIMATED_OPEARATION_TIME: 'Tiempo estimado de operación',
      EDIT_BATTERY_CAPACITY: 'Editar la capacidad de la batería',
      BATTERY_CAPACITY: 'Capacidad de la batería',
      DS_BMS_SWITCH_ENABLE: 'Habilitar interruptor BMS',
      VISIONGUARD: {
        VISIONGUARD: 'VisionGuard',
        VISIONGUARD_SETUP: 'Configuración de VisionGuard',
        MQTT_CONNECTION: 'Conexión MQTT',
        PARSING_ERROR: 'ERROR DE ANÁLISIS',
        DISABLED: 'DESACTIVADO',
        BROKER_CONNECTED: 'Broker conectado',
        CONNECTION_FAILED: 'Conexión fallida',
        BROKER_DISCONNECTED: 'Broker desconectado',
        EDIT_DETAILS: 'Editar detalles',
        LOGIN_FAILURE: 'Error de inicio de sesión',
},
      BROKER_URL: 'URL del corredor',
      PORT: 'Puerto',
      ENCRYPTION: 'Cifrado',
      ENCRYPTION_PROTOCOL: 'Protocolo de cifrado',
      TLS: 'TLS',
      STD: 'ETS',
      AUTHENTICATION: 'Autenticación',
      SYNCHRONIZATION: 'Sincronización',
      MAX_UPDATE_RATE: 'Frecuencia máxima de actualización (en segundos)',
      CLIENT_ID: 'ID de cliente',
      KEEP_ALIVE_TIME: 'Mantener vivo el tiempo (en segundos)',
      NORMAL_OPERATION: 'Operación normal',
      MAINS_EMERGENCY_OPERATION: 'Operación de emergencia de la red eléctrica',
      BATT_OPERATION: 'Operación Batt',
      MAINS_FAILURE_SUB: 'Sub falla de red',
      CHARGER_FAILURE: 'Falla del cargador',
      CIRCUIT_FAILURE: 'Fallo del circuito',
      LUM_FAILURE: 'Falla de Lum',
      DEEP_DISCHARGE: 'Descarga profunda',
      ISO_FAILURE: 'Falla de ISO',
      FT: 'PIE',
      BT: 'BT',
      BAHN: 'TREN',
      DEVICE_FAILURE: 'Fallo del dispositivo',
      USE_FOR_BUZZER: 'Uso para timbre',
      INVERT: 'INVERTIR',
      DS_DC_EDIT_BUTTON: 'Editar DC / Detalles de DC',
      DS_DC_INPUT_CURRENT: 'Corriente de entrada CC/CC',
      DS_SET_TEST_SCHEDULE: 'Establecer el cronograma de pruebas para',
      DS_DURATION_TESTS: 'Pruebas de duración.',
      DS_RATED_OPERATION_TIME: 'Tiempo de funcionamiento nominal',
      DS_TEST_LENGTH_CONFIG_LABEL_1: 'La duración de la prueba se puede configurar dentro del',
      DS_RELAIS_BUZZER_TOTAL_OPERATIONS_COUNT: 'de 16 seleccionados',
      DS_FUNCTIONAL_TESTS: 'Pruebas funcionales.',
      DS_ALL_LUMINARIES_OFF: 'Todas las luminarias apagadas',
      DS_TIMMER_VALUE: 'Temporizador {{id}}',
      DS_TIMER_STATUS_DISABLED: 'Estado del temporizador Deshabilitado',
      DS_ENABLE_TIMMER: 'Habilitar temporizador para establecer parámetros',
      BATT_CIRCUIT_ERROR: 'Falla del circuito de la batería',
      DS_FUNCTION_LEAD_TIME_VALIDATION: 'El valor debe estar entre 20 y 800',
      PLEASE_ENTER_VALID_NUMBER: 'Por favor ingrese un número válido',
      DS_DURATION_LEAD_TIME_VALIDATION: 'El valor debe estar entre 10 y 1000',
      DS_CG_MONITORING_MODE: 'Monitoreo CG',
      DS_UN_MONITORING_MODE: 'Sin supervisión',
      DS_BATTERY_RUNTIME: 'Autonomía selectiva de la batería en CC',
      DS_BUS_ID_SETTINGS: 'Configuración de ID de bus DS',
      DS_REMOVE_LUMINAIRE: 'Quitar luminaria',
      DS_REMOVE_LUMINAIRE_INFO: 'Esta luminaria deberá agregarse nuevamente mediante “Buscar nuevas luminarias” o mediante una lista blanca.',
      DS_REMOVE_LUMINAIRE_TITLE: '¿Quitar la luminaria permanentemente?',
      DS_ADDITIONALPASSWORDINSTRUCTION: 'Cree nuevas contraseñas para los usuarios con acceso de administrador y espectador.',
      DS_BATTERY: 'Batería',
      DS_MODULES: '10 módulos',
      DS_DC: 'CC/CC',
      DS_3PM_BUS: 'Módulos de bus I',
      DS_POWER_CONSUMPTION: 'Consumo de energía',
      DS_OPERATING_HOURS: 'Horario de atención',
      DS_MANUFACTURING_DATE: 'Fecha de fabricación',
      DS_SERIAL_NUMBER: 'Número de serie',
      SYSTEM_CONTROLS: 'Controles del sistema',
      DS_CIRCUIT_NAME: 'Nombre del circuito',
      DS_CIRCUIT_NUMBER: 'Número de circuito',
      DS_CIRCUIT_DESCRIPTION: 'Descripción del circuito',
      DS_CHARGING_VOLTAGE: 'Voltaje de carga',
      OPT_CHANNEL: 'Canal OPT',
      TLS_MODULE_NAME: '{{modelNumber}} (OPT {{modelNumber}}) canal {{inputNumber}}',
      DCRUNTIME: {
        BATT_DC_TIME_30S: '30 segundos',
        BATT_DC_TIME_1M: '1 minuto',
        BATT_DC_TIME_2M: '2 minutos',
        BATT_DC_TIME_5M: '5 minutos',
        BATT_DC_TIME_10M: '10 minutos',
        BATT_DC_TIME_15M: '15 minutos',
        BATT_DC_TIME_30M: '30 minutos',
        BATT_DC_TIME_1H: '1 hora',
        BATT_DC_TIME_1_5H: '1 hora 30 minutos',
        BATT_DC_TIME_2H: '2 horas',
        BATT_DC_TIME_3H: '3 horas',
        BATT_DC_TIME_8H: '8 horas',
        BATT_DC_TIME_PERMANENT: 'permanente (predeterminado)',
},
      DS_MONTH_BETWEEN_THE_TEST: 'Meses entre pruebas',
      DS_EDIT_BATTERY_CAPACITY: 'Editar la capacidad de la batería',
      DS_OPERATION_DETAILS: 'Detalles de la operación',
      DS_BATTERY_VOLTAGE: 'Voltaje',
      DS_BATTERY_CURRENT: 'Actual',
      DS_STATE: 'Estado',
      DS_SET_INPUT_CONFIG: {
        ASSIGNED_FUNCTION: {
          NO_FUNCTION: 'Sin función',
          ALL_LUM_ON: 'Todas las luminarias encendidas',
          MANNUAL_RESET: 'Reinicio manual',
          INVERSE_SWWITCH: 'interruptor inverso',
          SWITCH_OFF_MAINTAINED_LIGHT: 'apagar la luz mantenida',
          VENTILATION_MONITORING: 'monitorización de la ventilación',
          EXT_MONITOR: 'Monitor externo',
          SWITCH: 'cambiar',
          EXT_ISO: 'Monitor ISO externo',
          EXT_BATTERY: 'Monitor de batería externo',
          AE_SCENARIO_ACTIVE: 'Escenario AE activo',
          AE_FAILURE: 'Fallo de AE',
},
        RESET_OPTION: {
          MANNUAL_RESET: 'Reinicio manual',
          DELAY_ON_MAINS_RETURN: 'Retraso en el retorno a la red eléctrica',
          AUTOMATIC_RESET: 'Reinicio automático al volver a la red eléctrica',
},
        LENGTH_OF_TIME: {
          VIA_THE_APP: 'A través de la aplicación',
},
},
      DS_SEARCH_ALL_LUM_FAIL: 'La operación de búsqueda de todas las luminarias falló. \nPor favor, inténtelo de nuevo.',
      DS_SEARCH_NEW_LUM_FAIL: 'La búsqueda de nuevas luminarias falló. Inténtalo de nuevo.',
      DS_BATTERY_CHARGE_LEVEL: 'Nivel de carga',
      DS_DC_TEMPRATURE: 'Temperatura',
      DS_DC_OVERLOAD: 'Sobrecarga',
      DS_BUS_SUB_HEADER_TITLE: 'Listo - Operación normal',
      BUZZER: {
        NORMAL_OPERATION: 'Operación normal',
        MAINS_EMERGENCY_OPERATION: 'Operación de emergencia de la red eléctrica',
        BATT_OPERATION: 'Operación Batt',
        MAINS_FAILURE: 'Fallo de red',
        MAINS_FAILURE_SUB: 'Sub falla de red',
        CHARGER_FAILURE: 'Falla del cargador',
        CIRCUIT_FAILURE: 'Fallo del circuito',
        LUM_FAILURE: 'Falla de Lum',
        DEEP_DISCHARGE: 'Descarga profunda',
        ISO_FAILURE: 'Falla de ISO',
        FT: 'PIE',
        BT: 'BT',
        BAHN: 'TREN',
        DEVICE_FAILURE: 'Fallo del dispositivo',
        USE_FOR_BUZZER: 'Uso para timbre',
        INVERT: 'INVERTIR',
},
      DS_FUCTIONAL_TEST_TEXT: ' Duración estimada de la prueba: 00:02:00\n\n\' + \'Tiempo de entrega: Estándar\n',
      DS_SYSTEM_COMPONENT: 'Componente del sistema',
      DS_SYSTEM_MODULE_ADDRESS: 'Dirección del módulo',
      DS_SYSTEM_MODULE_INFO_TEXT: 'Texto informativo',
      DS_SYSTEM_MODULE_TYPE: 'Tipo',
      DS_SYSTEM_MODULE_INPUT_STATE: 'Estado de entrada',
      DS_SYSTEM_MODULE_INPUT_NAME: 'Nombre de entrada',
      DS_SYSTEM_MODULE_INPUT_FUNCTION: 'Función de entrada',
      DS_SYSTEM_MODULE_ACTIVE: '¿PUB o SUB activo?',
      DS_EDIT_MODULE_DETAILS: 'Editar detalles del módulo',
      DS_HARDWARE_REV: '¿Revolución de hardware?',
      DS_DC_HARDWARE_REV: 'Revisión de hardware',
      DS_VIEW_ALL_LUMINARIES: 'Ver todas las luminarias',
      DS_ALL_CIRCUITS: 'Todos los circuitos',
      DS_ESTIMED_GUIDELINE_UPDATED: '10 años, siempre que el sistema se opere en total cumplimiento con todos los requisitos y normas especificados, y que el mantenimiento del sistema de iluminación de emergencia sea realizado por personal cualificado. Esta información no constituye ninguna garantía.',
      DS_BUS_MODULE_INPUT: 'Entrada del módulo I-Bus',
      DS_GLOBAL: 'Global (a través de la aplicación, la pantalla o Visionguard)',
      RESET_SOURCE: 'Restablecer fuente',
      DS_SYSTEM_OPERATION_NOT_STARTED: '{{operation}} no se puede realizar debido al estado actual del sistema.',
      DS_SYSTEM_OPERATION_INTERRUPTED: '{{operation}} fue cancelada por otra fuente.',
      ENTER_VALID_CHARGE_VOLTAGE: 'Introduzca un voltaje de carga válido (26,5 - 29,0)',
      ENTER_VALID_CHARGE_C_RATE: 'Introduzca una tasa C de fin de carga válida (20 - 200)',
      ENTER_VALID_CUT_OFF_VOLTAGE: 'Introduzca un voltaje de corte válido (17,0 - 22,0)',
      ENTER_VALID_RECHARGE_THRESHOLD_VOLTAGE: 'Introduzca un voltaje de umbral de recarga válido (22,0 - 25,2)',
      ENTER_VALID_MAXIMUM_CHARGING_TIME: 'Introduzca un tiempo de carga máximo válido (12 - 24)',
      ENTER_VALID_MAXIMUM_STATE_OF_CHARGE: 'Introduzca un estado de carga máximo válido (80 - 100)',
      DS_FT_TEXT: '¿Quieres detener la prueba funcional?',
      DS_CIRCUIT_LUM_LIST: 'Lista de luminarias del circuito',
      DS_RELAY: 'Relé',
      DS_BUZZER: 'Zumbador',
      DS_RESET_RELAY_TO_DEFAULT: 'Restablecer el relé {{relayNo}} a los valores predeterminados',
      DS_RESET_BUZZER_TO_DEFAULT: 'Restablecer el timbre a los valores predeterminados',
      DS_STANDBY_OPERATION: 'Operación en espera',
      DS_EDIT_CIRCUIT_DETAILS: 'Editar detalles del circuito',
      DS_SERACH_NEW_CONTENT: 'Las luminarias configuradas permanecen y no se eliminarán.',
      DS_SEARCH_NEW_LUM_INFO_CONTENT: 'Si desea reconfigurar todas las luminarias, utilice la función “Buscar todas las luminarias”',
      DS_RESET_TAMPER_DETECTION_SUCCESS: 'La detección de manipulación se restableció correctamente',
      DS_RESET_TAMPER_DETECTION_FAILURE: 'Error al restablecer la detección de manipulación',
      DS_BUS_HEADER_TITLE: '3PM - I Autobús',
      DS_MAINS_FAILURE_WITH_CUSTOM_NAME: 'Fallo de red, \'Nombre personalizado\'',
      DS_INPUT_1_WITH_CUSTOM_NAME: 'Entrada 1, \'Nombre personalizado\'',
      DS_INPUT_2_WITH_CUSTOM_NAME: 'Entrada 2, \'Nombre personalizado\'',
      DS_DC_RUNTIME: 'Tiempo de ejecución de CC',
      DS_MONITORING_MODE: 'Modo de monitoreo',
      EMPTY: 'Vacío',
      DS_TOTAL_FAILURES: 'Fracasos totales',
      DS_BLOCKED: 'Obstruido',
      DS_DURATION_TEST_POPUP: '¿Duración de la prueba de inicio?',
      DS_DURATION_TEST_POPUP_SUBTITLE: 'Tiempo estimado, 01:00:00',
      DS_UNINSTALLED_MODULES: 'Desinstalado',
      DS_NAME: 'Nombre',
      DS_BATTERY_NAME: 'Batería de litio de 25,6 V',
      DS_SEARCH_ALL_TITLE: 'Crear una nueva configuración de iluminación',
      DS_SEARCH_ALL_SUBTITLE: 'Asegúrese de que todas las luminarias estén correctamente conectadas y realice la búsqueda. Las luminarias existentes se reemplazarán con los resultados de la búsqueda.',
      ADD_DELETE_LUMINAIRES: 'Agregar/Eliminar luminarias manualmente',
      ADD_DELETE_LUMINAIRES_INFO: 'Utilice “Editar circuito” para agregar o eliminar manualmente luminarias dentro de un circuito.',
      EDIT_CIRCUIT: 'Editar circuito',
},
    LOGBOOK_DETAILS: {
      LABEL_EVENT_AGO: 'atrás',
      PART_NUMBER: ' Nombre del usuario:',
      SERIAL_NUMBER: ' Número de serie:',
      ADD_COMMENTS: '+ Añadir comentarios...',
      REQUIRES_FIRMWARE_UPDATE: '1 REQUIERE ACTUALIZACIÓN DE FIRMWARE',
      ACKNOWLEDGE: 'Reconocer',
      ACKNOWLEDGED: 'Admitido',
      ACKNOWLEDGED_BY: 'Reconocido por',
      PREVIOUS_ACKNOWLEDGED_BY: ' Reconocido por:',
      ACTIVE: 'Activo',
      ACTIVE_ACKNOWLEDGED: 'Activo. Reconocido',
      AT: 'en',
      LABEL_CLOSED: 'cerrado',
      CLOSED: 'Cerrado',
      COMMENTS: 'Comentarios',
      DESCRIPTION: 'Descripción',
      DEVICE: 'Dispositivo',
      EDIT: 'Editar',
      EVENT: 'Evento',
      LABEL_EVENT_BEGAN : ' El evento comenzó:',
      LABEL_EVENT_CLOSE: ' Evento cerrado:',
      LOGBOOKDETAIL: 'Detalle del libro de registro',
      NO_PREVIOUS_LOG_TITLE: 'No hay ningún elemento de registro anterior en este sistema',
      PARTNO: ' Nombre del usuario:',
      PREVIOUS_LOG_ITEM: 'Elemento de registro anterior en este sistema',
      PREVIOUS_LOG_TITLE: 'Elemento de registro anterior en este sistema',
      SERIALNO: ' Número de serie:',
      STATUS: 'Estado',
      SYSTEM: 'Sistema',
      TIMESTAMP: 'Marca de tiempo',
      SYSTEM_TYPE : ' Tipo:',
},
    ORGANIZATION_MANAGE: {
      BUILDING_COUNT: 'Edificio',
      BUILDING_COUNT_S: 'Edificios',
      ORGANIZATION_MANAGE: 'Edificios',
      ADMIN_COUNT: ' Administrador de la organización',
      ADMIN_COUNT_S: 'Administradores de la organización',
      VIEWER_COUNT: 'Visor de la organización',
      VIEWER_COUNT_S: 'Visores de la organización',
      SYSTEM_COUNT: 'Sistema',
      SYSTEM_COUNT_S: 'Sistemas',
      ADD_NEW_BUILDING: '+ Agregar nuevo edificio',
      CREATE_ORGANIZATION: '+ Crear organización',
      ERROR_ADD_NEW_SYSTEM_ACTION: 'Agregar nuevos sistemas',
      ALL: 'Todo',
      SORT_TYPE_NAME: 'Alfabeto',
      SORT_TYPE_CITY: 'Ciudad',
      COMMENTS_HELPER: 'Comentarios para ayudar a los técnicos a llegar al sitio.',
      ORGANIZATION_NAME_HELPER: 'Solo letras, números, guiones bajos y guiones',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Marcar como fallido',
      ERROR_NO_BUILDING_FOUND: 'No se encontró ningún edificio',
      ERROR_NO_GATEWAY_FOUND: 'No se encontró ninguna gateway',
      ERROR_NO_LOGS_TITLE: 'No hay registros durante este período',
      ERROR_NO_LUMINARY_FOUND: 'No se encontraron luminarias',
      ERROR_NO_ORG_FOUND: 'No se encontró ninguna organización',
      ERROR_NO_REPORT_FOUND: 'No se encontraron informes',
      ERROR_NO_SYSTEM_FOUND: 'No se encontró ningún sistema',
      ERROR_NO_USER_FOUND: 'No se encontró ningún usuario',
      SORT_TYPE_NUMBER_OF_SYSTEMS: 'Número de sistemas',
      QUIT_EDIT_USER_DETAILS: 'Salir de editar',
      QUIT_TITLE: '¿Dejar de editar “{{orgName}}”?',
      ERROR_READ_INSTALLATION_MANUALS_ACTION: 'Leer los manuales de instalación',
      SEARCH: 'Buscar',
      SEARCH_BUILDINGS: 'Buscar',
      SEARCH_BUILDINGS_DASHBOARD: 'Buscar edificios',
      SEARCH_SYSTEM_DASHBOARD: 'Sistemas de búsqueda',
      SORT_BY_HEADER: 'ORDENAR POR',
      STARRED_ORGANIZATIONS: 'Organizaciones destacadas',
      VIEW_ORGANIZATION: 'Ver organización',
      ERROR_NO_DEVICE_TITLE: 'Aún no tienes activos en esta organización.',
      ERROR_NO_DEVICE_DESCRIPTION: 'Verá información sobre el estado de sus luces de emergencia una vez que comience a agregar activos (sistemas) a esta organización.',
      QUIT_MESSAGE: 'Los cambios no guardados se perderán.',
},
    ADD_BUILDING: {
      BLDG_ORG_CONTACT: 'Contactos',
      INVERTED_COMMAS_S: '\'s',
      BLDG_ORG_CONTACTS: 'Contactos de',
      BLDG_ADDITIONAL_DESC: 'Agregue comentarios adicionales opcionales para ayudar a su equipo de servicio',
      BLDG_ADD_DESCRIPTION: 'Descripciones adicionales',
      BLDG_ADDRESS: 'DIRECCIÓN',
      BLDG_CREATTION: 'Edificio creado',
      BUILD_CREATE_SUCESS: 'Edificio creado exitosamente',
      BLDG_HEADER: ' Crear un nuevo edificio para',
      BLDG_LOCATION_MESSAGE: 'Arrastre el mapa para colocar el marcador cerca de la ubicación del edificio. Esto ayudará a que los ingenieros de campo lleguen al lugar rápidamente en el futuro.',
      BLDG_EDIT_BTN: 'Editar datos de contacto',
      BLDG_NAMELENGTH: ' Ej., Oficina principal, Almacén',
      BLDG_INITILIZING_NETWORK: 'Inicializando red...',
      BLDG_INSIDE: 'adentro',
      BLDG_LOCAL_CONTACT: 'Contacto de construcción local',
      BLDG_CONTACT_TITLE: 'Datos de contacto del edificio local',
      BLDG_LOCATE_ON_MAP: 'Ubicar en un mapa en su lugar',
      BLDG_LOCATION: 'Ubicación',
      BLDG_ADDTIONAL_DETAILS: 'Ahora agreguemos algunos detalles adicionales para completar la configuración.',
      ORG_CREATE_SUCESS: 'Organización creada exitosamente',
      BLDG_ADDITION_ERROR: 'Por favor, introduzca una dirección válida.',
      BLDG_PRIMARYCONTACT: 'Contacto principal',
      BLDG_PRIMARY_LOCAL_CONTACT: 'Contacto local principal',
      BLDG_SECONDARYCONTACT: 'Contacto secundario (opcional)',
      BLDG_SECONDARY_LOCAL_CONTACT: 'Contacto local secundario',
      BLDG_NO_POSTAL_ADDRESS: 'Seleccione esta opción si no hay una dirección postal disponible',
      BLDG_CREATED_MESSAGE: 'Creado exitosamente',
      BLDG_ORGANIZATION_FOR: ' Utilice la organización',
      BLDG_ADD_CONTACT: '¿A quién deben contactar los electricistas sobre la "Oficina principal"?',
      SAVE_CHANGES_MSG: 'Sus cambios han sido guardados',
},
    USER_SETTINGS: {
       AUTOMATIC_LOGOUT_SUBTITLE: 'Deshabilitar la expiración automática de sesión de 15 minutos',
      ALARMS: '.',
      PHONE_NO_TEXT: 'Se requiere un número de móvil para recibir notificaciones por SMS.',
      ACCOUNT: 'Cuenta',
      ACCOUNT_CREATED_DATE: 'Cuenta creada',
      ADDRESS: 'DIRECCIÓN',
      ALARMS_TITLE: 'Alarmas',
      APPLICATION_THEME_COLOR: 'Color del tema de la aplicación',
      AUTOMATIC_LOGOUT: 'Cierre de sesión automático',
      UNITS_DESCRIPTION: 'Unidades imperiales británicas',
      BUILDING_NAME: 'Nombre del edificio',
      TIMEZONE_DESCRIPTION: 'Hora de Europa central (GMT-1:00)',
      CHANGE_PASSWORD: 'Cambiar la contraseña',
      COMPANY_ADDRESS: 'Dirección de la empresa',
      COMPANY_NAME: 'nombre de empresa',
      COMPANY_PHONE_NUMBER: 'Número de teléfono de la empresa',
      DATE_FORMAT: 'Formato de fecha',
      DATEFORMAT_DESCRIPTION: 'DD/MM/AAAA',
      DELETE_ACCOUNT: 'Eliminar cuenta',
      STATUS_UPDATES: 'El dispositivo está en modo de bloqueo, modo de emergencia, mantenimiento solicitado',
      AUTOMATIC_LOGOUT_TITLE: 'Deshabilitar el cierre de sesión automático',
      EMAIL: 'Dirección de correo electrónico',
      EMAIL_NOTIFICATION: 'Notificaciones por correo electrónico',
      TEXT_NOTIFICATION_TITLE: 'Habilitar notificaciones de texto (SMS)',
      ENABLED: 'Activado',
      TEXT_NOTIFICATION_BODY: 'La activación de las notificaciones por SMS puede generar cargos adicionales por mensajes de texto con su proveedor de servicios celulares. Estos cargos no están incluidos en el Acuerdo de servicio de Eaton.',
      LANGUAGE_DESCRIPTION: 'Inglés - Gran Bretaña',
      HEALTH_REPORT_TITLE: 'Informe de salud',
      LANGUAGE: 'Idioma',
      HEALTH_REPORT: 'Informes mensuales',
      PRODUCT_UPDATES: 'Nuevos lanzamientos, actualizaciones de firmware disponibles',
      NOTIFICATIONS_HEADER: 'Notificaciones',
      APP_THEME_DESCRIPTION: 'Tema del sistema operativo',
      ORGANIZATION: 'Organización',
      ORGANIZATION_NAME: 'Nombre de la organización',
      PASSWORD: 'Contraseña',
      PHONE_NUMBER: 'Número de teléfono',
      PREFERENCES_HEADER: 'Preferencias',
      PRODUCT_UPDATES_TITLE: 'Actualizaciones de productos',
      STATUS_UPDATES_TITLE: 'Actualizaciones de estado',
      TEXT_NOTIFICATION: 'Notificaciones de texto (SMS)',
      AUTOMATIC_LOGOUT_BODY: 'Esto anulará una función de seguridad estándar incluida en la aplicación para evitar el acceso a una sesión abandonada. Tenga en cuenta que el usuario será responsable de proteger el acceso no autorizado a este sistema y nunca debe dejar esta aplicación abierta sin supervisión.',
      TIME_ZONE: 'Huso horario',
      UNITS: 'Unidades',
      ORG_ADDRESS: 'Utilice la dirección de la organización',
      ORG_CONTACT_DETAILS: 'Utilice los datos de contacto de la organización',
      EDIT_USER_DETAILS: 'Detalles del usuario',
      NAME: 'Nombre de usuario',
      USER_NAME: 'Nombre de usuario',
      WARNING: 'ADVERTENCIA',
},
    EDITUSER: {
       PROMOTE_CONFIRMATION: 'Si esto fue lo que pretendía, envíe su cambio.',
      DEMOTE_CONFIRMATION: 'Si esto fue lo que pretendía, realice las modificaciones a continuación en la sección Rol/Ubicación de este formulario.',
      DEMOTE: 'Has cambiado el rol de este administrador de la organización. Si no era tu intención hacerlo, selecciona Cancelar.',
      PROMOTE: 'Ha ascendido a este usuario a administrador de la organización. Si no era su intención hacerlo, seleccione cancelar.',
},
    ADDUSER: {
      INVITEUSER: 'Invitar usuario',
      TITLE: 'Agregar usuario',
      ASTERIKSINFO: 'Los campos marcados con asterisco (*) son campos obligatorios necesarios para invitar a un usuario.',
      INVITESUCCESS: '¡Invitación exitosa!',
      SELECTROLE: 'Seleccione un rol para la(s) ubicación(es)',
      ACCOUNTCREATED: 'La invitación para crear una cuenta se ha iniciado con éxito.',
      EMAILRECEIVE: 'El usuario recibirá una invitación por correo electrónico para crear su cuenta en 5 a 10 minutos. No podrá ver su estado hasta que haya aceptado la invitación.',
      ADDUSERINFORMATION: 'Información del perfil de la cuenta del usuario',
},
    GATEWAY: {
      MANAGE_CELLULAR_CONNECTION: 'Administrar la conexión móvil',
      TRANSFER_SYSTEM: {
        TRANSFER_SYSTEM_SELECTION_PAGE_TITLE: '{{gatewayName}} Sistemas de gateway ({{systemCount}})',
        TRANSFER_SYSTEM_USERCONFIRMATION_TITLE: 'Los sistemas {{gatewayName}} se transferirán a los siguientes usuarios:',
        ADD_ANOTHER_USER: 'Agregar otro usuario',
        ADMIN_RIGHT_REQUIRED: 'Se requieren derechos de administrador para invitar al usuario',
        REGISTER_USER_REQUIRED: 'Se requiere al menos un usuario registrado para la transferencia',
        EMAIL_ID_DUPLICATE: 'El ID de correo electrónico está duplicado o no es una entrada válida',
        ADMIN_RIGHT_REQUIRED_FOR_SYSTEM_TRANSFER: 'Se requieren derechos de administrador para transferir entidades de usuario',
        DUPLICATE_ENTITY_ID: 'EntityId está duplicado o la entrada no es válida',
        TRANSFER_SYSTEM_EXISTING_USER: 'Usuarios existentes',
        INVALID_ENTITY_TYPE: 'Tipo de entidad no válido. Proporcione un tipo de entidad válido',
        TRANSFER_SYSTEM_LOGED_IN_USER_MSG: 'Usuario inválido, por favor agregue otro usuario.',
        INVITE_AS_COLLEAGUE: 'Invitar como colega',
        TRANSFER_SYSTEM_NEW_USER: 'Nuevos usuarios',
        TRANSFER_SYSTEM_ADD_EXISTING_USER: 'Agregue al menos un usuario existente para transferir entidades.',
        INVALID_EMAIL_ADDRESS: 'Proporcione una dirección de correo electrónico válida',
        INVALID_GATEWAY_ID: 'Proporcione una identificación de gateway válida',
        TRANSFER_SYSTEM_INFO: 'Seleccione un usuario existente o agregue uno nuevo.',
        TRANSFER_SYSTEM_SYSTEM_SELECTION_HEADER: 'Seleccione el(los) sistema(s) que desea transferir.',
        NO_DATA_FOUND: 'Datos solicitados no encontrados',
        TRANSFER_SYSTEM_SYSTEM_TRANSFER: 'Transferencia del sistema',
        TRANSFER_SYSTEM_CONFIRMATION_NEW_USER: 'Este usuario no puede monitorear sistemas hasta que acepte una invitación en el correo electrónico proporcionado.',
        TRANSFER_SYSTEM_PRIVILEGES: 'Privilegios del sistema de transferencia',
        TRANSFER_TO: 'Transferencia a',
        TRANSFER_USER_ALREADY_ADDED: 'Usuario ya añadido',
        TRANSFER_SYSTEM_ALREADY_ADDED_USER: 'El usuario ya está agregado a la lista. Agregue otro usuario.',
        TRANSFER_SYSTEM_USER_SELECTION_HEADER: '¿A quién desea transferir estos sistemas?',
        ADD_USERS: 'Agregar usuarios',
        TRANSFER_SYSTEM_DIALOG: '¿Transferir este sistema a los siguientes usuarios?',
        TRANSFER_SYSTEM_DIALOG_MSG: 'Ya no lo verás en tu panel y solo los usuarios seleccionados tendrán acceso.',
},
      ENTRY_PASSWORD_TITLE: 'Accediendo para',
      ADD_GATEWAYS: 'Agregar dispositivo',
      ADDING_GATEWAY_TITLE: 'Agregar "{{gatewayName}}" a {{orgName}}',
      CONNECT_TO_ELSYSTEM_FAILED_UREACHABLE_MSG: 'La gateway intenta conectarse al sistema y puede tardar más tiempo; revise el estado en la pestaña Sistema',
      RESET_GATEWAY_PASSWORD_SUCCESS: 'La contraseña de la gateway se restableció correctamente.',
      BLE: {
        ERROR: {
          INVALID_IP_AADRESS: 'Dirección IP no válida',
          CHANGE_FAILURE_MESSAGE: 'Se produjo un error al cambiar los parámetros',
          NOT_FETCHING_SYSTEM_DETAILS: 'No se pueden obtener los detalles del sistema',
          BUILDING_ALREADY_EXISTS: 'El nombre del edificio ya existe',
          RESET_PASSWORD_FAILED: 'La solicitud de restablecimiento de contraseña ha fallado. Inténtalo de nuevo.',
          INVALID_CONNECTION_STRING: 'Cadena de conexión no válida',
          INVALID_UUID: 'UUID no válido',
          ORGANIZATION_ALREADY_EXISTS: 'El nombre de la organización ya existe',
          REQUEST_FAILED_TITLE: 'Solicitud fallida',
          REQUEST_FAILED_GATEWAY_ADD: 'Error en la solicitud al agregar la gateway.',
          REQUEST_FAILED_MESSAGE: 'No se pudo completar la operación. Espere unos minutos y vuelva a intentarlo.',
          UNAUTHORIZED_ACCESS: 'Acceso no autorizado Por favor, inicie sesión nuevamente',
          INVALID_DEVICE: 'Dispositivo no válido',
          GATEWAY_UNRECHABLE: 'Sistema inaccesible',
          MAX_LIMIT_SYSTEM_REACHED_TITLE: 'Se alcanzó el límite máximo del sistema',
          REQUEST_FAILED_WIRELESS_GATEWAY_ADD: 'Error en la solicitud para agregar gateway inalámbrica.',
          REQUEST_FAILED_LP_SMART_ADD: 'No se pudo agregar Dualsmart',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'No se pudo agregar el dispositivo',
          DUPLICATE_SYSTEM_TITLE: 'Sistema duplicado',
          DIFF_PLATFORM_USER: 'La plataforma del dispositivo y la plataforma del usuario deben ser las mismas para la autoinvitación.',
          INVALID_ENTITY: 'Proporcione un ID de entidad válido.',
          PLATFORM_NOT_FOUND: 'No se encontraron detalles de la plataforma.',
          USER_ROLE_NOT_MATCH: 'El rol de usuario debe ser Técnico o Gerente de servicio.',
          INVALID_DEVICE_GUID: 'El ID del dispositivo solicitado no es un ID de sistema o de puerta de enlace válido.',
          ALREADY_HAVE_ACCESSE: 'El usuario ya tiene acceso al dispositivo solicitado.',
          FAILED_UPDATE_EPASDATA: 'No se pudo actualizar el número de ePAS',
},
        DEVICE_STATUS: {
          ALARM: 'Alarma',
          BLOCKED: 'Obstruido',
          NOT_PROVISIONED: 'No provisto',
          OFFLINE: 'Desconectado',
          ONLINE: 'En línea',
          PROVISIONED: 'Aprovisionado',
          READY: 'Listo',
          READY_FOR_COMMISSION: 'Listo para la puesta en servicio',
          WARNING: 'Advertencia',
},
        DEVICE_TYPE: {
          ATPLUS_CONTROLLER: 'Controlador AT+',
          COMMON_GATEWAY: 'Gateway común',
          DGS: 'DGS',
          LPSMART: 'LP inteligente',
          WIRELESS_GATEWAY: 'Controlador inalámbrico',
},
        SET_PASSWORD_STATUS: {
          INVALID_LENGTH: 'Longitud inválida',
          INVALID_PASSWORD: 'Contraseña inválida',
          PASSWORD_CHANGE_FAILURE: 'Error en el cambio de contraseña',
          PASSWORD_CHANGE_SUCCESS: 'Cambio de contraseña exitoso',
          PASSWORD_COMPARISON_FAIL: 'Error en la comparación de contraseñas',
},
        DEFAULT_LOGIN_STATUS: {
          LOGIN_DEFAULT_SUCCESS: 'Inicio de sesión predeterminado exitoso',
          LOGIN_FAILURE: 'Error de inicio de sesión',
          LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Se excedieron los intentos máximos de inicio de sesión',
          LOGIN_SUCCESS_ADMIN: 'Inicio de sesión exitoso admin',
          LOGIN_SUCCESS_SERVICE: 'Servicio de inicio de sesión exitoso',
          LOGIN_SUCCESS_USER: 'Usuario con inicio de sesión exitoso',
          LOGOUT: 'Cerrar sesión',
},
        NULL_VALUE: 'Sin respuesta',
        TURN_ON_BLE_MSG: 'Active Bluetooth para permitir que el “Administrador de seguridad del edificio” acceda a los sistemas locales.',
        DISCONNECT_ALERT_SUBTITILE: 'Ya no está conectado al Bluetooth "{{gatewayName}}". Asegúrese de estar dentro del alcance del Bluetooth para continuar.',
        SUCCESS: {
          REQUEST_SUCCESS_GATEWAY_ADD: 'La gateway se agregó correctamente',
          REQUEST_SUCCESS_WIRELESS_GATEWAY_ADD: 'La gateway inalámbrica se agregó correctamente',
          REQUEST_SUCCESS_LP_SMART_ADD: 'Dualsmart añadido con éxito',
          REQUEST_SUCCESS_BLE_DEVICE_ADD: 'Dispositivo añadido con éxito',
},
        LOST_BLE_CONNECTION: 'Conexión Bluetooth perdida',
},
      INVALID_SYSTEM_NUMBER: 'Número de sistema no válido',
      INVALID_USER_ACCESS_SYSTEM_UNLINK: 'Usuario no válido. No tiene acceso para desvincular el sistema.',
      GATEWAY_DISCONNECT_ALERT: '¿Estás seguro que deseas desconectarte?',
      DISCARD_CHANGES_ALERT: '¿Está seguro que desea descartar cambios?',
      UNLINKEXISTING_SYSTEM_ALERT: '¿Está seguro de que desea Desvincular el sistema existente?',
      GATEWAY_UNREGISTER_ALERT: '¿Estás seguro de que deseas cancelar el registro de Gateway?',
      AUTOMATICALLY_CONFIG_IP: 'Configurar automáticamente la dirección IP',
      BACKUP_CONNECTION: 'Conexión de respaldo',
      TIMELINE_VIEW: {
        BUILDING: 'Edificio',
        OPTINAL: 'Opcional',
        ORGANIZATION: 'Organización',
        SELECT_BUILDING: 'Por favor seleccione un edificio',
        SELECT_ORGANIZATION: 'Por favor seleccione una organización',
        SUB_LOCATION: 'Sububicación',
        SET_BACKUP_INTERNET_TITLE: 'Establecer el acceso a Internet de respaldo',
        SET_PRIMARY_INTERNET_TITLE: 'Establecer el acceso principal a Internet',
        INTERNET_CONNECTION_LABLE: 'Por favor seleccione…',
        SET_INTERNET_CONNECTION_MSG: 'Por favor, conéctese a Internet primero',
        SUB_LOCATION_LABLE: 'Nombre de la sububicación…',
        DESCRIPTION_LABLE: 'Escribe notas para tu equipo…',
        SYSTEM_INPUTS: 'Entradas del sistema',
        SYSTEM_INPUT_SUBTITLE: 'Nombre, información y programación',
        OUTPUT_CONFIGURATION: 'Configuración de salida',
        OUTPUT_CONFIGURATION_SUBTITLE: 'Información y programación del relé',
        SCHEDULE_TESTING: 'Programar pruebas',
        SCHEDULE_TESTING_SUBTITLE: 'Pruebas funcionales y de duración',
        CONFIGURE_SYSTEM_INPUT: 'Configurar la entrada del sistema',
        CONFIGURE_SYSTEM_OUTPUT: 'Configurar la salida del sistema',
        SET_TEST_SCHEDULE: 'Establecer un cronograma de prueba',
        SEARCH_FOR_IBUS: ' Buscar I-Bus',
        SEARCH_FOR_IBUS_SUBTITLE: 'Encuentra nodos de datos conectados',
        CIRCUIT_CONFIGURATION_SUBTITLE: 'Configuración y nombres',
        CIRCUITE_CONFIGURE: 'Configuración del circuito',
        SYSTEM_RELAY: 'Relé del sistema',
        CONFIGURE_SYSTEM_RELAY: 'Configurar el relé del sistema',
        SEARCH_ALL_LUMINAIRES_TITLE: 'Buscar todas las luminarias',
        SEARCH_ALL_LUMINAIRES_LABLE: 'Crear una configuración de iluminación',
},
      BLUETOOTH_SCAN_ERROR: ' ¿No encuentras tu gateway? Verifica',
      CARRIER_NAME: 'Nombre del transportista',
      CELLULAR: 'Celular',
      CELLULAR_PROCESS_FAILED_MSG: 'El proceso de configuración móvil falló. Inténtalo nuevamente.',
      CELLULAR_PROCESS_SUCCESS_MSG: 'Móvil configurado exitosamente.',
      CELLULAR_CONNECTION: 'Conexión móvil',
      NO_BLUETOOTH_SUPPORT: 'Bluetooth no compatible con este dispositivo',
      CHANGE_CONNECTION_METHOD: 'Cambiar el método de conexión',
      CHECK_FOR_UPDATES: 'Buscar actualizaciones',
      CONFIGURE_WI_FI_CONNECTION: 'Configurar los ajustes de Ethernet',
      CONFIGURE_CELLEULAR_CONNECTION: 'Configurar esta conexión celular',
      COMMISSION_NEW_GATEWAY: 'Conéctese a una emergencia de Eaton\nDispositivo de iluminación.',
      CONNECT_TO_ELSYSTEM_FAILED_MSG: 'Error en el proceso de conexión al sistema EL. Inténtalo de nuevo.',
      CONNECTED: 'CONECTADO',
      CONNECTED_TO: 'conectado a',
      CONNECTION_METHOD: 'Método de conexión',
      GATEWAY_CONNECTION_PRIORITY: 'Prioridad de conexión',
      CONNECTIONS: 'Conexiones',
      GATEWAY_ADD_BUILDING_VALUE: 'Crear un nuevo edificio',
      GATEWAY_ADD_ORGANIZATION_VALUE: 'Crear una nueva organización',
      SET_DATE_TIME_SUCCESS: 'La fecha y la hora se configuraron correctamente',
      DEFAULT_PASSWORD_ADMIN_CHANGED: 'CONTRASEÑA PREDETERMINADA DE ADMINISTRADOR CAMBIADA',
      DEFAULT_PASSWORD_USER_CHANGED: 'CONTRASEÑA PREDETERMINADA DE USUARIO CAMBIADA',
      DISCONNECTED: 'El dispositivo está desconectado o no puede conectarse, inténtelo nuevamente',
      DISCONNECTED_SUCCESS: 'El dispositivo se desconectó correctamente',
      GATEWAY_UNREGISTER_SUCCESS: 'La información de registro del dispositivo se eliminó correctamente',
      GATEWAY_UNREGISTER_FAILURE: 'La información de registro del dispositivo se eliminó correctamente',
      DGS_NOT_COMMUNICATING: 'DGS no se comunica',
      DGS_UNREACHABLE: 'DGS inalcanzable',
      DHCP: 'DHCP',
      DISABLE_WIFI_RATIO_STATUS: 'Desactivación de wifi para Gateway',
      DNS: 'Sistema de nombres de dominio',
      CONNECT_TO_ELSYSTEM_SUCCESS_MSG: 'El sistema EL se vinculó exitosamente.',
      ENABLE_LOCATION_FOR_MAP: 'Habilitar para encontrar su ubicación actual, habilitar para cargar la vista del mapa',
      ENABLE_WIFI_RATIO_STATUS: 'Habilitar wifi para Gateway',
      WIFI_CREDENTIALS_MESSAGE: 'Introduzca la contraseña correcta',
      ENTER_WIFI_CREDENTIALS: 'Ingresar credenciales de Wi-Fi',
      RESET_GATEWAY_PASSWORD: '¿Está seguro de que desea restablecer la contraseña de Gateway?',
      INVALID_EPAS_SERIAL_NUMBER: 'El número de serie de EPAS no es válido',
      ETHERNET: 'Ethernet',
      ETHERNET_CONFIGURATION: 'Configuración de Ethernet',
      ETHERNET_PROCESS_FAILED_MSG: 'El proceso de configuración de Ethernet ha fallado. Inténtalo de nuevo.',
      ETHERNET_CONNECTION: 'Conexión Ethernet',
      FAIL_LINK_SYSTEM: 'Error al vincular el sistema desde la gateway',
      FAIL_UNLINK_SYSTEM: 'Error al desvincular el sistema de la gateway',
      FAIL_UNREGISTER_GATEWAY: 'Error al anular el registro de la gateway',
      FINISH: 'Finalizar',
      CHANGE_PASSWORD_INFO: 'Por razones de seguridad, cambie la contraseña predeterminada.',
      GATEWAY_ACTIVATED: 'gateway activada',
      GATEWAY_ADDED: 'gateway añadida',
      GATEWAY_COMMISSIONING: 'Puesta en servicio de la pasarela',
      GATEWAY_CONNECTED: 'gateway conectada',
      GATEWAY_DETAILS: 'Detalles de la gateway',
      GATEWAY_NAME: 'Nombre de la gateway *',
      GATEWAY_PASSWORD: 'Contraseña de la gateway',
      GATEWAY_PASSWORD_INCORRECT: 'Contraseña de gateway incorrecta',
      GATEWAY_NAME_DESCRIPTION: 'Dale un nombre mejor a esta gateway y descripción.',
      SUCCESSFULLY_ADDED: 'Se ha añadido correctamente.',
      INCOMPLETE_SETUP: 'Configuración incompleta',
      INTERNET_SETTINGS: 'Configuración de Internet',
      INVALID_GUID: 'Id. de dispositivo no válida. Ingrese una GUID válida',
      FACTORY_RESET: 'Restablecimiento de fábrica',
      FACTORY_RESET_SUCCESS: 'El comando de restablecimiento de fábrica se ejecutó correctamente',
      FACTORY_RESET_FAILURE: 'El comando de restablecimiento de fábrica falló. Inténtalo de nuevo.',
      GATEWAY_FACTORY_RESET_ALERT: '¿Está seguro de que desea ejecutar el restablecimiento de fábrica para el gateway?',
      LAST_CONNECTED: 'Última conexión: 12:34:56 12 de mayo de 2024',
      CELLULAR_CONNECTION_TYPE_LTE: 'LTE',
      CELLULAR_CONNECTION_TYPE_NON_LTE: 'NO LTE',
      INVALID_LATITUDE: 'Latitud no válida. Indique una latitud válida.',
      INVALID_LONGITUDE: 'Longitud no válida. Por favor, proporcione una longitud válida.',
      INVALID_USER: 'Usuario inválido',
      SUBLOCATION_NAME_LENGTH: 'Solo letras, guiones y números',
      LINK_NEW_DEVICE: 'Vincular un nuevo dispositivo',
      LINK_NEW_SYSTEM: 'Vincular un nuevo sistema',
      LINK_SYSTEM: 'VINCULAR UN SISTEMA',
      LINK_ANOTHER_SYSTEM: 'Vincular otro sistema',
      LINK_MORE_SYSTEM: 'Vincular más sistemas',
      LINK_SYSTEM_MSG: 'Vincular sistema a \'{{gatewayName}}\' En progreso',
      LINK_SYSTEMS: 'Sistemas de enlace',
      LOCATION: 'Ubicación',
      DENIED_LOCATION_PERMISSION: 'Permiso de ubicación denegado. Habilítelo para obtener un escaneo de Bluetooth en busca de dispositivos cercanos',
      DENIED_LOCATION_PERMISSION_FOR_MAP: 'Permiso de ubicación denegado, habilítelo para cargar la vista del mapa',
      CONNECTION_TYPE_VALUE: 'LTE/WCDMA/GSM',
      MANAGE_ETHERNET_CONNECTION: 'Administrar la conexión Ethernet',
      MANAGE_WIFI_CONNECTION: 'Administrar la conexión Wifi',
      MANUALLY_CONFIG_IP: 'Introducir la dirección IP manualmente',
      SET_NAME_DESCRIPTION_SUCCESS: 'Nombre y descripción configurados correctamente',
      NO_DEVICE_FOUND: 'No se encontraron dispositivos',
      UNLINK_SYSTEM_ERROR: 'No hay gateway para cancelar el registro',
      NO_GATEWAY_NAME_FOUND: 'No se encontró ningún nombre',
      NO_SYSTEM_YET: 'Aún no hay sistemas',
      WIFI_NETWORK_NOT_AVAILABLE: 'No hay red wifi disponible',
      DHCP_OFF: 'Apagado',
      DHCP_ON: 'En',
      NO_SYSTEM_YET_DESCRIPTION: 'Una vez que vincule sus sistemas a esta gateway, verá una lista de sistemas aquí. Reformúlelo.',
      ONLINE_TEXT: 'en línea.',
      ORGANIZATION_TREE: 'Árbol de la organización',
      OTHER_NETWORK: 'Otra red..',
      BLUETOOTH_INSTRUCTIONS: ' Nuestras instrucciones',
      CHOOSE_GATEWAY_CONNECTION_METHOD: 'Por favor, elija su método de conexión de Gateway',
      CONFIRM_SELECTION: 'Por favor, confirme la selección',
      ENTER_ADMIN_CHANGE_PASSWORD: 'Por favor ingrese la contraseña de administrador modificada',
      ENTRY_GATEWAY_CHANGED_PASSORD: 'Por favor ingrese la contraseña modificada de la gateway',
      ENTRY_GATEWAY_DEFAULT_PASSORD: 'Por favor, introduzca la contraseña predeterminada de la gateway para',
      ENTRY_PASSWORD: 'Por favor, introduzca la contraseña de la gateway para',
      PLEASE_ENTER_NEW_PASSWORD_AGAIN_RECONNECT: 'Por favor ingrese la nueva contraseña nuevamente para reconectarse a la gateway.',
      MOVE_CAMERA_OVER_QR_CODE: 'Por favor mueva su cámara sobre el código QR',
      INVALID_BUILDING_ID: 'Proporcione una identificación de edificio válida',
      INVALID_DEVICE_ID: 'Proporcione una identificación de dispositivo válida',
      INVALID_DEVICE_NAME: 'Proporcione un nombre de dispositivo válido',
      INVALID_DEVICE_STATUS: 'Proporcione un estado válido del dispositivo',
      INVALID_DEVICE_TYPE: 'Proporcione un tipo de dispositivo válido',
      INVALID_PROJECT_ID: 'Proporcione una identificación de proyecto válida',
      INVALID_SYSTEM_ID: 'Proporcione una identificación de sistema válida',
      PLEASE_WAIT: 'Espere por favor',
      PRIMARY_CONNECTION: 'Conexión primaria',
      GATEWAY_PRIORITY: 'Prioridad',
      PROXY: 'Proxy (opcional)',
      PULL_REFRESH_TEXT: 'Desliza hacia abajo para actualizar',
      QUATERNARY_CONNECTION: 'Conexión cuaternaria',
      REMOVE_CONNECTION: 'Eliminar conexión',
      REMOVE_PRIMARY_CONNECTION: 'Eliminar conexión primaria',
      REQUIRE_GATEWAY_CONNECTED_TO_INTERNET: 'Requiere gateway conectada a Internet',
      SAVE_TO_CLOUD: 'Guardar en la nube',
      SAVE_WI_FI_CREDENTIALS: 'Guarde las credenciales de Wi-Fi para uso adicional  dispositivos',
      SCAN_QR_CODE: 'Escanear código QR',
      QR_CODE_SCAN: 'Escanear código QR',
      SCANNING_FOR_NEAR_BY_BLE: 'Buscando dispositivos Ble cercanos.',
      SCANNING_FOR_NEAR_BY_WIFI: 'Buscando WiFi cercano.',
      SEARCH_ALL_LUMINARIES: 'Buscar todas las luminarias',
      SEARCH_VIA_BLUETOOTH: 'Búsqueda por Bluetooth',
      SEARCHING_FOR_NEARBY_WIFI: 'Buscando Wi-Fi cercano...',
      SEARCH_VIA_BLUETOOTH_EllIPSE: 'Buscando vía Bluetooth...',
      SECONDARY_CONNECTION: 'Conexión secundaria',
      SELECT_PRIMARY_CONNECTION: 'Seleccione un método de conexión principal',
      SERIAL_NUMBER_NULL_OR_EMPTY: 'El número de serie no puede ser nulo o vacío',
      SET_DATE_TIME_CONFIG: 'Establecer fecha y hora Configuración incorrecta',
      SET_DATE_TIME_FAILURE: 'La fecha y la hora establecidas son un error de configuración',
      SET_NAME_DESCRIPTION_INCORRECT_CONFIG: 'Establecer nombre y descripción Configuración incorrecta',
      SET_NAME_DESCRIPTION_FAILURE: 'El nombre y la descripción del conjunto son errores de configuración',
      SET_EL_SYSTEM_PORT: 'Configurar el puerto del sistema EL',
      SET_GATEWAY_PORT: 'Configurar el puerto de enlace',
      STATIC: 'Estático',
      STATUS: 'Estado',
      STEP_THREE_OF_THREE: 'Paso 3 de 3',
      SYNC_DATE_TIME: 'Sincronizar fecha y hora',
      SYSTEM_UNLINK_SUCCESS: 'Desvinculación del sistema exitosa',
      SYSTEM_UNLINKED: 'Sistema desvinculado',
      SYSTEMS: 'Sistemas',
      UNLINK_SYSTEM_SUCCESS: 'Sistemas desregistrados exitosamente.',
      TERTIARY_CONNECTION: 'Conexión terciaria',
      GATEWAY_NOT_EXISTS: 'La gateway no existe',
      ADDING_GATEWAY_SUBTITITLE: 'Este proceso puede tardar hasta 2 minutos.',
      UNLINK_ANOTHER_SYSTEM: 'Desvincular otro sistema',
      UNLINK_EXISTING_SYSTEM: 'Desvincular el sistema existente',
      UNLINK_EXIST_SYSTEM: 'Cancelar el registro de Gateway',
      USE_WI_FI_PASSWORD: 'Usar contraseña de Wi-Fi',
      USE_WPA2_KEY: 'Utilice la clave WPA2',
      SCANNING_FAILED_TRY_AGAIN: 'Verificando dispositivo...',
      CARRIER_NAME_VALUE: 'Vodafone NL 3G',
      WI_FI: 'Wifi',
      WIFI_PROCESS_FAILED_MSG: 'El proceso de configuración de wifi falló. Inténtalo de nuevo.',
      GATEWAY_WIFI_CONFIG: 'Configuraciones de Wifi',
      WI_FI_NETWORK: 'Red wifi',
      WI_FI_NETWORK_NAME: 'Nombre de la red wifi',
      WI_FI_PASSWORD: 'Contraseña de Wi-Fi',
      GATEWY_INTERNET_SETTING_OPTIONAL_FIELD_MSG: 'Puede omitir cualquiera de estos pasos, pero será necesario completarlos más tarde para finalizar la configuración.',
      VERIFYING_DEVICE: 'Verificando dispositivo...',
      GATEWAY_OF: 'Puerta de entrada de',
      SYSTEM_LOCATION: 'Ubicación del sistema',
      LOCATION_PERMISSION_TITLE: 'Permiso de ubicación',
      LOCATION_REQUIRED_MESSAGE: 'Esta aplicación necesita acceso a tu ubicación.',
      PERMISSION_DENIED_TITLE: 'Permiso denegado',
      PERMISSION_DENIED_MULTIPLE_MSG: 'Has denegado el permiso de ubicación varias veces. Es posible que la aplicación no funcione correctamente sin él.',
      MAINTAINED_MODE: 'Modo mantenido',
      NON_MAINTAINED_MODE: 'Modo no mantenido',
      UNREGISTER_GATEWAY: 'Cancelar el registro de Gateway',
      CHOOSE_CONNECTION_TYPE: '¿Qué tipo de conexión utilizará para el sistema DGS?',
      REACHED_MAXIMUM_SUPPORTED_SYSTEM_ERROR_MSG: 'No se pueden agregar más sistemas. Se alcanzó el límite máximo de sistemas admitidos en Gateway',
      DUALSMART_NAME: 'Nombre de Dualsmart *',
      WIRELESS_GATEWAY_NAME: 'Nombre de la gateway inalámbrica *',
      DUPLICATE_SYSTEM_ERROR_MSG: 'El sistema con esta dirección IP ya está vinculado al Gateway.',
      DIRECT_CONNECT_OPTION_SELECT_MSG: 'Asegúrese de que la dirección IP del sistema esté configurada en Dirección IP y que DHCP esté deshabilitado',
      ATPLUS_OFFLINE_DATA_SYNC_TEXT: 'Datos capturados con éxito',
      ATPLUS_NAME: 'TLU AT+ Nombre *',
      MANAGE_WHITELIST: {
        MANAGE_WHITELIST: 'Administrar listas blancas',
        MANAGE_WHITELIST_TITLE: 'Gestión de listas blancas',
        CREATE_NEW_WHITELIST_BUTTON: 'Crear nueva lista blanca',
        NO_WHITELIST_FOUND: 'No se encontró ninguna lista blanca',
        ZONE_MANAGEMENT: 'Gestión de zonas',
},
      TIMEOUT_REQUEST: 'Tiempo de espera de solicitud',
      DUALSMART_DETAILS: 'Detalles de Dualsmart',
      DESCRIPTION: 'Descripción',
      SCAN_NEW_DEVICE: 'Escanear nuevo dispositivo',
      IS_CORRECT_DEVICE: '¿Es este el dispositivo correcto?',
      NEW_DEVICE_DETECTED: 'Nuevo dispositivo detectado',
      SUB_LOCATION: 'Sububicación',
      SYSTEM_SETTINGS: 'Configuración del sistema',
},
    ERROR_MESSAGES: {
      GENERIC_ERROR_CONTACT_DETAILS: ' o llamar al',
      GENERIC_ERROR: ' Se ha producido un error no especificado. Si el problema persiste, póngase en contacto con el servicio de asistencia de Eaton en',
      9003: 'La operación solicitada no se puede realizar, por favor contacte a su administrador',
      2002: 'El enlace de registro de usuario ha expirado o ya fue canjeado.',
      2018: 'No podemos completar su registro. Su organización ha superado la cantidad de usuarios asignados para su suscripción. Si su organización necesita usuarios adicionales, comuníquese con el servicio de asistencia de CST por correo electrónico a',
},
    FORGOT_PASSWORD: {
      INSTRUCTIONS: 'Por favor, introduzca el correo electrónico de la cuenta asociada a la cuenta.<br/><br/>\' +\n\'Si este correo electrónico tiene una cuenta en el Sistema de Gestión de Seguridad, recibirá una respuesta dentro de <3>un día hábil</3>.<br/><br/>\' +\n\'Para problemas urgentes de cuenta, llame al \'',
      ERROR: 'No se pudo restablecer su contraseña en este momento.',
      RESET_CODE_ERROR: ' Hubo un error con su código de reinicio.',
},
    ACCOUNT_SETTING: {
      UPDATES_AVAILABLE: 'ACTUALIZACIONES DISPONIBLES',
      ACCOUNT_CREATED: 'Cuenta creada',
      ACCOUNT_PREFERENCES: 'Preferencias de la cuenta',
      ADDRESS_LINE2: 'Línea de dirección 2 (opcional)',
      ALARAM: 'Alarmas',
      ALL_BUILDINGS: 'Todos los edificios',
      ALL_SYSTEM_FIRMWARE: 'Todo el firmware del sistema',
      ALL_SYSTEMS: 'Todos los sistemas',
      APPLICATION_THEME_COLOR: 'Color del tema de la aplicación',
      AUTOMATIC_LOG_OUT: 'Cierre de sesión automático',
      AUTOMATIC_UPDATES: 'Actualizaciones automáticas',
      AUTOMATIC_UPDATES_INFO: 'Descargue automáticamente la última versión del firmware a su dispositivo.',
      CHANGE_PASSWORD: 'Cambiar la contraseña',
      STORAGE_FIRMWAREFILE_INFO: 'Elija cómo almacenar los archivos de firmware en su dispositivo',
      CITY: 'Ciudad',
      COMPANY_ADDRESS: 'Dirección de la empresa',
      COMP_ADDRESS: 'Dirección de la empresa*',
      COMPANY_DETAILS: 'Datos de la empresa',
      COMPANY_NAME: 'nombre de empresa',
      COMP_NAME: 'nombre de empresa',
      COMPANY_PHONE_NUMBER: 'Número de teléfono de la empresa',
      CODE: 'Código del país',
      DATE_FORMAT: 'Formato de fecha',
      DELETE_ACCOUNT: 'Eliminar cuenta',
      DELETE_CUSTOMER: 'Eliminar cliente',
      DEVICE_BLOCKING: 'El dispositivo está en modo de bloqueo, modo de emergencia, mantenimiento solicitado',
      EDIT_CUSTOMER_INFO: 'Editar información del cliente',
      EMAIL: 'Correo electrónico',
      EMAIL_ADDRESS: 'Dirección de correo electrónico',
      REQUIRED_FIELD: 'Los campos con un asterisco (*) son obligatorios para continuar.',
      FIRMWARE_FILE: 'Archivos de firmware',
      FIRMWARE_UPDATES: 'Actualizaciones de firmware',
      FIRST_NAME: 'Nombre de pila',
      FT_DT_FAIL: 'Fallo de FT, Fallo de DT, desconectado, Fallo de batería, Fallo de lámpara, Fallo de ATSD',
      HEALTH_REPORT: 'Informe de salud',
      LANGUAGE: 'Idioma',
      LAST_NAME: 'Apellido',
      MONTHLY_REPORTING: 'Informes mensuales',
      NEW_RELEASE_FIRMWARE_UPDATE: 'Nuevos lanzamientos, actualizaciones de firmware disponibles',
      NOTIFICATIONS: 'Notificaciones',
      ORGAN_UPDATED_SUCCESSFULLY: 'Organización actualizada exitosamente',
      PASSWORD: 'Contraseña',
      PERSONAL_DETAILS: 'Datos personales',
      PHONE_NUMBER: 'Número de teléfono',
      VALID_FIRSTNAME_ERROR: 'Por favor, introduzca su nombre',
      POSTAL_CODE: 'Código Postal',
      PREFERENCES: 'Preferencias',
      PRIMARY_CONTACT: 'Contacto principal',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'Dirección de correo electrónico de contacto principal',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Número de teléfono de contacto principal',
      PRIMARY_EMAIL_ADDRESS: 'Dirección de correo electrónico principal',
      PRIMARY_PHONE_NUMBER: 'Número de teléfono principal',
      PRODUCT_UPDATE: 'Actualizaciones de productos',
      SAVE_CHANGES: 'Guardar cambios',
      SECONDARY_CONTACT: 'Contacto secundario',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Dirección de correo electrónico de contacto secundaria',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Número de teléfono de contacto secundario',
      SECONDARY_EMAIL_ADDRESS: 'Dirección de correo electrónico secundaria',
      SECONDARY_PHONE_NUMBER: 'Número de teléfono secundario',
      SLA_DETAILS: 'Detalles del contrato de nivel de servicio',
      STATUS_UPDATE: 'Actualizaciones de estado',
      STORAGE: 'Almacenamiento',
      TIME_ZONE: 'Huso horario',
      UNITS: 'Unidades',
      USER_NAME: 'Nombre de usuario',
      USER_UPDATED_SUCCESSFULLY: 'Usuario actualizado exitosamente',
      VERSION: 'Versión',
      EST: 'EST',
      DD_MM_YYYY: 'DD',
      CRITICAL_ALARAM: 'Solo alarmas críticas',
      FIRMWARE_UPDATE_REMIDERS: 'Actualizaciones de firmware, recordatorios de gestión del ciclo de vida',
      WARNINGS: 'Advertencias',
      OFFLINE_MODE: 'Modo sin conexión',
      OFFLINE_MODE_ENABLED: 'Activado',
      OFFLINE_MODE_DISABLED: 'Desactivado (Recomendado)',
      OFFLINE_MODE_ENABLE_WARNING: 'Al habilitar el modo sin conexión, el usuario puede trabajar sin conexión con la aplicación móvil, pero es posible que no pueda comunicarse con la nube ni ver actualizaciones de datos en tiempo real.\n\nPresione aceptar para continuar con el modo sin conexión.',
      OFFLINE_MODE_DISABLE_WARNING: 'Al deshabilitar el modo sin conexión, el usuario cerrará la sesión de la aplicación y deberá iniciar sesión nuevamente.',
      OPERATING_SYSTEM_THEME: 'Tema del sistema operativo',
},
    CHANGE_PASSWORD: {
      EMAIL_CONFIRM_MESSAGE: 'Hemos enviado un correo electrónico de confirmación a {{email}}',
      PROBLEM_OCCURRED: 'Ocurrió un problema:',
      PASSWORD: 'Cambiar la contraseña',
      OLD_PASSWORD: 'Contraseña anterior',
      PASSWORD_CHANGED: 'Contraseña cambiada',
      PASSWORD_INFO: 'La contraseña debe tener al menos 8 caracteres, contener al menos un carácter en mayúscula, un carácter en minúscula, un número y un carácter especial.',
      ERROR_MESSAGR: 'Su información no coincide con nuestros registros. Vuelva a ingresar su información para intentarlo nuevamente.',
      SUCCESS_MESSAGE: '¡Tu contraseña se actualizó correctamente! Para garantizar la seguridad de tu cuenta, deberás iniciar sesión en la aplicación con tus credenciales actualizadas.',
},
    SYSTEM_DETAIL: {
      GUIDE: '(Guía)',
      USERS_DATA: '5 administradores, 1 espectador',
      ACTIVATE_CONNECTIONS: 'Activar conexiones en la nube',
      ADD_ANOTHER_CELLULAR: 'Agregar conexión celular de respaldo',
      ADD_SLA: 'Añadir SLA',
       SYSTEM_DETAILS_TITLE: 'Detalles del sistema',
      ALL_CONTACTS: 'Todos los contactos',
      ALL_PEOPLE_IN_THIS_BUILDING: 'Todas las personas en este edificio',
      ALL_SYSTEMS_IN_THIS_BUILDING: 'Todos los sistemas en este edificio',
      BOTH_PORTS_CANNOT_BE_ON_SAME_SUBNET: 'Ambos puertos no pueden estar en la misma subred',
      BUILDING: 'Edificio',
      BUILDING_INFO: 'Información del edificio',
      BUILDING_TYPE: 'Tipo de edificio',
      BUYER: 'Comprador',
      CONNECTION_TYPE: 'Tipo de conexión',
      CONTACT_PERSON_Onsite: 'Persona de contacto en el sitio',
      CONTACT_TYPE: 'Tipo de contacto',
      CUSTOMER_DETAILS: 'Datos del cliente',
      CUSTOMER_INFO: 'Información del cliente',
      CUSTOMER_NUMBER: 'Número de cliente',
      DATE_COMMISSIONED: 'Fecha de puesta en servicio',
      DISABLE: 'Desactivar',
      DURATION_TEST: 'Prueba de duración',
      DURATION_TEST_FAILED: 'Prueba de duración fallida',
      DURATION_TEST_PASSED: 'Prueba de duración aprobada',
      ENABLED: 'Activado',
      ENTER_VALID_GATEWAY_ADDRESS: 'Introduzca una dirección de gateway válida',
      ENTER_VALID_IP_ADDRESS: 'Introduzca una dirección IP válida',
      ENTER_VALID_SUBNET_MASK: 'Introduzca una máscara de subred válida',
      ETHERNET_PORT_ONE: 'Puerto Ethernet A',
      ETHERNET_PORT_TWO: 'Puerto Ethernet B',
      EXPIRY_DATE: 'Fecha de caducidad',
      FIRMWARE_VERSION: 'Versión de firmware',
      FOR_BUILDINGS: 'Para edificios',
      FOR_SYSTEMS: 'Para sistemas',
      FUNCTIONAL_TEST: 'Prueba funcional',
      FUNCTIONAL_TEST_FAILED: 'Prueba funcional fallida',
      FUNCTIONAL_TEST_PASSED: 'Prueba funcional aprobada',
      GATEWAY: 'Puerta',
      GATEWAY_ADDRESS: 'Dirección de gateway',
      GATEWAY_ADDRESS_REQUIRED: 'Dirección de gateway*',
      GATEWAY_NAME: 'Nombre de la gateway',
      SYSTEM_UNLINKED_GATEWAY: 'ha sido  desvinculado de',
      SYSTEM_LINKED_GATEWAY: 'Ha sido vinculado  a',
      HOST_NAME: 'Nombre de host',
      INTIALIZE_CONNECTION: 'Inicializar conexión',
      INTIALIZE_NETWORK: 'Inicializando red...',
      IP_ADDRESS: 'Dirección IP',
      IP_ADDRESS_REQUIRED: 'Dirección IP*',
      IP_GATEWAY_NOT_IN_SAME_SUBNET: 'La dirección IP y la gateway no están en la misma máscara de subred',
      ETHERNET_CONNECTED: 'es ahora  conectado a internet',
      SYSTEM_LINKING_TITLE: '¿Es este el sistema que estás usando?',
      SYSTEM_UNLINKING_TITLE: '¿Es este el sistema que estás desvinculando?',
      SYSTEM_LINK_TITLE: ' Vincular un sistema a',
      LUMINAIRES: 'Luminarias',
      LUMINARIES_LIST: 'Lista de luminarias',
      MAC_ADDRESS: 'Dirección MAC',
      MAIN_CONTACT: 'Contacto principal',
      NETWORK_INFORMATION: 'Información de la red',
      NO_SYSTEM_FOUND: 'No hay sistema disponible',
      OFFICE: 'Oficina',
      ORGANIZATION: 'Organización',
      OTHER_STEPS: 'Otros pasos, si es necesario',
      OTHER_SYSTEMS: 'Otros sistemas',
      PART_NUMBER: 'Número de pieza',
      SETPORT_SYSTEM_DETAILS_DESCRIPTION: 'Por favor complete la configuración de Ethernet  detalles.',
      SYSTEM_DETAILS_DESCRIPTION: 'Encuentre estos detalles en la pantalla HMI de  el gabinete de su sistema.',
      PORT_NUMBER: 'Número de puerto',
      PREV: 'Anterior',
      PROJECT_LEAD: 'Líder del proyecto',
      REGISTER_ACTIVATE_GATEWAY: 'Registrarse y activar la pasarela',
      SERIALNO_VALUE: 'S3ri4l-Num63r',
      SERIAL_NUMBER: 'Número de serie',
      SETPORT_SYSTEM_LINK_TITLE: ' Configurar el puerto para vincular un sistema a',
      SLA_NUMBER_TITLE: 'Acuerdo de nivel de servicio n.º',
      SLAVE_NUMBER: 'Número de esclavo',
      SUBNET_MASK: 'Máscara de subred',
      SUBNET_MASK_REQUIRED: 'Máscara de subred',
      SYN_DATE_TIME: 'Sincronizar fecha y hora',
      SYSTEM: 'Sistema',
      SYSTEM_NAME: 'Nombre del sistema',
      SYSTEM_TYPE: 'Tipo de sistema',
      TECHNICAL_PERSON: 'Persona técnica',
      STATUS_DESCRIPTION: 'Esta es una descripción larga. Puede describir la ubicación del dispositivo y con quién hablar.',
      TOTAL_SLA: 'SLA totales',
      TRANSFER_ORGANIZATION: 'Transferir esta organización y sus activos a otro usuario (opcional)',
      SYSTEM_UNLINK_TITLE: 'Desvincular el sistema de',
      UPDATE_REQUIRED: 'Se requiere actualización',
      UPLOAD_DETAILS: 'Subir detalles vía bluetooth',
      FIRMWARE_VERSION_VALUE: 'v12.34-56',
      VERSION_AVAILABLE: 'v123.457 Disponible',
      VIEW_ALL: 'Ver todo',
      VIEW_ALL_LUMINARIES: 'Ver todas las luminarias',
      PARTNO_VALUE: 'xx xx xx xx',
      ETHERNET_SUBTITLE: 'Ahora puede acceder a su gateway a través de  web. Reformúlame.',
      NO_CUSTOMER_TEXT: 'Este sistema no se ha vinculado a ningún cliente.',
      LINK_TO_CUSTOMER_BUTTON: 'Vincular a un cliente.',
      LUMINARY_FIRMWARE_VERSION: 'Versión de firmware de la luminaria',
      FIRMWARE_UPDATE_MSG: 'Transmitir el comando de actualización de firmware a todas las luminarias y módulos',
      INTERNET_CONNECTIONS: 'Conexiones a Internet',
      INVALID_CONFIGURATION: 'Por favor, compruebe su configuración.',
      FAILURE_FT_DT: 'Falla FT/DT',
      IOTSTATUS: {
        FUNCTIONAL_TEST: 'Prueba de función',
},
},
    USER_INVITATION_MANAGEMENT: {
      YOU: '(Tú)',
      INVITATION_MESSAGE_UPDATE_COUNT: '{{updatedInvitationCount}} invitaciones fueron {{inviteStatus}} exitosas, {{rejectedInvitationCount}} invitaciones no fueron {{inviteStatus}}.',
      SUCCESS_COUNT: '{{updatedInvitationCount}} invitaciones se enviaron {{inviteStatus}} correctamente.',
      INVITE_ACCEPT: 'Aceptar',
      INVITE_ACCEPT_INVITATION: 'Aceptar invitación',
      INVITE_ACCEPTED: 'aceptado',
      INVITE_ACCEPTED_BUTTON: 'Aceptado',
      INVITE_ACCEPT_INVITATION_DESCRIPTION_1: 'Al aceptar esta invitación se agregará el siguiente elemento a su perfil:',
      ADMIN_APPROVE: 'Aprobar solicitud',
      COMPANY: 'Compañía',
      DECLINE_INVITATION: 'Rechazar invitación',
      TABLE_HEADER_DENIED_TITLE: 'Rechazado por mí ({{count}})',
      INVITE_DENIED: 'denegado',
      INVITE_DENY: 'Denegar',
      ADMIN_DECLINE_INVITATION: 'Denegar solicitud',
      TABLE_HEADER_EXPIRED_AT: 'Vencimiento',
      TABLE_HEADER_EXPIRED_TITLE: 'Invitaciones vencidas ({{count}})',
      INVITE_HISTORY: 'Historial de invitaciones',
      INVITATION_SUCCESS_MESSAGE: 'Invitación realizada exitosamente {{inviteStatus}}.',
      JOIN: 'Unirse',
      JOINALL: 'Únete a todos',
      LEAVE_ORGANIZATION: 'Dejar la organización',
      TABLE_HEADER_NAME: 'Nombre',
      INVITE_PENDING: 'Pendiente',
      INVITE_REQUEST_ACCESS_DESCRIPTION_2: 'Solicite acceso al administrador para agregar este elemento a su perfil',
      TABLE_HEADER_INVITE_DATE: 'Recibió',
      REMOVE_USER: 'Eliminar usuario',
      INVITE_REQUEST: 'Pedido',
      INVITE_REQUEST_ACCESS: 'Solicitar acceso',
      REQUESTEDBY: 'Solicitado por',
      INSTRUCTIONS: 'Seleccione si desea agregar elementos a su perfil o rechazar la invitación para agregarlos a su perfil.',
      ADMIN_INSTRUCTIONS: 'Seleccione si desea aprobar o rechazar su solicitud de acceso:',
      SENTBY: 'Enviado por',
      TABLE_HEADER_INVITE_BY: 'Enviado por',
      TABLE_HEADER_TOTAL_ACCEPTED_NO_DATA_FOUND: 'No hay invitaciones aceptadas en este momento.',
      TABLE_HEADER_DENIED_NO_DATA_FOUND: 'No hay invitaciones rechazadas en este momento.',
      TABLE_HEADER_EXPIRED_NO_DATA_FOUND: 'No hay invitaciones vencidas en este momento.',
      INVITATION_TEXT: 'Necesitarán una invitación para volver a unirse.',
      INVITE_REQUEST_ACCESS_DESCRIPTION_1: 'Esta invitación ha expirado y ya no se puede agregar a tu perfil.',
      TABLE_HEADER_TOTAL_COUNT: 'Total de invitaciones aceptadas ({{count}})',
      TABLE_HEADER_TOTAL_ACCEPTED_COUNT: 'Total de invitaciones aceptadas ({{count}})',
      SUCCESS_MESSAGE: 'Invitación de usuario exitosa {{count}}',
      ERROR_MESSAGE: 'La solicitud del usuario para actualizar la invitación falló',
      VIEW_ALL_ACCESS_RIGHTS: 'Ver todos los derechos de acceso',
      TITLE: 'Bienvenido, {{nombre de usuario}}',
      SUBTITLE: 'Has sido invitado a los siguientes proyectos:',
      ADMIN_SUBTITLE: 'Tienes solicitudes para acceder a invitaciones vencidas:',
},
    INACTIVITY: {
      LOGOUT: ', se cerrará su sesión.',
      INACTIVE_LOGOUT: 'Se desconectó por inactividad',
      TITLE: 'Tiempo de espera de la sesión',
      WARNING : ' Esta ventana ha estado inactiva durante 15 minutos. Si no se realiza ninguna acción en',
},
    ATPLUS: {
      ATPLUS_FAILURE_COUNT: '{{count}} Fallo',
      ATPLUS_DATETIME_TWENTYFOUR_HOUR: 'Hora de 24 horas',
      ATPLUS_TWO_MINUTE_AGO: 'Hace 2 minutos',
      ATPLUS_ACTIVATION: 'Activación',
      ADMIN: 'Administración',
      ADMINVIEWER: 'Administrador y espectador',
      ATPLUS_ADMIN_ACCESS: 'Acceso de administrador',
      ATPLUS_ALERT_LEVEL: 'Nivel de alerta',
      ATPLUS_ALERTSETTING_HEADER: 'Configuración del nivel de alerta',
      ATPLUS_SEARCHLUMINAIRE_WARNING: ' todas las luminarias se les asignará una nueva dirección y se creará una nueva configuración.',
      ATPLUS_LOGIN_FAILURE: 'Se produjo un error al cambiar los parámetros',
      ATPLUS_DATETIME_AUTO_DATE_TIME_HEADER: 'Fecha y hora automáticas',
      ATPLUS_AUTOMATIC_RESET: 'Modo de reposo automático',
      ATPLUS_AUTOMATIC_REST_MODE_MSG: 'El modo de reposo automático enviará las luminarias al reposo si se apaga la red principal local.',
      ATPLUS_BATTERYFAILURE: 'Fallo de la batería',
      ATPLUS_CHANGE_ADMIN_PASSWORD: 'Cambiar la contraseña del administrador',
      ATPLUS_CHANGE_PASSWORD_FAILURE: 'Error al cambiar contraseña',
      ATPLUS_CHANGE_PASSWORD_SUCCESS: 'Cambiar contraseña con éxito',
      ATPLUS_CHANGE_SERVICE_PARTNER_PASSWORD: 'Cambiar la contraseña del socio de servicio',
      ATPLUS_CHANGE_PASSWORD: 'Cambiar la contraseña del sistema',
      SYSTEMPASSWORD: 'Cambiar las contraseñas del sistema',
      ATPLUS_CHANGE_VIEWER_PASSWORD: 'Cambiar la contraseña del espectador',
      ATPLUS_SYNC_TEST_SCHEDULE_INFO: 'Haga clic en “Sincronizar programación de pruebas” para establecer las pruebas funcionales exactamente en 7 días a partir de ahora y las pruebas de duración en 10 semanas a partir de ahora.',
      ATPLUS_INFO_TAG_CLOSED: 'CERRADO',
      ATPLUS_COMISSIONING: 'Puesta en servicio',
      ATPLUS_COMMANDS: 'Comandos',
      ATPLUS_COMMSFAILURE: 'Fallo de comunicaciones',
      ATPLUS_CONFIGRATION_CREATED: 'Configuración creada',
      ATPLUS_CONFIGRATION_DETAIL: 'Detalles de configuración',
      ATPLUS_CONFIGRATION_NAME: 'Nombre de configuración',
      ATPLUS_CREATE_CONFIGRATION: 'Crear configuración',
      ATPLUS_DATETIME_CURRENT_TIME: 'Fecha y hora actuales del dispositivo del sistema',
      ATPLUS_DEVICE_DATETIME_CURRENT_TIME: 'Fecha y hora actual del dispositivo móvil',
      ATPLUS_CURRENT_TEST_SCHEDULE: 'Calendario de pruebas actual',
      ATPLUS_REFRESH_LUMINAIRES: 'Actualmente recuperando el estado más reciente de todas las luminarias en el edificio {{atplus}}.',
      ATPLUS_DATETIME: 'Fecha y hora',
      ATPLUS_DRYCONTACT_DEFAULT_SETTINGS: 'Configuración predeterminada',
      ATPLUS_DETAILS: 'Detalles',
      ATPLUS_DRY_CONTACT: 'Contacto seco',
      ATPLUS_DRYCONTACT_INPUT: 'Entrada de contacto seco',
      ATPLUS_ALERTSETTING_DRY_CONTACT_INPUT: 'Entrada de contacto seco activada',
      ATPLUS_DRYCONTACT_OUTPUT: 'Salida de contacto seco',
      ATPLUS_ALERTSETTING_DRY_CONTACT_OUTPUT: 'Salida de contacto seco activada',
      ATPLUS_DRYCONTACT_HEADER: 'Configuración de contacto seco',
      ATPLUS_DRYCONTACT_STATUS: 'Estado del contacto seco',
      ATPLUS_DURATION_TEST_TITLE: 'Duración\n Prueba',
      ATPLUS_DTSUCCESS: 'Duración de la prueba completa',
      ATPLUS_DTFAILEDTITLE: 'Prueba de duración fallida',
      ATPLUS_DTINPROGRESS: 'Prueba de duración en curso...',
      SERVICE: 'Servicio Eaton',
      ATPLUS_ELSYSTEM_SYSTEM_TIME: 'Hora local del sistema EL',
      ATPLUS_EMC_HEADER: 'Prueba de compatibilidad electromagnética',
      ATPLUS_EMERGENCY: 'Emergencia',
      ATPLUS_FW_UPDATE_EROOR: 'Error al actualizar el firmware, inténtalo nuevamente',
      ATPLUS_EXPORT_CONFIG: 'Configuración de exportación',
      ATPLUS_EXPORT_CONFIGRATION_FAIL: 'Error en el proceso de configuración de exportación',
      ATPLUS_FAILED_LUMINAIRE: 'Luminarias averiadas',
      ATPLUS_DRYCONTACT_FAILURE_THRESHOLD: 'Umbral de fallo excedido',
      ATPLUS_FAILURETYPE: 'Tipos de fallos',
      ATPLUS_FILE_ALREADY_EXIST_TITLE: 'El archivo ya existe',
      ATPLUS_FILE_ALREADY_EXIST_MSG: 'Ya existe un archivo con el mismo nombre. Cambie el nombre del archivo.',
      ATPLUS_FIRMWARE_FILE_FOR: 'Archivo de firmware para la versión',
      ATPLUS_FIRMWARE_UPDATE: 'Actualización de firmware',
      ATPLUS_FW_UPDATE_COMPLETE: 'Actualización de firmware completa',
      ATPLUS_FW_UPDATE_INPROGRESS: 'Actualización de firmware en curso',
      ATPLUS_FUNCTIONAL_TEST_TITLE: 'Prueba funcional',
      ATPLUS_FTSUCCESS: 'Prueba funcional completa',
      ATPLUS_FTINPROGRESS: 'Prueba funcional en progreso...',
      CHANGEPASSWORDFOR: 'Necesito cambiar la contraseña para',
      ATPLUS_IMPORT_CONFIG: 'Importar configuración',
      ATPLUS_INEMERGENCYMODE: 'En modo de emergencia',
      ATPLUS_INFAILURE: 'En el fracaso',
      ATPLUS_INRESTMODE: 'En modo de reposo',
      ATPLUS_INTESTMODE: 'En modo de prueba',
      ATPLUS_REFRESH_INCOMPLETE: 'Datos incompletos',
      ATPLUS_CHANGE_PASSWORD_INCORRECT_PASSWORD: 'Contraseña actual incorrecta',
      ATPLUS_DRYCONTACT_STATUS_INPUT: 'Aporte',
      ATPLUS_EXPORT_CONFIGRATION_INVALID_NAME: 'Nombre de configuración no válido',
      GWCDATPLUSHEADER: '¿Es este el dispositivo EL que estás poniendo en servicio?',
      ATPLUS_LAMPFAILURE: 'Fallo de la lámpara',
      ATPLUS_CONFIGRATION_FILE_TITLE_INFO: 'Solo letras, números, guiones bajos y guiones',
      ATPLUS_ALERTSETTING_LOCAL_MAIN_FAILURE: 'Fallo de la red principal local',
      ATPLUS_LOAST_CONNECTION: 'Conexión perdida - Inténtalo de nuevo',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS: 'Alertas de luminarias',
      ATPLUS_DTFAILEDDESCRIPTION: 'Fallo de luminaria',
      ATPLUS_LUMINAIRE: 'Luminarias',
      ATPLUS_FOUNDLUMINAIRE: 'Luminarias encontradas...',
      ATPLUS_FOUNDWERELUMINAIRE: 'Se encontraron luminarias.',
      ATPLUS_MAIN_OFFICE: 'Oficina central',
      ATPLUS_DRYCONTACT_SUBHEADER: 'Oficina central',
      ATPLUS_MANAGE_CONFIG: 'Administrar configuraciones',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED: 'Se ha alcanzado el número máximo de intentos',
      ATPLUS_MINIMIZE: 'Minimizar',
      ATPLUS_MULTIPLE_FAILURES: 'Fallos múltiples',
      ATPLUS_FOUNDNEWLUMINAIRE: 'Se encontraron nuevas luminarias.',
      ATPLUS_NEW_TEST_SCHEDULE: 'Nuevo calendario de pruebas',
      ATPLUS_DATETIME_SELECTED_TZ_PLACEHOLDER: 'Nueva York',
      ATPLUS_NEXT_SCHEDULES_DTTEST: 'Próxima prueba de duración programada',
      ATPLUS_NEXT_SCHEDULES_FTTEST: 'Próxima prueba funcional programada',
      ATPLUS_NO_FW_FILES: 'No hay ningún archivo de firmware presente para la versión',
      ATPLUS_NO_LUMINAIRES_INSTALLED: 'No hay luminarias instaladas',
      ATPLUS_NO_LUMINAIRES_YET: 'Aún no hay luminarias',
      ATPLUS_DRYCONTACT_RADIO_CLOSED: 'Normalmente cerrado',
      ATPLUS_DRYCONTACT_RADIO_OPEN: 'Normalmente abierto',
      ATPLUS_NEWLUMINAIRES_HEADLINE: 'Busque únicamente luminarias recién agregadas o reemplazadas en la “Oficina principal” para asignarles direcciones automáticamente.',
      ATPLUS_OPENSNACK: 'Abierto',
      ATPLUS_OPERATIONS: 'Operaciones',
      ATPLUS_ALERTSETTING_OTHER_ALERTS: 'Otras alertas',
      ATPLUS_DRYCONTACT_STATUS_OUTPUT: 'Producción',
      ATPLUS_DRYCONTACT_OUTPUT_DEFAULT_SETTINGS: 'Configuración predeterminada de salida',
      ATPLUS_ALERTSETTING_CHOOSE_NUMBER: 'Por favor, seleccione entre 1- 10 luminarias',
      ATPLUS_ADDITIONALPASSWORDINSTRUCTION: 'Cree nuevas contraseñas para los usuarios con acceso de nivel de servicio, administrador y espectador a este telecomando.',
      ATPLUS_DONT_MOVE: 'Por favor no te muevas',
      ATPLUS_DOWNLOAD_FW_FILES: 'Descargue el archivo nuevamente e intente...',
      ATPLUS_BLE_DISCONNECT_SUBTITILE: 'Asegúrese de estar dentro del alcance del Bluetooth y vuelva a intentarlo.',
      ATPLUS_RELOGINPASSWORDINSTRUCTION: 'Por favor ingrese la nueva contraseña nuevamente para volver a conectarse.',
      ATPLUS_RELOGIN_MESSAGE: 'Ingrese nuevamente la nueva contraseña para volver a conectarse.',
      ATPLUS_ENTRY_MESSAGE: 'Ingrese sus credenciales para cambiar las siguientes contraseñas.',
      ATPLUS_EXPORT_CONFIGRATION_INFO: 'Nombre el archivo que desea guardar y exportar y su configuración creada más recientemente.',
      ATPLUS_STAY_WHERE: 'Por favor quédate donde estás',
      ATPLUS_ALERTSETTING_NOTIFY: 'Utilice la siguiente configuración para personalizar sus preferencias de alerta.',
      ATPLUS_REFRESH_COMPLETE: 'Actualizar completo',
      ATPLUS_REFRESHLUMINAIRE_TEST: 'Luminarias Refresh',
      ATPLUS_REFRESH_LUMINAIRES_PAGETITLE: 'Luminarias Refresh',
      ATPLUS_REFRESH_LUMINAIRES_PROGRESS: 'Actualización de luminarias en proceso...',
      ATPLUS_USE_RELIGHT: 'La reiluminación solo está disponible para luminarias que se encuentren actualmente en modo de reposo.',
      ATPLUS_DRYCONTACT_INPUT_RELIGHT: 'Reenciende JOUR',
      ATPLUS_RELIGHT_SUCCESS: 'El modo Relight se ha activado correctamente.',
      ATPLUS_RESTMODE: 'Descansar',
      ATPLUS_REST_SUCCESS: 'El modo de descanso se ha activado correctamente.',
      ATPLUS_DURATION_TEST: 'Prueba de duración de ejecución',
      ATPLUS_FUNCTIONAL_TEST: 'Ejecutar prueba funcional',
      ATPLUS_SEARCHALL_LUMINAIRE: 'Buscar todas las luminarias',
      ATPLUS_SEARCH_ALL_LUMINAIRES: 'Buscar todas las luminarias',
      ATPLUS_SEARCH_NEWLUMINAIRES: 'Búsqueda de nuevas luminarias',
      ATPLUS_SEARCHNEW_LUMINAIRE: 'Buscar nuevas luminarias',
      ATPLUS_SERVICE_ACCESS: 'Acceso al servicio',
      ATPLUS_SERVICEPARTNERPASSWORD: 'Socio de servicio',
      ATPLUS_CHANGEPASSWORD_INSTRUCTION: 'Establecer una contraseña para los usuarios con',
      ATPLUS_ADDITIONALPASSWORD: 'Establecer contraseñas adicionales',
      ATPLUS_DATE_TIME: 'Establecer fecha y hora',
      ATPLUS_DATETIME_HEADER: 'Establecer fecha y hora',
      ATPLUS_ALERTSETTING_LUMINAIRE_ALERTS_INFO: 'Establezca la cantidad de luminarias defectuosas que debe alcanzar un sistema para que se active una alerta.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE: 'Mostrar luminarias conectadas',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE: 'Mostrar Luminarias Registradas',
      SIGN_IN: 'Iniciar sesión',
      SIGN_IN_AS: 'Iniciar sesión como...',
      ATPLUS_RELIGHT: 'Iniciar el modo Relight',
      ATPLUS_REST: 'Iniciar modo de descanso',
      ATPLUS_STARTSEARCH: 'Iniciar búsqueda',
      ATPLUS_START_TEST: 'Iniciar prueba',
      ATPLUS_VISIBILITY_TEST: 'Iniciar Visibilidad Plus',
      ATPLUS_DRYCONTACT_INPUT_VISIBILITY: 'Iniciar Visibilidad+',
      ATPLUS_STARTDT: 'Prueba de duración inicial...',
      ATPLUS_STARTFT: 'Iniciando prueba funcional...',
      ATPLUS_STARTDTSNACK: 'Detener prueba',
      ATPLUS_EMC: 'Cambiar a prueba EMC',
      ATPLUS_SYNCH_TEST: 'Programación de pruebas de sincronización',
      ATPLUS_SYNC_TEST_SCHEDULE: 'Programación de pruebas de sincronización',
      ATPLUS_SYNC_TEST_SCHEDULED_INFO: 'Sincronizar el cronograma de pruebas para la prueba funcional y de duración de todas las luminarias del edificio',
      TELECOMMANDPASSWORD: 'Contraseña de telecomando',
      ATPLUS_TEST: 'Prueba',
      ATPLUS_SYNC_TEST_TIME: 'Hora de la prueba:',
      ATPLUS_DRYCONTACT_INPUT_READONLY: 'La entrada de contacto seco es de solo lectura, pero se puede configurar manualmente en el interruptor DIP.',
      ATPLUS_DRYCONTACT_STATUS_READONLY: 'El estado es de solo lectura, pero se puede configurar manualmente en el interruptor DIP.',
      ATPLUS_LUMINAIRE_INSTALL: 'Esta acción hará parpadear todas las luminarias de una instalación.',
      ATPLUS_SHOW_CONNECTED_LUMINAIRE_INFO: 'Esta acción hará parpadear cualquier luminaria que esté correctamente cableada y conectada al controlador.',
      ATPLUS_SEARCHLUMINAIRE_HEADLINE: 'Esta acción creará una nueva configuración utilizando todas las luminarias conectadas.',
      ATPLUS_SHOW_REGISTERED_LUMINAIRE_INFO: 'Esta acción solo hará parpadear las luminarias que estén incluidas en su configuración de iluminación.',
      ATPLUSSYNC_TEST_SCHEDULED_TIME_INFO: 'Esta acción sincronizará la próxima prueba funcional exactamente a la semana y las pruebas de duración a las 10 semanas.',
      ATPLUS_AUTOMATIC_REST_MODE_INFO: 'Esta información es de solo lectura, pero se puede configurar manualmente en el interruptor DIP.',
      ATPLUS_LOAST_CONNECTION_INFO: 'Este dispositivo móvil debe permanecer dentro del alcance de Bluetooth y conectado al sistema AT+ durante la prueba funcional.',
      ATPLUS_DEVICE_RANGE: 'Este dispositivo móvil debe permanecer dentro del alcance Bluetooth del TLAT+ para esta operación. \n\nEste proceso puede tardar varios minutos.',
      ATPLUS_TOMANYLUMINAIREHEADER: 'Este sistema solo admite hasta 64 luminarias. Solo los primeros 64 dispositivos detectados formarán parte de su configuración.\nUtilice la función “Buscar luminarias registradas” en la ventana de puesta en servicio para encontrar las luminarias que no están incluidas en su configuración.',
      ATPLUS_CURRENT_LUMINAIRES_CONFIGURATION: 'Esto reemplazará su configuración de luminaria actual.',
      ATPLUS_TIMEREMAINS: 'Estimación de tiempo,',
      ATPLUS_TIMEREMAINING: ' Tiempo restante,',
      ATPLUS_DATETIME_TIMEZONE: 'Huso horario',
      ATPLUS_TIMEZONE_HEADER: 'Huso horario',
      TLU_ATPLUS_PASSWORD_INCORRECT: 'Contraseña TLU AT+ incorrecta',
      ATPLUS_TOMANYLUMINAIRE: 'Se encontraron demasiadas luminarias',
      ATPLUS_FIRMWARE_UPDATING: 'Actualizando firmware...',
      ATPLUS_USE_REST: ' Utilice Descanso para luminarias que ya no están conectadas a la red eléctrica principal.',
      ATPLUS_FINISHSEARCH: 'Utilice estos resultados para crear y compartir una nueva configuración mediante “Exportar”.',
      ATPLUS_DATETIME_AUTO_DATE_TIME_SUBTEXT: 'Utilice la fecha, la hora y la zona horaria de su dispositivo móvil para configurar automáticamente Sincronizar con el sistema. Desactive esta función para configurar manualmente la fecha, la hora y la zona horaria.',
      ATPLUS_VIEWLOGBOOK: 'Ver el libro de registro',
      VIEWER: 'Espectador',
      ATPLUS_VIEWER_ACCESS: 'Acceso de los espectadores',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY: 'Puedes intentar iniciar sesión en este',
      ATPLUS_DT_DIALOG: 'Puede perder datos si se aleja demasiado del sistema AT+ durante la prueba de duración.\n\nTiempo restante estimado: 01:00:00',
      ATPLUS_FT_DIALOG: 'Puede perder datos si se aleja demasiado del sistema AT+ durante la prueba funcional.\n\nTiempo restante estimado: 00:02:00',
      ATPLUS_NO_LUMINAIRES_YET_DESCRIPTION: 'Necesitarás utilizar la función “Buscar todas las luminarias” y activar tu TLAT+ para ver tus luminarias aquí.',
      ATPLUS_CONFIGRATION_CREATED_MESSAGE: 'Su configuración ha sido creada exitosamente.',
      ATPLUS_RELOGIN_SUCCESS_MESSAGE: 'Se guardaron sus nuevas contraseñas.',
      ATPLUS_DEVICE_UNREGISTERED: 'Este dispositivo no está registrado',
      ATPLUS_DEVICE_NEEDCOMMISSIONIG: 'Este dispositivo no está registrado en la nube y debe volver a ponerse en funcionamiento.',
      SAVE_TO_CLOUD: 'Guardar en la nube',
      EXPORT: 'Exportar',
      ATPLUS_IMPORT_CONFIG_SETTING_DEVICE_NAME: 'Configuración del nombre del dispositivo',
      TPLUS_IMPORT_CONFIG_LOADING_LUM_CONFIGRATION: 'Cargando la configuración de la luminaria...',
      ATPLUS_IMPORT_CONFIG_SETTING_DRY_CONTACT_CONFIGURATION: 'Configuración de la configuración de contacto seco',
      ATPLUS_IMPORT_CONFIG_PROGRESS_ALERT_TITLE: '¿Renunciar y perder el progreso?',
      TPLUS_IMPORT_CONFIG_PROGRESS_ALERT_SUBTITLE: 'Al salir de esta pantalla se cancelará el proceso de importación y tendrá que iniciar el proceso nuevamente.',
      ATPLUS_START_VISIBILITY_PLUS: 'Iniciar Visibilidad Plus',
      ATPLUS_VISIBILITY_PLUS: 'Visibilidad Plus',
      ATPLUS_VISIBILITY_PLUS_FAILED: 'Visibilidad Plus fallida',
      ATPLUS_IN_ALARM: 'En estado de alarma',
      LAMP_FAILURE_TEXT: 'Fallo de la lámpara',
      SAFETY_LUMINARIE: 'Luminaria de seguridad',
      LUMINARY_ADDRESS: '<dirección>',
      DS_SEARCH_IO_MODULES_BTN_TEXT: 'Buscar módulos I-Bus',
      DS_SEARCH_FOR_IO_MODULES: 'Buscar módulos I-Bus',
      ATPLUS_ACTIVATION_STEP: 'Siga las instrucciones a continuación para registrar y activar las funciones de monitorización en este sistema TLU AT+.',
      ATPLUS_INSURE_ALL_LUMINARIES_REGISTERED: 'Pasos de activación',
      ATPLUS_ACTIVATION_IF_NOT_COMPLETED_THIS_STEPS: 'Si aún no ha completado este paso, haga clic aquí para obtener más información.',
      ATPLUS_ACTIVATION_REGISTER_SYSTEM_TO_CLOUD: 'Haga clic en "Registrar el sistema en la nube y activarlo".',
      ATPLUS_ACTIVATION_MUST_HAVE_BLUETOOTH: '(El sistema TLU AT+ debe tener conexión a internet y Bluetooth).',
      ATPLUS_ACTIVATION_INTERNET_CONNECTION_REQUIRED: 'Se requiere conexión a internet.',
      ATPLUS_ACTIVATION_PROGRESS_PAGEINFO_SUBTITLE: 'Siga las instrucciones a continuación para registrar y activar las funciones de monitorización en este sistema TLU AT+.',
      ATplUS_ACTIVATION_PENDING: 'Pendiente',
      ATplUS_ACTIVATION_SENDING_DATA_TO_CLOUD: 'Enviando datos a la nube',
      ATPLUS_ACTIVATION_REGISTERED: 'Registrado',
      ATPLUS_ACTIVATING_DEVICE: 'Activando TLU AT+',
      ATPlUS_ACTIVATION_COMPLETE: 'Activación completada',
      ATPLUS_ACTIVATION_COMPLETE_MESSAGE: 'Su sistema y todas las funciones de monitorización ya están activados.',
      ATPLUS_ACTIVATION_REGISTER_AND_ACTIVATE: 'Registrar y activar TLU AT+',
      ATPLUS_ACTIVATION_RESULT_TITLE: 'Resultado de la activación',
      ATPLUS_TLU_AT_PLUS: 'TLU AT+',
      ATPLUS_ACTIVATION_PROCESS: 'El proceso de activación ya se inició, pero requiere conexión a internet para el siguiente paso. ',
      ATPLUS_ACTIVATION_INFO1: 'Una vez conectado a internet, los datos se registrarán automáticamente en la nube.',
      ATPLUS_ACTIVATION_INFO2: 'Queda por completar la activación de su configuración registrada. Asegúrese de tener conexión Bluetooth para completar la activación.',
      ATPLUS_ACTIVATION_YOU_HAVE: 'Tiene...',
      ATPLUS_ACTIVATION_EXIST_REGISTERED: 'Quiero completar el proceso de activación con mi configuración registrada.',
      ATPLUS_ACTIVATION_NEW_REGISTERED: 'Quiero registrar una nueva configuración.',
      ATPLUS_ACTIVATION_INPROGRESS: 'Activación en curso',
      ATPLUS_ACTIVATION_48HUORS: '48 horas para completar la activación',
      ATPLUS_ACTIVATION_COMPLETE: 'Pulse "Ver" para completar el proceso',
      ATPLUS_ACTIVATION_ALREADY_INPROGRESS: 'Ya hay una activación en curso',
      ATPLUS_ACTIVATION_FAILED: 'Error de registro',
      ATPLUS_ACTIVATION_FAILED_MESSAGE: 'Asegúrese de que las configuraciones de la nube y del sistema coincidan.',
      ATPLUS_MODEL_NAME: 'Nombre del modelo',
      ATPLUS_MODEL_DESCRIPTION: 'Descripción del modelo',
      ATPLUS_IDENTIFY_LUMINAIRE: 'Esto hará que la luminaria parpadee. Si se deja encendida, se apagará después de 1 hora.',
      ATPLUS_IDENTIFY_LUMINAIRE_TITLE: 'Identificar luminaria',
      ATPLUS_IMAGE_DESCRIPTION_TITLE: 'Información no disponible',
      ATPLUS_IMAGE_DESCRIPTION_SUBTITLE: 'Verifique su conexión a internet y vuelva a intentarlo. Luminaria de emergencia',
      ATPLUS_SAFETY_LIGHT: 'Luz de seguridad',
      ATPLUS_SAFETY_LIGHT_ROUND: 'Luz de seguridad redonda',
      ATPLUS_SAFETY_LIGHT_SQUARE: 'Luz de seguridad cuadrada',
      ATPLUS_EXIT_SIGN_PICTOGRAM_DOWN: 'Luz de señal de salida, pictograma hacia abajo',
      ATPLUS_EXIT_SIGN_PICTOGRAM_RIGHT: 'Luz de señal de salida, pictograma a la derecha',
      ATPLUS_EXIT_SIGN_PICTOGRAM_TOP: 'Luz de señal de salida, pictograma superior',
      ATPLUS_EXIT_SIGN_PICTOGRAM_LEFT: 'Luz de señal de salida, pictograma a la izquierda',
      ATPLUS_EXIT_SIGN_LIGHT: 'Luz de señal de salida',
      NO_LUMINARIE_TYPE_SELECTED: 'No se ha seleccionado ningún tipo de luminaria',
      ATPLUS_LUM_FAIL_MSG: 'Error en la actualización de campos',
      ATPLUS_NAME_UPDATE_FAILED: 'El nombre de la luminaria se actualizó correctamente y la descripción del conjunto falló',
      ATPLUS_DESCRIPTION_FAILED: 'Descripción de Luminarie actualizada con éxito y el nombre establecido es incorrecto',
      ATPLUS_REGISTER_DEVICE: 'Registro del dispositivo TLU AT+',
      ATPLUS_REGISTER_LUMINAIRES: 'Registro de luminarias en el dispositivo TLU AT+',
      ATPLUS_ACTIVATION_ALREADY_EXISTS: 'El dispositivo ya está activado.',
      ATPLUS_ALERTSETTING_ZONE_ALERTS: 'Alertas de zona',
      ATPLUS_ALERTSETTING_ZONE_ALERTS_INFO: 'Establezca la cantidad de luminarias defectuosas que debe alcanzar un sistema para que se active una alerta.',
      ATPLUS_ALERTSETTING_ZONE_CHOOSE_NUMBER: 'Por favor, elija entre 1 - 6 luminarias',
      ATPLUS_ALERTSETTING_LINE_ALERTS: 'Alertas de línea',
      ATPLUS_ALERTSETTING_LINE_ALERTS_INFO: 'Establezca la cantidad de luminarias defectuosas que debe alcanzar un sistema para que se active una alerta.',
      ATPLUS_ALERTSETTING_LINE_CHOOSE_NUMBER: 'Por favor elija entre 1- 10 líneas',
      ATPLUS_OFFLINE_UNREGISTER_INFO: 'Sincronice los datos desde la nube antes de cancelar el registro; de lo contrario, no es administrador para cancelar el registro de este dispositivo.',
      ATplUS_ACTIVATION_FETCHING_DATA_FOR_ACTIVATION: 'Obteniendo datos para el proceso de activación',
       NO_FAILURES_DETECTED: 'No se detectaron fallas',
      ATPLUS_XMLFILES_ONLY: '* Seleccione sólo archivos \'.xml\'',
      ATPLUS_IDENTIFICATION_CONNECTED_LUMINAIRE: 'Identificar luminarias conectadas',
      ATPLUS_IDENTIFICATION_CONNECTED_LUMINAIRE_INFO: 'Esta acción hará parpadear cualquier luminaria que esté correctamente cableada y conectada al controlador.',
      ATPLUS_IDENTIFICATION_REGISTERED_LUMINAIRE: 'Identificar luminarias registradas',
      ATPLUS_IDENTIFICATION_REGISTERED_LUMINAIRE_INFO: 'Esta acción solo hará parpadear las luminarias que estén incluidas en su configuración de iluminación.',
      ATPLUS_REPLACE_TLUAT: 'Estoy reemplazando un TLU AT+',
      ATPLUS_ADD_NEW_TLUAT: 'Estoy agregando un nuevo TLU AT+',
      ATPLUS_REPLACE_EXISTING_TLUAT: 'Estoy reemplazando un TLU AT+ existente',
      ATPLUS_IMPORT_INFO: 'Importar configuración de iluminación Importe la configuración de iluminación más reciente para este telecomando',
      ATPLUS_IDENTIFY_LUMS: 'Identificar luminaria encendida',
      ATPLUS_IDENTIFY_LUMS_OFF: 'Identificar luminaria apagada',
      ATPLUS_RESET_LUMINARIE: 'Restablecer Luminaria',
      ATPLUS_RESET_LUMINARIE_INFO: 'El restablecimiento borrará todos los fallos registrados en la luminaria. Esta acción es irreversible.',
      ATPLUS_PREVIOUS_DT_INFO: 'Duración de la prueba anterior',
      ATPLUS_WEEKDAYS: 'Cada {{weekDay}} semanas',
      ATPLUS_TEST_INFORMATION: 'Información de la prueba',
      ATPLUS_DESCRIPTION: 'Descripción actualizada exitosamente',
      ATPLUS_SYSTEM_LOCAL_TIME: 'Hora local del sistema EL:',
      ATPLUS_SYSTEM_LOCAL_TIME_CET: '(CET)',
      ATPLUS_MODEL: 'Por modelo',
      ATPLUS_LUMINAIRE_LIST: 'Por lista de luminarias',
      ATPLUS_MODEL_VALUE: 'modelo',
      ATPLUS_LUMINAIRE_LIST_VALUE: 'Lista de luminarias',
      ATPLUS_LUM_SEARCH_NOT_STARTED: 'Búsqueda de luminarias no iniciada',
      ATPLUS_LUM_SEARCH_ONGOING: 'Búsqueda de luminarias en curso',
      ATPLUS_LUM_CONF_SET_GET: 'Configuración de la luminaria',
      ATPLUS_LUM_STATUS_GET: 'Obtener el estatus de Luminaria',
      ATPLUS_LUM_SEARCH_COMPLETE: 'Búsqueda de luminarias completa',
      ATPLUS_LUM_EPAS_GET: 'Obtención de Luminarie EPAS',
      ATPLUS_ACTIVATION_PENDING_NOTIFICATION_TITLE: 'Activación pendiente para',
      ATPLUS_ACTIVATION_PENDING_NOTIFICATION_SUBTITLE: 'Por favor, inténtalo de nuevo',
      ATPLUS_ACTIVATION_FAIL_NOTIFICATION_TITLE: 'La activación falló para',
      ATPLUS_CONFIGURATION_MISMACTH: 'Es posible que los valores de configuración no coincidan, por lo que no podrá configurar este dispositivo.',
      ATPLUS_SETTING_LUMINAIRES_CONFIGRATION: 'Configuración de la luminaria actual de la luminaria total...',
      SYSTEM_POWER_UP_MAINS: 'Encendido del sistema - Conexión a la red eléctrica',
      SYSTEM_POWER_DOWN_BUTTON: 'Apagado del sistema - Botón de encendido',
      SYSTEM_POWER_DOWN_BATTERY_DISCONNECT: 'Apagado del sistema - Batería desconectada',
      SYSTEM_POWER_DOWN_MAINS_FAILURE_NO_BATTERY: 'Apagado del sistema - Fallo de red',
      DATALINE_FAILURE_DISCONNECTED: 'Línea de datos de la luminaria desconectada',
      ATPLUS_INVALID_FILE: 'Hay un problema con el archivo de configuración',
      ATPLUS_SYNC_SYSTEM_DATA: 'Sincronizar datos del sistema',
      ATPLIS_EPASS_ISSUE_IN_ACTIVATION: 'EPAS no está disponible para luminarias conectadas. Activación cancelada. Busca luminarias y vuelve a intentarlo.',
      ATPLUS_INVITE_OFFLINE: 'En modo sin conexión, conéctese a Internet y sincronice los datos sin conexión',
      ATPLUS_LOGIN_MAX_ATTEMPTS_EXCEEDED_BODY_WITH_TIME: 'Intente iniciar sesión después de {{ time }}',
      ATPLUS_NOT_ACTIVATE_TITLE: 'Este sistema no ha sido activado',
      ATPLUS_NOT_ACTIVATE_INFO: 'Para poder ver la información de monitoreo de las luminarias, complete los pasos para activar este sistema.',
      ATPLUS_ACTIVATE_THIS_SYSTEM: 'Activar este sistema',
      ATPLUS_ACTIVATION_72HOURS: '72 horas para completar la activación',
      ATPLUS_SPEC_DATE_COMMISSIONED: 'Fecha de puesta en servicio',
      ATPLUS_SPEC_TOTAL_LUMINAIRES: 'Luminarias Totales',
      ATPLUS_SPEC_LUMINAIRE: 'Luminarias',
      ATPLUS_SPEC_VIEW_ALL_LUMINAIRES: 'Ver luminarias',
      ATPLUS_SPEC_LOADER_SUBTITITLE: 'Este proceso puede tardar hasta 60 segundos...',
      ATPLUS_ACTIVATION_WARNING_FOR_SKIP_BUILDING: 'Antes de activar el sistema {{devices}}, asegúrese de que {{devices}} esté registrado en la organización y el edificio. De lo contrario, registre el dispositivo en la organización y el edificio y luego realice la activación.',
      ATPLUS_CONTROLLER_MAC_ADDRESS: 'Dirección MAC BLE',
      ATPLUS_RESET_BUILDING: 'Restablecer edificio',
      ATPLUS_RESET_BUILDING_SUCCESS: 'El restablecimiento del edificio se ejecutó correctamente',
      ATPLUS_RESET_BUILDING_FAILURE: 'Error al restablecer el edificio. Inténtalo de nuevo.',
      ATPLUS_FACTORY_RESET_BUILDING_ALERT: '¿Está seguro de que desea ejecutar Restablecer edificio para Gateway?',
      COMMISSIONING_STEPS: 'Pasos de la puesta en servicio',
},
    USERLIST: {
      DELETECONFIRMATION: 'La cuenta {{email}} y todos sus datos se eliminarán de forma permanente. La eliminación de esta cuenta no afectará a la organización, los dispositivos ni ningún dato histórico relacionado.',
      ACCOUNT_DELETE: 'Cuenta eliminada',
      ALL_LOCATION: 'Todas las ubicaciones',
      DELETEACCOUNT: '¿Eliminar esta cuenta?',
      COL_EMAIL: 'Correo electrónico',
      COL_LOCATION: 'Ubicación',
      COL_ROLE: 'Role',
      COL_STATUS: 'Estado',
      DELETE_SUCCESS: 'La cuenta de usuario de {{email}} ha sido eliminada exitosamente.',
      COL_USERNAME: 'Nombre de usuario',
},
    REPORTS: {
      ISSUES: '{{issueCount}} problemas',
      MONTHLY_REPORT: 'Informe mensual',
      NO_ISSUES: 'No hay problemas durante este período',
      REPORT_DOWNLOAD_FAILED: 'Error en la descarga del archivo de informe',
      REPORT_DOWNLOAD_SUCCESSFULLY: 'El archivo de informe se ha descargado correctamente',
},
    MAP: {
      MAP_COORDINATES: '{{latitud}} N, {{longitud}} E',
      BLOCKED: 'OBSTRUIDO',
      MAP_COORDINATES_LABEL: 'Coordenadas',
       MAP_ADDRESS_DISPLAY: 'Mostrar dirección en el mapa',
      MAP_DRAG_MARKER: 'Arrastre sobre el mapa para colocar el pin',
      ERROR: 'ERROR',
      OFFLINE: 'DESCONECTADO',
      READY: 'LISTO',
      MAP_ENABLE_ON_COUNTRY: 'Seleccione el país para habilitar el mapa',
      SYSTEM: 'Sistema',
      SYSTEMS: 'Sistemas',
      WARNING: 'ADVERTENCIA',
},
    MAINTENANCE_DETAILS: {
      ADD_DOC: '+ Agregar documento',
      ADD_NOTES: '+ Agregar notas',
      ADD_DOCUMENT_BUTTON: '+ Agregar documento o foto',
      NEW_MAINTENANCE: '+ Nuevo mantenimiento',
      CREATE_MAINTAINENCE_BUTTON: 'Asignar y notificar',
      TECHNICIAN_INPUT_LABEL: 'Asignado a',
      STATUS_COMPLETED: 'Terminado',
      CUSTOMER_CONTACT: 'Contactos de clientes',
      DATE_CREATED: 'Fecha de creación',
      DELETE_REQ: 'Solicitud de eliminación',
      COMMENTS_LABEL: 'Descripción (opcional)',
      DOCUMENTATION: 'Documentación',
      STATUS_DUE: 'Pendiente',
      EMERGENCY: 'Emergencia',
      STATUS_EXPIRED: 'Venció',
      HIGH: 'Alto',
      IN_DUE: 'EN {{differenceInDays}} DÍAS',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_TYPE: 'Tipo de archivo no válido. Solo se permiten PDF, JPEG y PNG.',
      SUPPORT_TYPE_INPUT_LABEL: 'Tipo de problema',
      LIFECYCLE_MAINTAINANCE: 'Mantenimiento del ciclo de vida',
      LIFECYCLE_MAINTENANCE: 'Mantenimiento del ciclo de vida',
      LOCATION: 'Ubicación(es)',
      LOW: 'Bajo',
      MAINTENANCE_HISTORY: 'Historial de mantenimiento',
      MAINTENANCE_REQUEST: 'Solicitud de mantenimiento',
      MEDIUM: 'Medio',
      NO_CUSTOMER_LINKED: 'Ningún cliente vinculado',
      NO_DOC_ADDED: 'No se agregó documentación',
      NO_MAINTENACE_FOUND: 'No se encontró ningún mantenimiento',
      NO_NOTES_ADDED: 'No se agregaron notas',
      NOTES: 'Notas',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_INVALID_FILE_SIZE: 'Uno o más archivos superan el límite de tamaño de 2 MB.',
      PAST_DUE: 'Vencido',
      PRIORITY: 'Prioridad',
      STATUS_REJECTED: 'Rechazado',
      REOPEN_SERVICE_TICKET: 'Reabrir ticket de servicio',
      REQUEST_PRIORITY_INPUT_LABEL: 'Solicitud de prioridad',
      REQ_MAINTENANCE: 'Mantenimiento solicitado',
      REQUESTED_MAINTAINANCE: 'Mantenimiento solicitado',
      SCHEDULED: 'Programado',
      STATUS_SCHEDULED: 'Programado',
      SCH_SERVICE_DATE: 'Fecha de servicio programada',
      SEARCH: 'Buscar por número de ticket',
      SERVICE_DATE: 'Fecha de servicio',
      SERVICE_TICKET_NO: 'Número de ticket de servicio',
      SERVICE_TYPE: 'Tipo de servicio',
      SUPPORT_TECHNICIAN: 'Técnico de soporte',
      SYS_FAILURE: 'Fallo del sistema',
      SYSTEM_FAILURE: 'Fallo del sistema',
      TICKET_CLOSED: 'Boleto cerrado',
      TICKET_NO: 'Número de billete',
      STATUS: 'Estado del ticket:Todos',
      TODAY: 'HOY',
      UPLOAD_DOCUMENT_ERROR_MESSAGE_MAX_3_FILES: 'Sólo puedes seleccionar hasta 3 archivos.',
      EDIT_SERVICE_TICKET: 'Editar ticket de servicio',
      MAINTENANCE_OPERATIONS: 'Operaciones de mantenimiento',
      SCHEDULED_MAINTENANCE: 'Mantenimiento programado',
      RECENT_MAINTENANCE: 'Mantenimiento reciente',
      CLOSE_SERVICE_TICKET: 'Cerrar ticket de servicio',
      CLOSE_TICKET: 'Cerrar ticket',
      DESCRIBE_ACTION: 'Describa las acciones tomadas para resolver el problema.',
      TICKET_RESOLUTION: 'Resolución de tickets',
      CLOSED_BY: 'Cerrado por',
},
    ASSETS_DETAILS: {
      ADD_BUILDINGS: '+ Agregar edificio',
      ADD_SYSTEMS: '+ Agregar sistema',
      NEW_MAINTAINENCE: '+ Nuevo mantenimiento',
      BUILDINGS: 'Edificios',
      CUSTOMER_MAINTAINENCE_HEADER: 'Datos del cliente',
      CUSTOMER_INFO_HEADER: 'Información del cliente',
      DOWNLOAD_AS: 'Descargar como…',
      FIRMWARE: 'Firmware',
      GATEWAYS: 'gateway',
      LINK_TO_CUSTOMER_BUTTON: 'Enlace al cliente',
      MAIN_CONTACT: 'Contacto principal',
      RIGHT_MAINTAINENCE_HEADER: 'Detalles de mantenimiento',
      MOST_RECENT_STATUS: 'Estado más reciente',
      NOTIFY_USERS_MAINTAINENCE_HEADER: 'Notificar a los usuarios:',
      SUBHEADER_TEXT_MAINTAINENCE: 'Revise la información, asigne un técnico e incluya cualquier detalle útil para solucionar el problema.',
      PREVIOUS_SYSTEM_STATUS: 'Estado anterior del sistema',
      CREATE_MAINTAINENCE_HEADER: 'Programar una nueva operación de mantenimiento',
      ADD_BUILDING_ASSET: 'Seleccione una organización para crear un edificio',
      SELECT_ORGANIZATION_LABEL: 'Seleccionar organización',
      SHOW_FAVORITE_BUILDINGS: 'Mostrar solo edificios destacados',
      SHOW_FAVORITE_GATEWAYS: 'Mostrar solo las pasarelas destacadas',
      SHOW_FAVORITE_SYSTEMS: 'Mostrar solo sistemas destacados',
      SLA_SUBTITLE: 'Acuerdo de nivel de servicio n.º',
      LEFT_MAINTAINENCE_HEADER: 'Detalles del sistema',
      SYSTEM_NAME_TYPE_SUBTITLE: 'Nombre y tipo de sistema',
      SYSTEMS: 'Sistemas',
      HELPER_TEXT_MAINTAINENCE: 'Esta solicitud alertará a los contactos principal y secundario de {{customerName}}. Incluirá información relevante sobre la ubicación, el dispositivo, la alarma y el evento de forma predeterminada.',
      NO_CUSTOMER_TEXT: 'Este sistema no ha sido vinculado a ningún cliente',
      CONFIG_LUMNS_DECS: 'Puedes pegar datos de Excel directamente en esta tabla.',
},
    COMMON: {
      REQUIRES_FIRMWARE_UPDATE: '1 requiere actualización de firmware',
      NOTIFICATION_REPORT_MESSAGE_BODY: 'Hay un nuevo informe mensual para: \n {{bodytext}} disponible para ver',
      ACCESS: 'Acceso',
      ACTIVE: 'Activo',
      ALERT: '¡Alerta!',
      DOWNLOAD_PERMISSION: 'Permitir los permisos para guardar el archivo en su dispositivo',
      GO_BACK: 'Volver',
      NOTIFICATION_EVENT_OCCURED: 'Se ha producido un error {{logType}} con el siguiente sistema',
      ASSETS: 'Activos',
      BACK: 'Atrás',
      BLOCKED: 'OBSTRUIDO',
      CANCEL: 'Cancelar',
      CANNOT_REFRESH_TOKEN: 'No se puede actualizar el token',
      CLOSE: 'Cerca',
      SET_ETHERNET: 'Configurar los ajustes del puerto',
      CONFIRM: 'Confirmar',
      CONNECT: 'Conectar',
      CONNECTION: 'Conexión',
      CSV: 'CSV',
      DASHBOARD: 'Panel',
      DESCRIPTION: 'Descripción',
      DISCARD: 'Desechar',
      DISCARD_UNSAVED_CHANGE: '¿Descartar los cambios no guardados?',
      DONE: 'Hecho',
      DOWNLOAD: 'Descargar',
      DOWNLOAD_FAILED: 'Descarga fallida, por favor intente nuevamente',
      COMPANY: 'Comer',
      EDIT: 'Editar',
      APP_NAME: 'Gerente de seguridad de edificios',
      EMPTY: 'VACÍO',
      EXCEL: 'Archivo de Excel',
      EXIT: 'Salida',
      EXTEND: 'Extender',
      DOWNLOAD_SUCCESS: 'Archivo descargado exitosamente.',
      ANOMALY: 'EN ANOMALÍA',
      INACTIVE: 'Inactivo',
      INCOMPLETE: 'Incompleto',
      INFO: 'Información',
      INTERVAL: 'Intervalo',
      KEEP_EDITING: 'Seguir editando',
      LAST_RETREIVED: 'Última recuperación:',
      LAST_RETRIEVED: 'Última recuperación: -- hace min',
      LINK: 'Enlace',
      LOCATE: 'Localizar',
      LOGBOOK: 'Cuaderno',
      LOGGED_IN_SUCCESSFULLY: 'Inició sesión correctamente',
      NOTIFICATION_NEW_REPORT_AVAILABLE: 'Nuevo informe disponible',
      NEWUSER: 'Nuevo usuario',
      NEXT: 'Próximo',
      NODATA: 'Sin datos',
      OFF: 'apagado',
      OFFLINE: 'Desconectado',
      OK: 'De acuerdo',
      ON: 'en',
      PASSWORD: 'Contraseña',
      PDF: 'PDF',
      SELECT_PREFERRED_LANGUAGE: 'Por favor seleccione su idioma preferido',
      POWERED_BY_BRIGHTLAYER: 'Desarrollado por Brightlayer',
      READY: 'LISTO',
      RECOONECTTOGATWAY: 'Reconectarse a la gateway',
      REFRESH: 'Refrescar',
      REMOVE: 'Eliminar',
      RETURNTODASHBOARD: 'Regresar al panel de control',
      NAVIGATION_HEADER: 'Sistema de gestión de seguridad',
      SAVE: 'Ahorrar',
      REFRESH_TOKEN_ERROR: 'El token de seguridad no debe ser nulo ni estar vacío',
      SESSION_ALERT_TITLE: 'Tiempo de espera de la sesión',
      SET: 'Colocar',
      SETTINGS: 'Ajustes',
      VIEW_ALL_SYSTEM: 'Mostrar todo',
      SKIP: 'Saltar',
      STOP: 'Detener',
      PERMISSION_ERROR: 'Permiso de almacenamiento no concedido',
      SYNC: 'Sincronizar',
      SYNCH_OFFLINE_DATABASE: 'Sincronizar base de datos sin conexión',
      SYSTEM: 'Sistema',
      SESSION_ALERT_SUBTITLE: 'Esta ventana ha estado inactiva durante 15 minutos. Si no se realiza ninguna acción en {{extendTime}}, se cerrará la sesión.',
      TIME: 'Tiempo',
      TRYAGAIN: 'Intentar otra vez',
      DOWNLOAD_FAIL: 'No se puede descargar, inténtalo de nuevo.',
      UNAUTHORIZED_ACCESS: 'Acceso no autorizado',
      UNLINK: 'Desconectar',
      USERS: 'Usuarios',
      VIEW: 'Vista',
      WELCOME: 'Bienvenido',
      YES: 'Sí',
      EMPTY_SYSTEM_TITLE: 'Aún no tienes activos en esta organización.',
      EMPTY_SYSTEM_SUBTITLE: 'Verá información sobre el estado de sus luces de emergencia una vez que comience a agregar activos (sistemas) a esta organización.',
      ERROR_OCCURED: 'Se produjo un error en',
      OOPS: '¡Ups!',
      THERE_IS_ERROR: 'Hay un error',
      NEW_VERSION_AVAILABLE: 'Nueva versión de la aplicación disponible en',
      UNDER_MAINTENANCE: 'La aplicación se encuentra actualmente en mantenimiento.',
      UNDER_MAINTENANCE_TITLE: 'Aplicación en mantenimiento',
      UPDATE_AVAILABLE_TITLE: 'Actualización disponible',
      UPDATE_REQUIRED_TITLE: 'Se requiere actualización',
      UPDATE_NOW: 'Actualizar ahora',
      ASK_ME_LATER: 'Pregúntame más tarde',
      EMPTY_TRIGGERS_LINE: 'No se han configurado activadores opcionales.',
      ASSIGN: 'Asignar',
      OKTA_LOGOUT_ALERT: '¿Estás seguro de que deseas cerrar sesión en Okta?',
      OKTA_LOGIN_BUTTON: 'Iniciar sesión con Okta',
      CANNOT_PROCCED_LOGIN: 'Eres un usuario no autorizado. Regístrate.',
      UNAUTHORIZED_ACCESS_OKTA: 'Error de autorización',
      SCAN: 'Escanear',
      NO: 'No',
      ACKNOWLEDGE: 'Reconocer',
      SAVED_SUCCESSFULLY: 'Guardado correctamente',
      SWITCHED_ON: 'ENCENDIDO',
      FAN_BYPASS_ON: 'Desvío del ventilador activado',
      HOUR: 'Hora',
      MINUTES: 'Minutos',
      SAVE_UPDATES: 'Guardar actualizaciones',
      CHARGER: 'Cargador',
      SETUP: 'configuración',
      DAYS: 'Días',
      INTENET_ERR_MSG: 'Ya no estás conectado a Internet. Por favor, conéctate a Internet.',
      LOADER_SUBTITITLE: 'Este proceso puede tardar hasta 60 segundos...',
      BEFORE: 'Antes',
      INVITE_MYSELF: 'Invitarme a mí mismo',
      MINUTE: 'minuto',
      AGO: 'atrás',
      UP_TO_DATE: 'A hoy',
      RESET_SERVICE_COUNTER_DESCRIPTION: 'Utilice “Restablecer contador de servicio” para confirmar la hora/día en que se realizó el mantenimiento del sistema.',
      DATE_OF_SERVICE: 'Fecha de servicio',
      SET_SERVICE_REMINDER: 'Establecer recordatorio de servicio',
      MONTH: 'meses',
      OPERATION_SCHEDULE_SUCCESSFULLY: 'Operación programada con éxito',
      SECONDS: 'Artículos de segunda clase',
      VALID_EMAIL_ERROR: 'Por favor, introduzca un correo electrónico válido',
      INPUT_NUMBER: 'Número de entrada',
      TEXT_MODE: 'Modo',
      INVALID_CONFIGURATION: 'Configuración no válida',
      SYNC_REALTIME_TO_CLOUD: 'Sincronizar datos con la nube',
      OK_CAPS: 'DE ACUERDO',
      SUBLOCATION: 'sububicación',
      CREATED: 'creado',
      UPDATED: 'actualizado',
      HOURS: 'horas',
      TRANSFER_LUMINARIES: 'Transferir',
      ROOTED_DEVICE_ALERT_TITLE: '¡¡¡Advertencia de seguridad!!!',
      ROOTED_DEVICE_ALERT_MSG: 'Este dispositivo parece estar rooteado. No se puede usar la aplicación BSMS Mobile con él.',
      INTERVAL_DT: 'Cada {{testIntervalsDT}} meses',
      INTERVAL_FT: 'Cada {{testIntervalsFT}} días',
      EDIT_SYSTEM: 'Sistema de edición',
      TRIGGERS: 'Desencadenantes',
      SELECTED: 'Seleccionado',
      NAME: 'Nombre',
},
    PASSWORD_REQUIREMENTS: {
      LENGTH: '8-16 caracteres',
      LOWER: 'Una letra minúscula',
      NUMBERS: 'Un numero',
      SPECIAL: 'Un personaje especial',
      UPPER: 'Una letra mayúscula',
},
    AUTH_TRANSLATION: {
      FORGOT_PASSWORD: {
        LINK_SENT_ALT: 'Se ha enviado un enlace para restablecer su contraseña a <1>{{email}}</1>.',
        LINK_SENT: 'Se ha enviado un enlace para restablecer su contraseña a <b>{{email}}</b>.',
        ERROR: 'No se pudo restablecer su contraseña en este momento.',
        INSTRUCTIONS_ALT: 'Por favor ingrese el correo electrónico de la cuenta asociada a la cuenta',
        INSTRUCTIONS: 'Por favor ingrese el correo electrónico de la cuenta asociada a la cuenta. \nSi este correo electrónico tiene una cuenta con Eaton, recibirá una respuesta dentro de <b>un día hábil</b>.\nPara problemas urgentes de cuenta, llame al  {{teléfono}}.',
        RESET_CODE_ERROR: ' Hubo un error con su código de reinicio.',
},
      MESSAGES: {
        USER_PHONE_NUMBER_INVALID: 'Un número de teléfono no es válido',
        CONGRATS: '¡Felicidades!',
        CONTACT: 'Comuníquese con un representante de soporte de Eaton',
        EMAIL_SENT: 'Correo electrónico enviado',
        ERROR: '¡Error!',
        FAILURE: 'Fallo',
        INVALID_VERIFICATION_CODE: 'El código de verificación no es válido o la longitud debe ser inferior a 6 caracteres',
        LOADING: 'Cargando...',
        GENERIC_ERROR_MESSAGE: 'Comuníquese con su administrador si no se puede completar la operación solicitada.',
        EMAIL_ENTRY_ERROR: 'Por favor, introduzca un correo electrónico válido',
        USER_EMAIL_INVALID: 'Proporcione una dirección de correo electrónico válida.',
        REQUEST_ERROR: 'Lo sentimos, hubo un problema al enviar su solicitud.',
        SUCCESS: 'Éxito',
        WELCOME: 'Bienvenido',
        LOGIN_MESSAGE: 'Estás \'conectado\'',
},
      CHANGE_PASSWORD: {
        PROBLEM_OCCURRED: 'Ocurrió un problema:',
        CANCEL: 'Cancelar',
        PASSWORD: 'Cambiar la contraseña',
        CONFIRM_NEW_PASSWORD: 'Confirmar nueva contraseña',
        OLD_PASSWORD: 'Contraseña anterior',
        PASSWORD_CHANGED: 'Contraseña cambiada',
        PASSWORD_INFO: 'La contraseña debe tener al menos 8 caracteres, contener al menos un carácter en mayúscula, un carácter en minúscula, un número y un carácter especial.',
        UPDATE: 'Actualizar',
        EMAIL_CONFIRM_MESSAGE: 'Hemos enviado un correo electrónico de confirmación a <b>{{email}}</b>',
        ERROR_MESSAGE: 'Su información no coincide con nuestros registros. Vuelva a ingresar su información para intentarlo nuevamente.',
        SUCCESS_MESSAGE: '¡Tu contraseña se actualizó correctamente! Para garantizar la seguridad de tu cuenta, deberás iniciar sesión en la aplicación con tus credenciales actualizadas.',
},
      SELF_REGISTRATION: {
        VERIFY_EMAIL: {
          MESSAGE: 'Se ha enviado un código de verificación a la dirección de correo electrónico que has proporcionado. Haz clic en el enlace o introduce el código que aparece a continuación para continuar. Este código es válido durante 30 minutos.',
          VERIFICATION_CODE_PROMPT: '¿No recibiste un código?',
          RESEND: 'Reenviar correo electrónico de verificación',
          VERIFICATION: 'Código de verificación',
},
        ALREADY_REGISTERED_USER: 'Usuario ya registrado',
        INSTRUCTIONS: 'Para registrarse en una cuenta Eaton, ingrese la información requerida a continuación. Deberá verificar su dirección de correo electrónico para continuar.',
},
      REGISTRATION: {
        STEPS: {
          COMPLETE: '¡Cuenta creada!',
          ACCOUNT_DETAILS: 'Detalles de la cuenta',
          COMPANY_ADDRESS: 'Dirección de la empresa',
          COMPANY_DETAILS: 'Datos de la empresa',
          CREATE_ACCOUNT: 'Crear una cuenta',
          PASSWORD: 'Crear contraseña',
          LICENSE: 'Acuerdo de licencia',
          VERIFY_EMAIL: 'Verificar correo electrónico',
},
        EULA: {
          DEUTSCH: 'Alemán',
          ENGLISH: 'Inglés',
          AGREE_TERMS: 'He leído y acepto los Términos y Condiciones',
          LANGUAGE_SUCCESS: 'Idioma actualizado exitosamente',
          LOADING: 'Cargando el Acuerdo de Licencia de Usuario Final...',
},
        INSTRUCTIONS: {
          ACCOUNT_DETAILS: 'Ingrese sus datos a continuación para completar la creación de la cuenta.',
          COMPANY_DETAILS: 'Esto ayuda a Eaton a brindar soporte de servicio para su solución de iluminación de emergencia. Si está iniciando un proyecto para su cliente, incluya la información de su propia empresa, no de la de su cliente.',
          COMPANY_ADDRESS: 'Esto ayuda a Eaton a brindar soporte de servicio para su solución de iluminación de emergencia. Si está iniciando un proyecto para su cliente, incluya la información de su propia empresa, no de la de su cliente.',
},
        UNKNOWN_EMAIL: 'Correo electrónico desconocido',
        UNKNOWN_ORGANIZATION: '-',
        FAILURE_MESSAGE: 'No pudimos completar tu registro. Pulsa "Continuar" a continuación para finalizar.',
        SUCCESS_MESSAGE_ALT: 'Su cuenta ha sido creada exitosamente con el correo electrónico <1>{{email}}</1>.\nSu cuenta ya ha sido agregada a la organización <3>{{organization}}</3>.\nPresione continuar abajo para finalizar.',
        SUCCESS_MESSAGE: 'Su cuenta ha sido creada con éxito {{state}} con el correo electrónico {{email}}.\n\nUsted ha sido agregado a {{organization}}.\',',
        SUCCESS_EXISTING: 'Su cuenta se ha creado correctamente. Inicie sesión con el correo electrónico y la contraseña de su cuenta Eaton.',
        SUCCESS_SYNCED_MESSAGE: 'Su cuenta de EL Digital se ha sincronizado exitosamente con la información de Bright Layer Cloud asociada con el correo electrónico <b>{{email}}</b>.',
        SUCCESS_FINISH: 'Haga clic en "Finalizar" para iniciar sesión y acceder a su cuenta.',
        SUCCESS_DASHBOARD: 'Haga clic en "Ir a mi panel de control" para continuar con su cuenta.',
},
      ACTIONS: {
        BACK: 'Atrás',
        CANCEL: 'Cancelar',
        CHANGE_LANGUAGE: '¡Cambia el idioma aquí!',
        CLICK_BUTTON: 'Haga clic en el botón',
        UPDATE_REDUX: '¡Haga clic en el botón para actualizar el valor de la tienda redux!',
        CONTINUE: 'Continuar',
        DONE: 'Hecho',
        FINISH: 'Finalizar',
        GO_HOME: 'Ir a Inicio',
        GO_DASHBOARD: 'Ir a mi panel de control',
        GO_TEST: 'Ir a la página de prueba',
        LOG_IN: 'Acceso',
        LOG_OUT: 'Finalizar la sesión',
        NEXT: 'Próximo',
        OKAY: 'Bueno',
        REMEMBER: 'Acuérdate de mí',
        RESEND: 'Reenviar',
        SEND_AGAIN: 'Enviar de nuevo',
        SEND_EMAIL: 'Enviar correo electrónico',
        CREATE_ACCOUNT: 'Inscribirse',
        UPDATE: 'Actualizar',
},
      FORMS: {
        COMPANY_NAME: 'nombre de empresa',
        CONFIRM_PASSWORD: 'confirmar Contraseña',
        COUNTRY: 'País',
        CURRENT_PASSWORD_ERROR: 'La contraseña actual no coincide',
        FIRST_NAME: 'Nombre de pila',
        RESET_PASSWORD: 'Has olvidado tu contraseña',
        LAST_NAME: 'Apellido',
        ORGANAIZATION_ADRESS: 'Dirección de la organización Línea 1*',
        PASSWORD: 'Contraseña',
        PASS_MATCH_ERROR: 'Las contraseñas no coinciden',
        PHONE_NUMBER: 'Número de teléfono',
        TOGGLE_PASSWORD_VISIBILITY: 'Activar o desactivar la visibilidad de la contraseña',
},
      LABELS: {
        CURRENT_PASSWORD: 'Contraseña actual',
        EMAIL: 'Dirección de correo electrónico',
        FORGOT_PASSWORD: 'Olvidaste tu contraseña ?',
        NEED_ACCOUNT: '¿Necesitas una cuenta?',
        NEW_PASSWORD: 'Nueva contraseña',
        OPTIONAL: 'Opcional',
        PASSWORD: 'Contraseña',
        USERNAME: 'Nombre de usuario',
},
      LOGIN: {
        INCORRECT_CREDENTIALS: 'Correo electrónico o contraseña incorrectos',
        GENERIC_ERROR: 'Su solicitud no pudo ser procesada en este momento.',
        INVALID_CREDENTIALS: 'No se reconoce su combinación de nombre de usuario y contraseña.',
},
      GATEWAY_COMMISSION_STEP: {
        STEP_NUMBER: 'Paso {{stepNo}} de 4',
},
      BLEDEVICE_COMMISSION_STEP: {
        STEP_NUMBER: 'Paso {{stepNo}} de {{totalSteps}}',
},
      TLUATPLUS_COMMISSION_STEP: {
        STEP_NUMBER: 'Paso {{stepNo}} de 3',
},
},
    REGISTRATION: {
      STEPS_MESSAGE: {
        CREATE_ACCOUNT_VERIFY_EMAIL: 'Se ha enviado un código de verificación a la dirección de correo electrónico que has proporcionado. Haz clic en el enlace o introduce el código que aparece a continuación para continuar. Este código es válido durante 30 minutos.',
        CREATE_ACCOUNT_USER_DETAILS: 'Ingrese sus datos a continuación para completar la creación de la cuenta.',
        CREATE_ACCOUNT_COMPANY_DETAILS: 'Esto ayuda a Eaton a brindar soporte de servicio para su solución de iluminación de emergencia. Si está iniciando un proyecto para su cliente, incluya la información de su propia empresa, no de la de su cliente.',
        CREATE_ACCOUNT_ENTER_EMAIL: 'Para registrarse y obtener una cuenta en el Sistema de gestión de seguridad, ingrese la información solicitada a continuación. Deberá verificar su dirección de correo electrónico para continuar.',
},
      STEPS: {
        COMPLETE_OTHER_ADOPTER: '¡Cuenta confirmada!',
        COMPLETE: '¡Cuenta creada!',
        ACCOUNT_DETAILS: 'Detalles de la cuenta',
        COMPANY_ADDRESS: 'Dirección de la empresa',
        COMPANY_DETAILS: 'Datos de la empresa',
        CREATE_ACCOUNT: 'Crear una cuenta',
        PASSWORD: 'Crear contraseña',
        FORGOT_PASSWORD: 'Has olvidado tu contraseña',
        LICENSE: 'Acuerdo de licencia',
        VERIFY_EMAIL: 'Verificar correo electrónico',
},
      STEPS_ERROR_MESSAGE: {
        USER_ALREADY_EXIST_MESSAGE: 'Usuario ya registrado',
        USER_INVALID_ENTRY: 'Los parámetros de entrada no pueden ser nulos o vacíos.',
        GENERIC_ERROR_MESSAGE: 'Comuníquese con su administrador si no se puede completar la operación solicitada.',
        USER_EMAIL_INVALID: 'Proporcione una dirección de correo electrónico válida.',
        VERIFICATION_CODE_EXPIRED_MESSAGE: 'El código ha expirado. Haga clic en el botón a continuación para solicitar otro correo electrónico de verificación.',
},
      EULA: {
        LOADING: 'Cargando el Acuerdo de Licencia de Usuario Final...',
        LANGUAGE: 'Por favor seleccione su idioma preferido',
        FRENCH: 'Francés',
},
      FAILURE_MESSAGE: 'No pudimos completar su registro. Presione continuar a continuación para continuar con la suite Eaton ELDigital',
      SUCCESS_MESSAGE: 'Su cuenta ha sido creada exitosamente con el correo electrónico {{email}}.',
      SUCCESS_MESSAGE_OTHER_ADOPTER: 'Su cuenta de EL Digital se ha sincronizado exitosamente con la información de Bright Layer Cloud asociada con el correo electrónico <2>{{email}}</2>.',
},
    USER_INVITATION_REGISTRATION: {
      ACCEPT: 'Aceptar',
      DENY: 'Denegar',
      INSTRUCTIONS: ' Si este correo electrónico tiene una cuenta con Eaton, recibirá una respuesta dentro de <3>un día hábil</3>.<br/><br/>Para problemas urgentes con la cuenta, llame al',
      TITLE: 'Sistema de Gestión de Seguridad - Invitación de Usuario',
      INVITATION_VALIDATION_ERROR: ' Hubo un error con tu código de invitación.',
},
    DASHBORAD: {
      ACCEPT_BUTTON: 'Aceptar invitación',
      ACCEPT_HEADER: '¿Aceptar invitación?',
      ACCEPTED_INVITATION: 'Invitaciones aceptadas',
      ACCEPT_TITLE: 'Al aceptar la invitación se agregará el siguiente elemento a tu perfil:',
      ADD_NEW_ORGANIZATION: 'Agregar una nueva organización...',
      ADD_ANOTHER_ORGANIZATION: 'Agregar otra organización',
      ALL_BUILDINGS: 'Todos los edificios',
      ALL_CITIES: 'Todas las ciudades',
      ALL_COMPANIES: 'Todas las empresas',
      ALL_COUNTRIES: 'Todos los países',
      ALL_CUSTOMER_ID: 'Todos los ID de clientes',
      ALL_GATEWAYS: 'Todas las gateways',
      ALL_ORGANIZATIONS: 'Todas las organizaciones',
      ALL_STATUSES: 'Todos los estados',
      ALL_STATUS: 'Todos los estados',
      ALL_TYPES: 'Todos los tipos',
      BLOCKED: 'Obstruido',
      BUILD_DETAILS: 'Detalles del edificio',
      BUILDINGS: 'Edificios',
      CUSTOMERS: 'Clientes',
      DECLINE: 'Rechazar',
      DECLINED_INVITATION: 'Invitaciones rechazadas',
      DISPLAY_ADDRESS_ON_MAP: 'Mostrar dirección en el mapa',
      MAP_DRAG_TITLE: 'Arrastre sobre el mapa para colocar el pin',
      REQUEST_ACCESS_SENT: 'Solicitud de acceso por correo electrónico enviada al usuario',
      ERROR: 'Error',
      EVENT: 'Evento',
      EXPIRED_INVITATION: 'Invitaciones vencidas',
      EXPORT_REPORT: 'Informe de exportación',
      GATEWAY: 'gateway',
      IN_ANOMALY: ' En Anomalía',
      INFORMATION: 'Información',
      INVITATION_HISTORY: 'Historial de invitaciones',
      ISSUES: 'asuntos',
      JOIN: 'Unirse',
      LIST_VIEW: 'Vista de lista',
      MAP_VIEW: 'Vista del mapa',
      MONTHLY_REPORT: 'Informe mensual',
      NO_ISSUES_DURING_THIS_PERIOD: 'No hay problemas durante este período',
      ORG_DETAILS: 'Detalles de la organización',
      PENDING_INVITATION: 'Invitaciones pendientes',
      CHOOSE_REPORT_YOU_WOULD_LIKE_TO_SAVE_SHARE: 'Por favor seleccione el informe que desea guardar o compartir.',
      PLEASE_MAKE_A_SELECTIONS: 'Por favor haga una selección',
      REQUEST_SUBTITLE: 'Solicite acceso a la persona que le envió la invitación para agregar este elemento a su perfil.',
      INVITATION_BODY: 'Seleccione los elementos que desea agregar a su perfil o rechazar una invitación.',
      READY: 'Listo',
      NO_CONTENT: 'Reemplace esta página con su propio contenido',
      REPORTS: 'Informes',
      REQUEST_BUTTON: 'Solicitar acceso',
      REQUEST_HEADER: '¿Solicitar acceso?',
      CHECK_INVITATIONS: ' Buscando invitaciones...',
      SELECT_ALL: 'Seleccionar todo',
      SELECTIONS_CONFIRMED: 'Selecciones confirmadas',
      SERVICE_MANAGERS: 'Gerentes de servicios',
      SYSTEMS: 'Sistemas',
      TECHNICIANS: 'Técnicos',
      EMPTY_ACCEPTED_INVITATION: 'No hay invitaciones aceptadas en este momento',
      EMPTY_DECLINED_INVITATION: 'No hay invitaciones rechazadas en este momento.',
      EMPTY_EXPIRED_INVITATION: 'No hay invitaciones vencidas en este momento.',
      EMPTY_REQUESTED_INVITATION: 'No hay invitaciones solicitadas en este momento',
      REQUEST_TITLE: 'Esta invitación ha expirado y ya no se puede agregar a tu perfil.',
      TOTAL_ACCEPTED_INVITATIONS: 'Total de invitaciones aceptadas',
      TOTAL_LUMINAIRES: 'Luminarias Totales',
      TOTAL_SYSTEMS: 'Sistemas totales',
      UPDATING_PROFILE: 'Actualizando tu perfil...',
      VIEW_ALL: 'Ver todo',
      VIEW_ALL_ACCESS_RIGHTS: 'Ver todos los derechos de acceso',
      VIEW_ALL_BUIDINGS: 'Ver todos los edificios',
      VIEW_ALL_SYSTEM: 'Ver todos los sistemas',
      WARNING: 'Advertencia',
      INVITATION_SUB_HEADING: 'Has sido invitado a los siguientes proyectos:',
      REPORTS_BUILDINGS: 'Edificios',
      REPORTS_SYSTEMS: 'Sistemas',
      EMPTY_ZONE: 'Vacío',
      TEST_ZONE: 'Prueba',
      RESERVED: 'Reservar',
},
    TRANSFER_BUILDINGS: {
      PASSWORD: 'Contraseña de la cuenta',
      ERRORMESSAGE: 'Se excedieron los límites de inicio de sesión. Inténtelo nuevamente después de un tiempo.',
      HEADER: 'Transferir permanentemente todos los {{buildingCount}} edificios, incluidas todas las X gateway y {{systemCount}} sistemas que se encuentran debajo de ellos, a otra organización. Debe ser administrador de ambas organizaciones para realizar la acción.',
      ACTION: 'Escriba la contraseña de su cuenta para confirmar la acción.',
      TRANSFER_TO: 'Transferir a…',
},
    MERGE_ASSETS: {
      PASSWORD: 'Contraseña de la cuenta',
      MERGE_DELETE: 'Fusionar y eliminar',
      MERGE_ASSETS_TITLE: 'Fusionar activos a otro edificio',
      SUCCESS: 'Los activos del edificio se fusionaron correctamente',
      ACTION: 'Escriba la contraseña de su cuenta para confirmar la acción.',
      HEADER: 'Transfiera todas las {{gatewayCount}} gateway y {{systemCount}} sistemas debajo de ella a otro edificio y elimine permanentemente el actual.',
      TRANSFER_TO: 'Transferir a...',
},
    DRAWER: {
      ACCOUNTPREFERENCES: 'Preferencias de la cuenta',
      RIGHTS_RESERVED: 'Reservados todos los derechos',
      ASSETS: 'Activos',
      COPYRIGHT: 'Derechos de autor © Eaton',
      DASHBOARD: 'Panel',
      OVERVIEW: 'Panel',
      DEVICES: 'Dispositivos',
      HELP: 'Ayuda',
      HELPANDFEEDBACK: 'Ayuda y comentarios',
      LEGAL: 'Legal',
      LOCATIONS: 'Ubicaciones',
      LOGBOOK: 'Cuaderno',
      MAINTENANCE: 'Mantenimiento',
      MANAGELOCATION: 'Administrar ubicaciones y sitios',
      MANAGEUSER: 'Administrar usuarios',
      ORGSETTINGS: 'Mis organizaciones',
      MYPROFILE: 'Mi perfil',
      REPORTS: 'Informes',
      ELDIGITAL: 'Sistema de gestión de seguridad',
      SELECT_ACCOUNT: 'Seleccionar cuenta',
      SETTINGS: 'Ajustes',
      TIMELINE: 'Cronología',
      USERS: 'Usuarios',
},
    SETTINGS: {
      TITLE: 'Preferencias de la cuenta',
      SUBTITLE: 'Nivel de administrador: usuarios',
},
    NAVIGATION_DRAWER: {
      ACCOUNT_PREFERENCES: 'Preferencias de la cuenta',
      ALL_RIGHTS_RESERVED: 'Reservados todos los derechos',
      CHANGE_PASSWORD: 'Cambiar la contraseña',
      COPYRIGHT: 'Derechos de autor',
      HELP_AND_FEEDBACK: 'Ayuda y comentarios',
      LEGAL: 'Legal',
      LOGOUT: 'Cerrar sesión',
      PROJECT_SETTINGS: 'Mis organizaciones',
      REPORTS: 'Informes',
      USERS: 'Usuarios',
},
    USER_MENU: {
      ACCOUNT_SETTING: 'Configuraciones de la cuenta',
      CONTACT_US: 'Contáctenos',
      LOG_OUT: 'Finalizar la sesión',
},
    USER_DETAIL: {
      ACTIVE: 'ACTIVO',
      COMPANY_ADRESS: 'Dirección de la empresa',
      COMPANY_DETAIL: 'Datos de la empresa',
      COMPANY_NAME: 'nombre de empresa',
      COMPANY_PHONE_NUMBER: 'Número de teléfono de la empresa',
      EMAIL_ID: 'Dirección de correo electrónico',
      INACTIVE: 'INACTIVO',
      PERSONAL_ADRESS: 'Título del puesto',
      LEAVE_ORGANISATION: 'Dejar la organización',
      JOB_TITLE: 'Dirección personal',
      PERSONAL_PHONE_NUMBER: 'Número de teléfono personal',
      PHONE_NUMBER: 'Número de teléfono',
      REMOVE_USER: 'Eliminar usuario',
      USER_NAME: 'Nombre de usuario',
},
    FILTER: {
      ACTIVE_LOGS_ONLY: 'Solo registros activos',
      ALL: 'Todo',
      ALL_LOG_TYPES: 'Todos los tipos de registros',
      CUSTOM: 'Costumbre...',
      PAST_TWELVE_MONTHS: 'Últimos 12 meses',
      PAST_SIX_MONTHS: 'Últimos 6 meses',
      SINCE_THE_BEGINNING_OF_YEAR: 'Desde principios de {{currentyear}}',
},
    LOGBOOK: {
      LOGBOOK_ACTIVELOG: 'Solo registros activos',
      LOGBOOK_ALL: 'Todo',
      LOGBOOK_ALLLOG: 'Todos los tipos de registros',
      CUSTOM_LOGBOOK_RANGE: 'Gama de libros de registro personalizados',
      CUSTOM: 'Costumbre...',
      END_DATE: 'Fecha de finalización',
      LOGBOOK_GROUPBY: 'Agrupar por :',
      PAST_TWELVE_MONTHS: 'Últimos 12 meses',
      PAST_SIX_MONTHS: 'Últimos 6 meses',
      FILTER_DOWNLOAD_TEXT: 'Por favor aplique un filtro para descargar el libro de registro.',
      LOGBOOK_SHOW: 'Espectáculo :',
      SINCE_THE_BEGINNING_OF_YEAR: 'Desde principios de {{currentyear}}',
      START_DATE: 'Fecha de inicio',
      LOGBOOK_TIME_RANGE: 'Intervalo de tiempo:',
},
    BUILDING_DETAILS: {
      ADD_BUILDING: 'Añadir edificio a',
      ALL_SYSTEMS: 'Todos los sistemas',
      VIEW_ALL_GATEWAYS: 'Ver todas las pasarelas',
},
    ADD_ORGANIZATION: {
      ORG_ADD_DESCRIPTION: 'Agregue comentarios adicionales opcionales para ayudar a su equipo de servicio.',
      ADDITIONAL_DESC: 'Descripción adicional',
      ORG_ADD_BLDG_BELONGS: 'pertenece.',
      CREATE_ORGANIZATION_TITLE: 'Crear organización',
      ORG_SUBTITLE: 'La creación de una organización permite agrupar edificios y coordinar la supervisión de los sistemas EL.',
      DETAILS_FOR: 'Detalles para',
      ORG_FOR: 'para',
      INVALID_CHARACTER: 'Caracter inválido',
      ORG_NAMELENGTH: ' Solo letras, números, guiones bajos y guiones',
      ORG_ADD_BLDG: ' Ahora vamos a agregar el edificio donde se encuentra el',
      ORGANIZATION_CREATED: 'Organización creada',
      VALID_EMAIL_ERROR: 'Por favor, introduzca un correo electrónico válido',
      ORG_PRIMARYCONTACT: 'Contacto principal',
      ORG_PROVIDED_DETAILS: 'Proporcionar detalles en caso de que sea necesario xxx.',
      ORG_SECONDARYCONTACT: 'Contacto secundario (opcional)',
      ORG_SKIPBUTTON: 'Saltar por ahora',
      ORG_SKIPMESSAGE: 'Vaya a completar los datos de contacto individualmente para cada edificio.',
      ORG_SUCCESS: 'Organización creada con éxito',
      ALPHABET_INPUT: 'Toma el alfabeto como entrada',
      ALPHANUMERIC_INPUT: 'Toma alfanuméricos como entrada',
      ALPHANUMERIC_DASH_UNDERSCORE_INPUT: 'Acepta caracteres alfanuméricos, guiones y guiones bajos como entrada',
      ORG_HELPTEXT: 'Esto ayuda a que los electricistas de Eaton y otros fuera de su empresa lleguen rápidamente al sitio.',
      ORGANIZATION_DETAILS: '¿A quién deben contactar los electricistas?',
},
    MANAGE_USERS: {
      ADVANCED_INVITE_USER_ORGANIZATION_SELECTION: 'Agregarlos a las organizaciones:',
      INVITE_USER_ORGANIZATION_LABEL: 'Añadir a la organización... *',
      USER_ROLE_ADMIN: 'Administración',
      ADVANCED_INVITE_ADMIN: ' Administración:',
      ADVANCED_INVITE: 'Invitación avanzada',
      INVITE_USER_ADVANCE: 'Avanzado…',
      INVITE_USER_AS: 'Como',
      ADVANCED_INVITE_USER_SELECTION: 'Elija un usuario nuevo o existente:',
      INVITE_USER_EMAIL_NAME: 'Correo electrónico *',
      INVITE_USER_EMAIL: 'Correo electrónico *',
      INVITE_USER_EMAIL_USER_NAME: 'Correo electrónico o nombre de usuario *',
      INVITE_USER_SUBTITLE: 'Otorgar acceso a usuarios nuevos o existentes',
      ADVANCED_INVITE_SUBTITLE: 'Otorgar acceso a organizaciones, edificios y sistemas específicos.',
      ADVANCED_INVITE_ADMIN_DESCRIPTION: 'conceder acceso completo a todo dentro del nivel asignado.',
      ADVANCED_INVITE_LIMITED_DESCRIPTION: 'Otorgar privilegios de visualización mínimos para que un usuario solo vea información básica que sea fundamental para su función. Esto resulta útil cuando alguien solo necesita supervisar un sistema dentro de un edificio.',
      ADVANCED_INVITE_VIEWER_DESCRIPTION: 'otorgar privilegios de visualización a todo lo que esté dentro de un nivel asignado.',
      INVITATION_FAIL_HEADER: 'Invitación expirada',
      INVITE_USER_AS_COLLEAGUE: 'Invitar como colega',
      INVITE_USER: 'Invitar usuario',
      INVITE_SUCCESS_MESSAGE_SINGLE: 'Se invitó a {{email}} a {{organization}}.',
      INVITE_SUCCESS_MESSAGE_MULTIPLE: 'Se invitó a {{email}} a {{organizationCount}} organizaciones.',
      USER_ROLE_LIMITED: 'Limitado',
      ADVANCED_INVITE_LIMITED: ' Limitado:',
      MY_DETAILS_HEADER: 'Mis datos',
      OTHER_USER_LIST_HEADER: ' Otros usuarios',
      ADVANCED_INVITE_PLEASE_ASSIGN_ROLES: 'Asigne roles para el acceso de {{email}} a organizaciones, edificios y sistemas.',
      REMOVE_USER: '¿Quitar {{name}} de "{{title}}"?',
      INVITATION_REQUEST_ACTION: 'Solicitar otra invitación',
      INVITE_USER_ORGANIZATION_SELECT_ALL: 'Seleccionar todo',
      INVITE_USER_SEND_INVITE: 'Enviar invitación',
      INVITATION_FAIL_BODY: 'Este enlace de invitación por correo electrónico ha expirado. Comuníquese con el administrador del sistema para recibir otra invitación por correo electrónico.',
      USERS_IN_HEADER: ' Usuarios en',
      USER_ROLE_VIEWER: 'Espectador',
      ADVANCED_INVITE_VIEWER: ' Espectador:',
      NOT_APPLICABLE_SLASH: 'N / A',
},
    ORGANIZATION_DETAILS: {
      ADDRESS: 'DIRECCIÓN',
      BUILDING_DETAILS: 'Detalles del edificio',
      DELETE_FOREVER: 'Borrar para siempre',
      EDIT_BUILDING: 'Editar edificio',
      EDIT_ORGANIZATION: 'Editar organización',
      EMAIL_ADDRESS: 'Dirección de correo electrónico',
      MERGE_ASSETS: 'Fusionar activos a otro edificio',
      ORGANIZATION: 'Organización',
      ORGANIZATION_DETAILS: 'Detalles de la organización',
      PHONE_NUMBER: 'Número de teléfono',
      PRIMARY_CONTACT: 'Contacto principal',
      PRIMARY_CONTACT_EMAIL_ADDRESS: 'Dirección de correo electrónico de contacto principal',
      PRIMARY_CONTACT_PHONE_NUMBER: 'Número de teléfono de contacto principal',
      SECONDARY_CONTACT: 'Contacto secundario',
      SECONDARY_CONTACT_EMAIL_ADDRESS: 'Dirección de correo electrónico de contacto secundaria',
      SECONDARY_CONTACT_PHONE_NUMBER: 'Número de teléfono de contacto secundario',
      TRANSFER_BUILDINGS: 'Transferir edificios a otra organización',
      USERS: 'Usuarios',
},
    COMMON_INPUT: {
      COMMON_ADDRESS: 'DIRECCIÓN',
      COMMON_ADDRESSLINE2: 'Línea de dirección 2 (opcional)',
      COMMON_BUILDINGNAME: 'Nombre del edificio',
      COMMON_CITY: 'Ciudad',
      COMMON_COUNTRY: 'País',
      COMMON_OPTIONALDESC: 'Descripción (opcional)',
      COMMON_EMAIL_ADDRESS: 'Dirección de correo electrónico',
      COMMON_NAME: 'Nombre de la organización',
      COMMON_PHONENUMBER: 'Número de teléfono',
      VALID_ADDRESS: 'Por favor, introduzca una dirección válida',
      VALID_PHONE_ERROR: 'Por favor, introduzca un número de teléfono válido',
      VALID_POSTAL_CODE: 'Por favor, introduzca un código postal válido',
      VALID_CITY_ERROR: 'Por favor ingrese una ciudad válida',
      VALID_COMPANY_ERROR: 'Por favor ingrese una empresa válida',
      VALID_FIRSTNAME_ERROR: 'Por favor, introduzca un nombre válido',
      VALID_LASTNAME_ERROR: 'Por favor ingrese un apellido válido',
      VALID_VERIFICATION_CODE: 'Por favor, introduzca un código de verificación válido',
      COMMON_POSTALCODE: 'Código Postal',
},
    TOAST_MSG: {
      CREATE_CUSTOMER_ERROR_CODE_9069: 'La dirección no es válida o la longitud debe ser menor o igual a 250 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9070: 'La dirección 2 no es válida o la longitud debe ser menor o igual a 250 caracteres',
      INVITE_TECHNICIAN_ERROR_CODE_9130: 'Se requieren derechos de administrador para invitar al usuario',
      INVITE_USER_ERROR_CODE_9130: 'Se requieren derechos de administrador para invitar al usuario.',
      TOAST_ERROR_MERGE_ASSET_9213: 'Se requieren derechos de administrador para fusionar activos',
      TOAST_SUCCESS_BUILDING_CREATE: 'Edificio creado exitosamente',
      BUILDING_LIST_API_FAILURE: 'Falló el listado de edificios',
      BUILDING_TRANSFER_FAILURE: 'Se produjo un error al transferir el edificio',
      BUILDING_TRANSFER_SUCCESS: 'La transferencia del edificio se realizó con éxito',
      TOAST_SUCCESS_BUILDING_UPDATE: 'Edificio actualizado exitosamente',
      INVITE_USER_ERROR_CODE_9143: 'No se puede degradar el rol del usuario.',
      CREATE_CUSTOMER_ERROR_CODE_9072: 'La ciudad no es válida o la longitud debe ser menor o igual a 50 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9164: 'El comentario de la empresa no es válido o la longitud debe ser menor o igual a 255 caracteres.',
      CREATE_CUSTOMER_ERROR_CODE_9040: 'El código de país de la empresa no es válido',
      CREATE_CUSTOMER_ERROR_CODE_9170: 'Nombre de la empresa ya disponible.',
      CREATE_CUSTOMER_ERROR_CODE_9023: 'El número de teléfono de la empresa no es válido o la longitud debe estar entre 8 y 10',
      CREATE_CUSTOMER_ERROR_CODE_9073: 'El código de país no es válido o la longitud debe ser menor o igual a 4 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9068: 'El país no es válido o la longitud debe ser menor o igual a 50 caracteres',
      CREATE_MAINTAINANCE_API_FAILURE: 'Error al crear la API de mantenimiento',
      TOAST_SUCCESS_CUSTOMER_CREATED: 'Cliente creado exitosamente',
      CUSTOMER_DETAIL_SUCCESS: 'Detalle del cliente recuperado exitosamente',
      TOAST_ERROR_GET_CUSTOMER_INFO: 'La recuperación de los datos del cliente no ha sido exitosa',
      CREATE_CUSTOMER_ERROR_CODE_9225: 'Número de cliente ya disponible.',
      CREATE_CUSTOMER_ERROR_CODE_9172: 'El número de cliente no es válido o la longitud debe estar entre 8 y 16 caracteres.',
      CREATE_MAINTAINANCE_ERROR_CODE_9078: 'La descripción no es válida o la longitud debe ser menor o igual a 255 caracteres',
      DEVICE_LIST_API_FAILURE: 'Error en la lista de dispositivos',
      ACKNOWLEDGE_LOG_SUCCESS: 'Los detalles del registro del dispositivo se reconocieron correctamente',
      CREATE_CUSTOMER_ERROR_CODE_9043: 'El correo electrónico no es válido o la longitud debe ser menor o igual a 75 caracteres',
      INVITE_TECHNICIAN_ERROR_CODE_9043: 'El correo electrónico no es válido o la longitud debe ser menor o igual a 75 caracteres',
      INVITE_USER_ERROR_CODE_9043: 'El correo electrónico no es válido o la longitud debe ser menor o igual a 75 caracteres',
      INVITE_TECHNICIAN_ERROR_CODE_9136: 'El tipo de entidad o rol no es una entrada válida o no coincide el tipo de entidad y el tipo de rol',
      INVITE_USER_ERROR_CODE_9136: 'El tipo de entidad o rol no es una entrada válida o no coincide el tipo de entidad y el tipo de rol.',
      INVITE_TECHNICIAN_ERROR_CODE_9127: 'EntityId está duplicado o la entrada no es válida',
      INVITE_USER_ERROR_CODE_9127: 'EntityId está duplicado o la entrada no es válida',
      TOAST_ERROR_BUILDING_UPDATE: ' No se pudo ejecutar la actualización del edificio',
      CREATE_MAINTAINANCE_ERROR_CODE_9219: 'El nombre del archivo no es válido o la longitud debe ser menor o igual a 50 caracteres',
      TOAST_ERROR_GET_PASS_DETAILS: 'Error en la obtención de detalles de PAAS',
      REMOVE_ACCESS_ERROR_CODE_3057: 'Identificación de entidad no válida. Proporcione una identificación de entidad válida.',
      REMOVE_ACCESS_ERROR_CODE_3059: 'Tipo de entidad no válido. Proporcione un tipo de entidad válido',
      TOAST_ERROR_LINK_CUSTOMER_9203: 'Enumeración de TIPO SLA no válida.',
      REMOVE_ACCESS_ERROR_CODE_2007: 'ID de usuario no válida, proporcione un GUID válido',
      INVITE_TECHNICIAN_ERROR_CODE_9159: 'La invitación y la invitación del usuario no deben ser iguales',
      INVITE_USER_ERROR_CODE_9159: 'La invitación y la invitación del usuario no deben ser iguales',
      UPDATE_LOG_COMMENTS_SUCCESS: 'Los comentarios del registro se actualizaron correctamente',
      ACKNOWLEDGE_LOG_API_FAILURE: 'Reconocimiento de registros fallido',
      CREATE_MAINTAINANCE_SUCCESS: 'Actividad de mantenimiento creada con éxito',
      TOAST_ERROR_MERGE_ASSET_9214: 'No hay activos para fusionar',
      CREATE_MAINTAINANCE_ERROR_CODE_9221: 'El número de documento debe ser menor o igual a 3',
      TOAST_SUCCESS_ORG_CREATE: 'Organización creada exitosamente',
      TOAST_ERROR_ORG_UPDATE: 'La organización falló',
      TOAST_SUCCESS_ORG_UPDATE: 'Organización actualizada exitosamente',
      CREATE_CUSTOMER_ERROR_CODE_9074: 'El número de teléfono no es válido o la longitud debe estar entre 8 y 10.',
      TOAST_ERROR_MESSAGE: 'Por favor, rellene todos los detalles correctamente antes de enviar.',
      CREATE_MAINTAINANCE_ERROR_CODE_9220: 'Proporcione una identificación de usuario válida para el técnico asignado',
      TOAST_ERROR_MERGE_ASSET_9048: 'Proporcione una identificación de edificio válida.',
      CREATE_CUSTOMER_ERROR_CODE_9167: 'Proporcione un tipo de contacto válido.',
      CREATE_MAINTAINANCE_ERROR_CODE_9185: 'Proporcione una identificación de cliente válida',
      TOAST_ERROR_MERGE_ASSET_9210: 'Proporcione una identificación de edificio de destino válida.',
      CREATE_MAINTAINANCE_ERROR_CODE_9217: 'Proporcione un enlace válido',
      CREATE_CUSTOMER_ERROR_CODE_9163: 'Proporcione un nombre válido o la longitud debe ser menor o igual a 24 caracteres',
      CREATE_MAINTAINANCE_ERROR_CODE_9215: 'Proporcione un tipo de solicitud válido',
      CREATE_MAINTAINANCE_ERROR_CODE_9228: 'Proporcione una fecha de servicio válida',
      CREATE_MAINTAINANCE_ERROR_CODE_9216: 'Proporcione un tipo de servicio válido',
      CREATE_MAINTAINANCE_ERROR_CODE_9050: 'Proporcione un ID de sistema válido',
      CREATE_CUSTOMER_ERROR_CODE_9071: 'El código postal no es válido o la longitud debe estar entre 4 y 10 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9165: 'El comentario del contacto principal no es válido o la longitud debe ser menor o igual a 255 caracteres.',
      CREATE_CUSTOMER_ERROR_CODE_9175: 'El código de país principal2 no es válido o la longitud debe ser menor o igual a 4 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9150: 'El nombre principal no es válido o la longitud debe estar entre 1 y 50 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9151: 'El apellido principal no es válido o la longitud debe estar entre 1 y 50 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9173: 'El teléfono principal2 no es válido o la longitud debe estar entre 8 y 10.',
      REMOVE_ACCESS_SUCCESS: 'La eliminación de usuario se completó con éxito',
      TOAST_ERROR_MERGE_ASSET_9004: 'Datos solicitados no encontrados',
      CREATE_CUSTOMER_ERROR_CODE_9166: 'El comentario de contacto secundario no es válido o la longitud debe ser menor o igual a 255 caracteres.',
      CREATE_CUSTOMER_ERROR_CODE_9076: 'El código de país secundario no es válido o la longitud debe ser menor o igual a 4 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9176: 'El código de país secundario2 no es válido o la longitud debe ser menor o igual a 4 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9077: 'El correo electrónico secundario no es válido o la longitud debe ser menor o igual a 75 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9152: 'El nombre secundario no es válido o la longitud debe estar entre 1 y 50 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9153: 'El apellido secundario no es válido o la longitud debe estar entre 1 y 50 caracteres',
      CREATE_CUSTOMER_ERROR_CODE_9147: 'El número de teléfono secundario no es válido o la longitud debe estar entre 8 y 10.',
      CREATE_CUSTOMER_ERROR_CODE_9174: 'El número de teléfono secundario2 no es válido o la longitud debe estar entre 8 y 10.',
      CREATE_MAINTAINANCE_ERROR_CODE_9009: 'El token de seguridad no debe ser nulo ni estar vacío',
      CREATE_MAINTAINANCE_ERROR_CODE_9222: 'Se requieren derechos de administrador de servicios para crear una actividad de mantenimiento',
      CREATE_MAINTAINANCE_ERROR_CODE_9162: 'El número de SLA no es válido o la longitud debe estar entre 6 y 12 caracteres',
      INVITE_TECHNICIAN_ERROR_CODE_9158: 'Algunas entidades tienen roles limitados por los roles invitados',
      INVITE_USER_ERROR_CODE_9158: 'Algunas entidades tienen roles limitados a partir de los roles invitados.',
      INVITE_TECHNICIAN_ERROR_CODE_9160: 'Algunas entidades tienen un papel limitado en la solicitud de invitación.',
      INVITE_USER_ERROR_CODE_9160: 'Algunas entidades tienen un papel limitado en la solicitud de invitación.',
      TOAST_ERROR_MERGE_ASSET_9211: 'Los identificadores de los edificios de origen y destino son los mismos',
      TOAST_ERROR_MERGE_ASSET_9212: 'La construcción de fuentes y la construcción de destinos no están bajo la misma organización',
      TOAST_ERROR_LINK_CUSTOMER_9204: 'Sistema ya vinculado a SLA válido',
      INVITE_USER_ERROR_CODE_9223: 'El usuario actual solo puede enviar invitaciones a usuarios normales.',
      INVITE_USER_ERROR_CODE_9224: 'El usuario actual no puede enviar invitaciones al administrador de servicios ni al administrador de PAAS.',
      CREATE_MAINTAINANCE_ERROR_CODE_9218: 'El documento tiene más de 2 MB o está duplicado o es un PDF, JPEG o PNG codificado en Base64 no válido',
      REMOVE_ACCESS_ERROR_CODE_9001: 'Acceso no autorizado',
      CREATE_CUSTOMER_ERROR_CODE_9001: 'Acceso no autorizado',
      CREATE_MAINTAINANCE_ERROR_CODE_9001: 'Acceso no autorizado',
      CREATE_CUSTOMER_ERROR_CODE_9000: 'Acceso a funciones no autorizadas',
      UPDATE_LOG_COMMENTS_API_FAILURE: 'Error al actualizar los comentarios del registro',
      REMOVE_ACCESS_ERROR_CODE_3060: 'El usuario no puede eliminar el acceso propio',
      TOAST_ERROR_UPDATE_USER_DETAILS: 'La actualización de los detalles del usuario no se ha realizado correctamente',
      INVITE_USER_ERROR_CODE_9142: 'El usuario ha sido invitado para el mismo rol.',
      INVITE_TECHNICIAN_SUCCESS: 'Invitación de usuario enviada con éxito',
      TOAST_ERROR_MERGE_ASSET_9044: 'La contraseña del usuario no es válida o la longitud debe estar entre 8 y 16 caracteres',
      INVITE_TECHNICIAN_ERROR_CODE_9190: 'El tipo de rol de usuario no es una entrada válida',
      INVITE_USER_ERROR_CODE_9190: 'El tipo de rol de usuario no es una entrada válida.',
      TOAST_SUCCESS_UPDATE_USER_DETAILS: 'Usuario actualizado exitosamente',
      UPDATE_MAINTAINANCE_SUCCESS: 'Actividad de mantenimiento actualizada con éxito',
      UPDATE_MAINTAINANCE_ERROR_CODE_9001: 'Acceso no autorizado',
      UPDATE_MAINTAINANCE_ERROR_CODE_9009: 'El token de seguridad no debe ser nulo ni estar vacío',
      UPDATE_MAINTAINANCE_ERROR_CODE_9078: 'La descripción no es válida o la longitud debe ser menor o igual a 255 caracteres.',
      UPDATE_MAINTAINANCE_ERROR_CODE_9222: 'Se requieren derechos de Gerente de servicio o Técnico para realizar esta operación',
      UPDATE_MAINTAINANCE_ERROR_CODE_9227: 'Proporcione una identificación de mantenimiento válida',
      UPDATE_MAINTAINANCE_ERROR_CODE_9245: 'La actividad de mantenimiento ya tiene el mismo estado de ticket actual que el solicitado para la actualización',
      UPDATE_MAINTAINANCE_ERROR_CODE_9246: 'Se alcanzó el límite de reapertura de la actividad de mantenimiento',
      UPDATE_MAINTAINANCE_API_FAILURE: 'Error en la actualización de la API de mantenimiento',
      TICKET_CLOSED_SUCCESS: 'Ticket de servicio cerrado exitosamente',
},
    MY_ORGANIZATION_DETAILS: {
      ADDRESS_Line1: 'Dirección Línea 1',
      ADMINS: 'Administradores',
      DELETE_FOREVER: 'Borrar para siempre',
      DESCRIPTION: 'Descripción (opcional)',
      EDIT_BUILDING: 'Editar edificio',
      EDIT_ORGANIZATION: 'Editar organización',
      NAME_DESCRIPTION: 'Nombre y descripción',
      SAVE_ORGANIZATION: 'Guardar organización',
      TRANSFER_BULDING_ANOTHER_ORGANIZATION: 'Transferir edificios a otra organización',
      VIEWER: 'Espectadores',
},
    INVITE_USER: {
      ADMIN: 'Administración',
      ADVANCE_INVITATION: 'Invitación anticipada',
      ADVANCE_INVITE: 'Avanzado...',
      ADVANCE_INVITE_CLOSE: '¿Está seguro de que desea salir de la Invitación avanzada?',
      AS_ADMIN: 'Como administrador',
      AS_VIEWER: 'Como espectador',
      BUILDING_ACCESS: 'Acceso al edificio',
      ENTER_USER_EMAIL: 'Correo electrónico o nombre de usuario',
      GRANT_ACCESS_HEADER: 'Otorgar acceso a usuarios nuevos o existentes.',
      ADVANCE_DES_CONTENT: 'Otorgar acceso a los usuarios para acceso específico a organizaciones, edificios y sistemas.',
      GRANT_ADMIN_ACCESS: 'Otorgar acceso completo a todo dentro del nivel asignado.',
      GRANT_VIEW_ACCESS: 'Otorgar privilegios de visualización a todo lo que esté dentro de un nivel asignado.',
      SEND_INVITE_FAILURE: 'El envío de la invitación falló',
      SEND_INVITE_SUCCESS: 'Invitación enviada exitosamente',
      INVITATION_ACCEPTED: 'Invitación aceptada exitosamente.',
      INVITATION_DENIED: 'Invitación rechazada exitosamente.',
      INVITE_AND_ASSIGN: 'Invitar y asignar',
      INVITE_AS_COLLEGUE: 'Invitar como colega',
      INVITE_USER: 'Invitar usuario',
      LIMITED: 'Limitado',
      GRANT_LIMITED_ACCESS: 'Privilegios mínimos, esto es útil para un usuario que solo necesita monitorear un sistema dentro de un edificio.',
      NOBUILDING_AVAILABLE: 'No hay edificios disponibles',
      NOSYSTEMS_AVAILABLE: 'No hay sistemas disponibles',
      ORGANIZATION_ACCESS: 'Acceso a la organización',
      SELECT_ORGANIZATION: 'Por favor seleccione una Organización',
      PRIVILEGES: 'Privilegios',
      RECEIVED: 'Recibió',
      SEND_INVITE: 'Enviar invitación',
      SENT_BY: 'Enviado por',
      SYSTEM_ACCESS: 'Acceso al sistema',
      VIEWER: 'Espectador',
      ERROR_MESSAGE: 'Su solicitud ha sido rechazada',
      SEND_INVITE_SUCCESS_COUNT: 'El conde invitado exitosamente es: {{count}}',
      SEND_INVITE_FAILURE_COUNT: 'El número de invitaciones fallidas es: {{count}}',
      SEND_INVITE_STATUS: 'Enviar estado de invitación',
},
    DISCLAMIER: {
      OVERVIEW: 'El recuento de alarmas representa todas las alarmas activas',
      TIMELINE: 'Las alarmas mostradas representan todas las alarmas durante los últimos 90 días',
},
    LUMINARY_DETAILS: {
      ALL_ATSD: 'Todos los ATSD',
      ALL_CIRCUIT: 'Todo el circuito',
      ALL_STATUSES: 'Todos los estados',
      ATSD: 'ATSD #',
      CIRCUIT: 'Circuito',
      LUMINAIRE_ADDRESS: 'Dirección de la luminaria',
      MODEL: 'Modelo',
      TYPE: 'Tipo',
      TESTS: 'Pruebas',
      CIRCUIT_TITLE: 'N.° de circuito',
      LUMINARY_DETAILS: 'Detalles de la luminaria',
      CGLINEID: 'ID de CGLine+',
      MODEL_NAME: 'Nombre del modelo',
      MODEL_DESCRIPTION: 'Descripción del modelo',
      DURATION_TEST_DURATION: 'Duración de la prueba',
      PREVIOUS_DURATION_TEST_STARTED: 'Prueba de duración anterior iniciada',
      FUNCTIONAL_TEST_DURATION: 'Duración de la prueba funcional',
      PREVIOUS_FUNCTIONAL_TEST_STARTED: 'Prueba funcional anterior iniciada',
      LINE: 'Línea',
      ZONE: 'Zona',
      LINES: 'Pauta',
      LUMINAIRES_TOTAL: 'total de luminarias',
      ZONES: 'Zonas',
      CHARGE_FAILURE: 'Fallo de carga',
      FT_FAILURE: 'Falla de FT',
      DT_FAILURE: 'Falla de DT',
      CGLINE_VERSION_CORTEX: 'Versión Cortex',
      CGLINE_VERSION_XMEGA: 'Versión xMega',
      CGLINE_VERSION_BOOTLOADER: 'Versión del cargador de arranque',
      CGLINE_VERSION_SDCARD: 'Versión SDCard',
      TEST_GROUP: 'Grupo de prueba',
      LBL_EVERY: 'Cada',
      DURATION_RESULT: 'Resultado de la duración',
      RATED_DURATION: 'Duración nominal',
      NUMBER_OF_NEIGHBORS: 'Número de vecinos',
      RADIO_SIGNAL: 'Señal de radio',
      GOOD_SIGNAL: 'Buena señal',
      BAD_SIGNAL: 'Mala señal',
      NO_SIGNAL: 'Sin señal',
      AVERAGE_SIGNAL: 'Señal promedio',
      EXCELLENT_SIGNAL: 'Excelente señal',
      RADIO_FIRMWARE_VERSION: 'Versión del firmware de la radio',
      EPAS_Number: 'Número EPAS',
      LUMINARIE_NAME: 'Nombre de la luminaria',
      RADIO: 'Radio',
      EPAS: 'EPAS',
      TEST_PASSED: 'Prueba aprobada',
      TEST_FAILED: 'Prueba fallida',
},
    SEARCH: {
      ALL_BUILDINGS: 'Todos los edificios',
      ALL_GATEWAYS: 'Todas las gateways',
      ALL_ORGANIZATIONS: 'Todas las organizaciones',
      ALL_STATUSES: 'Todos los estados',
      ALL_SYSTEMS: 'Todos los sistemas',
      ALL_TYPES: 'Todos los tipos',
},
    CUSTOMER_DETAILS: {
      ALL_USERS: 'Todos los usuarios',
      DELETE_SLA: '¿Estás seguro de que deseas eliminar el SLA?',
      BACK_UP_PHONE: 'Teléfono de respaldo',
      BUYER_HEADER: 'Comprador',
      BUYER: 'Comprador',
      CONTACT_TYPE: 'Tipo de contacto',
      CONTACT_PERSON_ON_SITE: 'Persona de contacto en el sitio',
      CUSTOMER_HEADER_SUBTITLE: 'Cliente',
      CUSTOMER_ID: 'Identificación del cliente',
      CUSTOMER_NAME: 'Nombre del cliente.',
      CUSTOMER_DETAILS_HEADER: 'Nombre y dirección del cliente',
      CUSTOMER_NAME_LABEL: 'Nombre o número del cliente',
      CUSTOMER_NUMBER: 'Número de cliente',
      DELETE_CUSTOMER: 'Eliminar cliente',
      LUMINARY_INFO: '¿Este contrato incluye la monitorización de luminarias?',
      EDIT_CUSTOMER_INFO: 'Editar información del cliente',
      CREATE_CUSTOMER_HEADER: 'Editar información del cliente',
      EDIT_PLATFORM_INFO: 'Editar información de la plataforma',
      EDIT_SLA_DETAILS: '-',
      EXPIRES: 'Caduca',
      IMAGES: 'Imágenes',
      INCLUDE_LUM_MONITORING: 'Incluir monitorización de luminarias',
      SLA_DETAILS_TEXT: 'Monitorización de luminarias incluida',
      CALENDAR_HELPER_TEXT: 'mm/dd/aaaa',
      MOBILE_NUMBER: 'Número de teléfono móvil.',
      LUMINARY_MONITORING_NO: 'No',
      NO_CUSTOMER_FOUND: 'No se encontró ningún cliente',
      NO_SERVICE_MANAGER_FOUND: 'No se encontró ningún administrador de servicios',
      NO_TECHNICIAN_FOUND: 'No se encontró ningún técnico',
      CUSTOMER_NUMBER_HELPER_TEXT: 'Solo alfabetos y números',
      SLA_NUMBER_HELPER_TEXT: 'Solo alfabetos y números',
      OFFICE_NUMBER: 'Número de oficina.',
      IMAGE_REQUIREMENTS: 'PNG, JPG (100x100px), 2 MB máx.',
      PHONE_NUMBERS_HEADER: 'Números de teléfono principales y de respaldo',
      PRIMARY_CONTACT_INFO: 'Información de contacto principal',
      PROJECT_LEAD: 'Líder del proyecto',
      REMOVE_IMAGE: 'Eliminar imagen',
      SECONDARY_CONTACT_INFO: 'Información de contacto secundaria',
      FILE_RESOLUTION_ERROR: 'El archivo seleccionado no coincide con la resolución deseada',
      FILE_SIZE_ERROR: 'El tamaño de archivo seleccionado excede el tamaño máximo de archivo permitido',
      SERVICE_MANAGER: 'Gerente de servicio',
      SLA_CUSTOMER_NUMBER: 'Número de cliente de SLA',
      SLA_DETAILS_HEADER: 'Detalles del contrato de nivel de servicio',
      SLA_EXPIRATION_DATE: 'Fecha de vencimiento del SLA',
      TECH_LEAD_HEADER: 'Líder técnico',
      TECHNICAL_PERSON: 'Persona técnica',
      UPLOAD_AVATAR_LOGO: 'Subir el logotipo de Avatar',
      LUMINARY_MONITORING_YES: 'Sí',
      REQUIRED_FIELD_MESSAGE: 'Los campos con un asterisco (*) son obligatorios.',
      ENTER_VALID_NAME: 'Solo letras, números, guiones bajos y guiones.',
      CUSTOMER_ADDRESS: 'Dirección del cliente.',
      USE_ORGANIZATION_ADDRESS: 'Usar la dirección de la organización.',
      NUMBER_ONLY: 'Solo números.',
      PHONE_NUMBERS_DETAILS: 'Números de teléfono y detalles.',
      COMMENTS_HELP: 'Comentarios para ayudar a los técnicos a llegar al sitio.',
      SECONDARY_CONTACT: 'Contacto secundario (opcional).',
      EDIT_MAIN_BUILDING: 'Editar "Edificio principal".',
      DISCARD_MESSAGE: '¿Descartar cambios?',
      EDIT_ALERT_MESSAGE: '¿Se perderán todos los cambios?',
      CUSTOMER_DETAILS_UPDATE_SUCCESS: 'Los datos del cliente se actualizaron correctamente.',
      CUSTOMER_DETAILS_UPDATE_FAIL: 'No se pudieron actualizar los datos del cliente.',
},
    USER_MANAGEMENT: {
      ALL_USERS: 'Todos los usuarios',
      INVITE_USER: 'Invitar usuario',
      YOUR_DETAILS: 'Tus datos',
},
    USERDETAILS: {
      DELETE_USER_SUBHEADER: 'Todos sus datos de usuario se perderán de forma permanente.',
      RESET_PASSWORD_ERROR: 'No se pudo restablecer su contraseña en este momento.',
      DELETE_USER_BUTTON_TEXT: 'Eliminar cuenta para siempre',
      DELETE_USER_FAILURE_MSG: 'No se pudo eliminar. Inténtelo después de un tiempo.',
      DELETE_USER_POP_UP_HEADER: '¿Eliminar permanentemente la cuenta “{{email}}”?',
      RESET_PASSWORD_SUCCESS: 'El correo electrónico de restablecimiento de contraseña se envió correctamente.',
      EDIT_SUCCESS: 'Usuario actualizado exitosamente',
      DELETE_USER_SUCCESS_MSG: 'Su cuenta ha sido eliminada exitosamente',
},
    ATPLUS_LOGBOOK_EVENTNAME: {
      MAXIMUM_LOGIN_ATTEMPTS_EXCEDDED: 'Se superaron los intentos de inicio de sesión permitidos',
      BATTERY_CHARGE_FAILURE: 'Se detectó un fallo en la carga de la batería',
      BATTERY_DURATION_FAILURE: 'Se detectó un fallo en la duración de la batería',
      TLAT_PLUS_BATTERY_FAILURE: 'Fallo de la batería',
      TLAT_PLUS_BATTERY_LOW: 'Batería baja',
      COMMUNICATION_FAILURE: 'Fallo de comunicación detectado',
      DRY_CONTACT_INPUT: 'Entrada de contacto seco activada',
      DRY_CONTACT_OUTPUT: 'Salida de contacto seco activada',
      MANUAL_DURATION_TEST: 'Duración de la prueba iniciada',
      MANUAL_DURATION_TEST_CANCELED: 'Duración de la prueba detenida',
      FACTORY_RESET: 'Restablecimiento de fábrica',
      FAILURE_THRESHOLD_EXCEEDED: 'Umbral de fallo excedido',
      FIRMWARE_UPDATE_FAILURE: 'Error en la actualización del firmware',
      FIRMWARE_UPDATE_SUCCESS: 'Actualización de firmware exitosa',
      MANUAL_FUNCTION_TEST: 'Prueba de función iniciada',
      MODBUS_COMMUNICATION_FAILURE: 'Fallo de comunicación de la gateway',
      UART_COMMUNICATION_FAILURE: 'Fallo interna',
      LAMP_FAILURE: 'Se detectó fallo de lámpara',
      LOCAL_MAIN_FAILURE: 'Fallo de la red eléctrica local',
      PASSWORD_CHANGE: 'Cambio de contraseña',
      PASSWORD_RESET: 'Restablecer contraseña',
      MANUAL_RELIGHT_COMMAND: 'Reencendido activado',
      MANUAL_REST_COMMAND: 'Descanso activado',
      SEARCH_ALL_LAMP_COMPLETED: 'Buscar todas las lamparas completadas',
      SEARCH_NEW_LAMP_COMPLETED: 'Búsqueda de nueva lámpara completada',
      MANUAL_SYNCHRONIZE_TEST_TIME_COMMAND: 'Sincronizar los tiempos de prueba',
      ACTIVATION: 'Activación del sistema completada',
      SYSTEM_POWER_DOWN: 'Apagado del sistema',
      SYSTEM_POWER_UP: 'Encendido del sistema',
      DATALINE_FAILURE: 'Fallo de la línea de comunicación TLAT+',
      MANUAL_START_VISIBILITY_PLUS: 'Visibilidad + Iniciado',
      MANUAL_STOP_VISIBILITY_PLUS: 'Visibilidad + Detenido',
      START_MANUAL_FUNCTION_TEST: 'Inicio de la prueba de función manual',
      START_AUTOMATIC_FUNCTION_TEST: 'Inicio de la prueba de funcionamiento automático',
      END_FUNCTION_TEST: 'Fin de la prueba de funcionamiento',
      CANCEL_FUNCTION_TEST: 'Cancelar prueba de función',
      START_MANUAL_DURATION_TEST: 'Inicio de la prueba de duración manual',
      START_AUTOMATIC_DURATION_TEST: 'Inicio de la prueba de duración automática',
      END_DURATION_TEST: 'Fin de la prueba de duración',
      CANCEL_DURATION_TEST: 'Cancelar prueba de duración',
      LUMINAIRE_FAILURE_DC: 'Fallo de luminaria DC',
      CIRCUIT_CURRENT_I_MAX: 'Corriente de circuito I > Imax',
      CIRCUIT_FUSE_FAILURE: 'Fallo del fusible del circuito',
      CIRCUIT_ISO_FAILURE_PLUS: 'Circuito - Fallo ISO +',
      CIRCUIT_ISO_FAILURE_MINUS: 'Circuito - Fallo ISO -',
      GENERAL_ISO_FAILURE_PLUS: 'Fallo general de ISO +',
      GENERAL_ISO_FAILURE_MINUS: 'Fallo general de ISO -',
      ISO_FAILURE_ACKNOWLEDGED: 'Se reconoció el fallo de ISO',
      INTERRUPTION_BATTERY: 'Interrupción - batería',
      CHARGING_FAILURE: 'Fallo de carga',
      BATTERY_CAPACITY_FAILURE: 'Fallo de capacidad de la batería',
      DEEP_DISCHARGE_PROTECTION: 'Protección contra descargas profundas',
      RESET_DEEP_DISCHARGE_PROTECTION: 'Restablecer la protección contra descarga profunda',
      MAINS_FAILURE_AT_DEVICE_START: 'Fallo de red (en el dispositivo) Inicio',
      MAINS_FAILURE_AT_DEVICE_END: 'Fallo de red (en el dispositivo) Fin',
      MAINS_FAILURE_S3S4_START: 'Fallo de red (S3S4) Inicio',
      MAINS_FAILURE_S3S4_END: 'Fallo de red (S3S4) Fin',
      MAINS_FAILURE_3_PHASE_MONITOR_START: 'Fallo de red (monitor trifásico) Inicio',
      MAINS_FAILURE_3_PHASE_MONITOR_END: 'Fallo de red (monitor trifásico) Fin',
      BLOCKING_MENU_START: 'Bloqueo (menú) Inicio',
      BLOCKING_MENU_END: 'Bloqueo (menú) Fin',
      BLOCKING_S1S2_START: 'Bloqueo (S1S2) Inicio',
      BLOCKING_S1S2_END: 'Fin del bloqueo (S1S2)',
      BLOCKING_LON_BMS_START: 'Bloqueo (LON/BMS) Inicio',
      BLOCKING_LON_BMS_END: 'Fin del bloqueo (LON/BMS)',
      SWITCH_ON_SUPPLY: 'Encender el suministro',
      COMMUNICATION_FAULT_WITHIN_DEVICE_START: 'Fallo de comunicación dentro del arranque del dispositivo',
      COMMUNICATION_FAULT_WITH_DEVICE_END: 'Fallo de comunicación con el extremo del dispositivo',
      FAN_FAILURE_START: 'Inicio por fallo del ventilador',
      FAN_FAILURE_END: 'Fin de la falla del ventilador',
      FAILURE_EXT_ISO_MONITOR_START: 'Error al iniciar el Monitor ISO externo',
      FAILURE_EXT_ISO_MONITOR_END: 'Fallo Ext. Fin del monitor ISO',
      FAILURE_EXT_MONITOR_START: 'Inicio del monitor externo de falla',
      FAILURE_EXT_MONITOR_END: 'Extremo del monitor externo de falla',
      REQUEST_ALL_LUMINAIRES_ON_START: 'Solicitar el encendido de todas las luminarias',
      REQUEST_ALL_LUMINAIRES_ON_END: 'Solicitar el encendido de todas las luminarias',
      DCDC_CONVERTER_FAILURE: 'Fallo del convertidor DCDC',
      ISO_SWITCH_BROKEN: 'Interruptor ISO roto',
      CIRCUIT_IGBT_FAILURE: 'Fallo del circuito IGBT',
      ANALOG_VALUE_LOG: 'Registro de valores analógicos',
      AUXILIARY_VOLTAGE: 'Tensión auxiliar',
      AE_SCENARIO_ACTIVE_START: 'Inicio activo del escenario AE',
      AE_SCENARIO_ACTIVE_END: 'Fin activo del escenario AE',
      AE_FAILURE_START: 'Inicio de falla de AE',
      AE_FAILURE_END: 'Fin de falla de AE',
      FAILURE_TEMP_SENSOR_START: 'Falla de temperatura. Arranque del sensor',
      FAILURE_TEMP_SENSOR_END: 'Falla de temperatura. Sensor final',
      FT_NOT_POSSIBLE: 'FT no es posible',
      DT_NOT_POSSIBLE: 'DT no posible',
      TEST_MAINS_FAILURE_3_PHASE_MONITOR_START: 'Prueba de inicio de falla de red (monitor trifásico)',
      TEST_MAINS_FAILURE_3_PHASE_MONITOR_END: 'Prueba de fallo de red (monitor trifásico) final',
      CHANGE_BATTERY_CAPACITY: 'Cambiar la capacidad de la batería',
      CHANGE_BATTERY_EXPERTS_RELEASE: 'Los expertos en cambio de batería publican',
      CHANGE_DT_STOP_CONDITIONS: 'Cambiar las condiciones de parada del DT',
      MAINS_FAILURE_GROUP_DEVICE_START: 'Inicio del dispositivo del grupo de fallo de red',
      MAINS_FAILURE_GROUP_DEVICE_END: 'Fin del dispositivo del grupo de fallo de red',
      CRITICAL_BATTERY_TEMPERATURE: 'Temperatura crítica de la batería',
      DATE_MAINTENANCE_INTERVAL_CHANGED: 'Fecha en que se modificó el intervalo de mantenimiento',
      CHANGE_COMMISSIONING_DATE_BATTERY: 'Cambiar fecha de puesta en servicio de la batería',
      LOGBOOK_EVENT_NOT_DEFINED: 'Evento no definido',
      CONVERTER_FAILURE: 'Fallo del convertidor',
      ISOLATION_FAILURE: 'Fallo de aislamiento',
      TEST_RESULT_FOR_ISO_FAILURE_MONITOR: 'Resultado de la prueba de monitoreo de fallas ISO',
      START_FUNCTION_TEST_VISION_GUARD: 'Iniciar prueba de función Vision Guard',
      START_FUNCTION_TEST_MANUAL_BSMS: 'Manual de prueba de función de inicio BSMS',
      START_FUNCTION_TEST_AUTOMATIC: 'Prueba de función de inicio automática',
      START_FUNCTION_TEST_DRY_CONTACT: 'Prueba de función de inicio de contacto seco',
      END_OF_FUNCTION_TEST: 'Fin de la prueba de funcionamiento',
      START_DURATION_TEST_VISION_GUARD: 'Prueba de duración de inicio Vision Guard',
      START_DURATION_TEST_MANUAL_BSMS: 'Manual de prueba de duración de inicio BSMS',
      START_DURATION_TEST_AUTOMATIC: 'Prueba de duración de inicio automática',
      START_DURATION_TEST_DRY_CONTACT: 'Duración del inicio de la prueba de contacto seco',
      END_OF_DURATION_TEST: 'Fin de la prueba de duración',
      STOP_TEST_BSMS: 'Detener la prueba BSMS',
      STOP_TEST_VISION_GUARD: 'Detener la prueba Vision Guard',
      STOP_TEST_DRY_CONTACT: 'Detener la prueba de contacto seco',
      BLOCK_VISION_GUARD: 'Protector de visión de bloque',
      BLOCK_BSMS: 'Bloquear BSMS',
      BLOCK_DRY_CONTACT: 'Bloquear el contacto seco',
      RELEASE_VISION_GUARD: 'Liberar Vision Guard',
      RELEASE_BSMS: 'Liberar BSMS',
      RELEASE_DRY_CONTACT: 'Liberar contacto seco',
      START_INCREASE_AFFORDANCE_VISION_GUARD: 'Comience a aumentar la rentabilidad de Vision Guard',
      START_INCREASE_AFFORDANCE_BSMS: 'Comience a aumentar la asequibilidad del BSMS',
      START_INCREASE_AFFORDANCE_DRY_CONTACT: 'Comience a aumentar la accesibilidad del contacto seco',
      STOP_INCREASE_AFFORDANCE_VISION_GUARD: 'Detener el aumento de la asequibilidad Vision Guard',
      STOP_INCREASE_AFFORDANCE_BSMS: 'Detener el aumento de la asequibilidad BSMS',
      STOP_INCREASE_AFFORDANCE_DRY_CONTACT: 'Detener el aumento de la accesibilidad del contacto seco',
      SWITCH_MAINTAINED_LUMS_ON_VISION_GUARD: 'Interruptor mantenido Lums en Vision Guard',
      SWITCH_MAINTAINED_LUMS_ON_BSMS: 'Cambiar Lums mantenidos en BSMS',
      SWITCH_MAINTAINED_LUMS_ON_DRY_CONTACT: 'Interruptor mantenido Lums en contacto seco',
      SWITCH_MAINTAINED_LUMS_OFF_VISION_GUARD: 'Desactivar el interruptor de Lums mantenido Vision Guard',
      SWITCH_MAINTAINED_LUMS_OFF_BSMS: 'Desactivar los Lums mantenidos en BSMS',
      SWITCH_NON_MAINTAINED_LUMS_ON_BSMS: 'Cambiar Lums sin mantenimiento en BSMS',
      SWITCH_MAINTAINED_LUMS_OFF_DRY_CONTACT: 'Interruptor mantenido Lums apagado contacto seco',
      FIRMWARE_UPDATE_SUCCESS_CONTROLLER: 'Actualización de firmware del controlador exitosa',
      FIRMWARE_UPDATE_SUCCESS_RADIO_MESH: 'Actualización de firmware exitosa de la malla de radio',
      FIRMWARE_UPDATE_FAIL_CONTROLLER: 'Controlador con fallos de actualización de firmware',
      FIRMWARE_UPDATE_FAIL_RADIO_MESH: 'Error en la actualización del firmware de la malla de radio',
      NEW_FIRMWARE_AVAILABLE_RADIO_MESH: 'Nuevo firmware disponible para radio mesh',
      NEW_FIRMWARE_AVAILABLE_CONTROLLER: 'Nuevo firmware disponible para el controlador',
      SEARCH_ALL_LUMS: 'Buscar todos los Lums',
      COMMUNICATION_FAILURE_SUM: 'Fallo de comunicación SUM',
      LUMINAIRE_FAILURE_SUM: 'Fallo de luminaria SUM',
      BATTERY_FAILURE_SUM: 'Falla de batería SUM',
      MAINS_FAILURE_SUM: 'Fallo de red SUM',
      LUMINAIRE_DT_FAILURE: 'Fallo del DT de la luminaria',
      LUMINAIRE_FT_FAILURE: 'Fallo de la luminaria FT',
      LUMINAIRE_BATTERY_FAILURE: 'Fallo de la batería de la luminaria',
      LUMINAIRE_LAMP_FAILURE: 'Fallo de la lámpara de la luminaria',
      LUMINAIRE_COM_FAILURE: 'Fallo de comunicación de la luminaria',
      START_NETWORK_COMMISSIONING: 'Iniciar la puesta en servicio de la red',
      STOP_NETWORK_COMMISSIONING: 'Detener la puesta en servicio de la red',
      SINK_AVAILABLE: 'Fregadero disponible',
      SINK_UNAVAILABLE: 'Lavabo no disponible',
      SINK_CONFIGURED: 'Fregadero configurado',
      SINK_NOT_CONFIGURED: 'Fregadero no configurado',
},
    MY_ORGANIZATION: {
      ALPHABET: 'Alfabeto',
      CITY: 'Ciudad',
      NUMBER_SYSTEM: 'Número de sistemas',
},
    FIRMWARE_UPDATE: {
      FIRMWARE_UPDATE_ALERT_TITILE: '¿Estás seguro que deseas Salir?',
      CURRENT_VERSION: 'Versión actual',
      FIRMWARE_ALREADY_UPDATED: 'Firmware ya actualizado',
      FIRMWARE_UPDATE_FAILED_TITLE: 'Error en la actualización del firmware',
      FIRMWARE_PROGRESS_MSG: 'Actualización de firmware en progreso...',
      FIRMWARE_UPDATE_ALERT_SUB_TITILE: 'La actualización del firmware aún está en proceso. ¿Quieres ir al Panel de Control?',
      FIRMWARE_UPDATE_FAILED: 'El proceso de actualización del firmware ha fallado. Inténtalo de nuevo.',
      FIRMWARE_VERSION_UPDATED: 'La actualización del firmware se ha completado con éxito',
      FIRMWARE_ALREADY_UPDATED_TEXT: 'La versión del firmware ya está actualizada a la última versión.',
      FIRMWARE_NOT_AVAILABLE: 'La versión del firmware no se obtuvo correctamente. Cierre la sesión de la aplicación móvil e inicie sesión para volver a intentarlo.',
      LATEST_VERSION: 'Última versión',
      LOST_BLUETOOTH_CONNECTION: 'Conexión Bluetooth perdida',
      ENTRY_PASSWORD: 'Por favor, introduzca la contraseña del sistema para',
      RELEASED_ON: 'Lanzado el',
      SELECT_FIRMWARE_VERSION: 'Seleccione una versión de firmware',
      SELECT_A_VERSION: 'Seleccione una versión',
      UPDATE_TO_LATEST: 'Actualizar a la última versión',
      UPLOAD_FILE: 'Subir archivo',
      FIRMWARE_UPDATE_TITILE: 'Le recomendamos que actualice  el firmware a la última versión.',
      FIRMWARE_UPDATEPOPUP_MSG: 'Ya no estás conectado a la',
      SELECT_A_VERSION_USB: 'Seleccione una versión desde USB',
      TAP_UPDATE_LATEST_SECOND_STEP: 'Toca "Actualizar a la última versión" a continuación',
      INSERT_USB_DRIVE: 'Inserte una unidad USB en el puerto USB del sistema.',
      FIRMWARE_UPDATE_VIA_USB_FIRST_STEP: 'Utilice los siguientes pasos para actualizar el firmware sin una conexión a Internet.',
      UPDATE_FIRMWARE_USB: 'Actualizar el firmware mediante USB',
      FIRMWARE_UPDATE_ALERT_SUB_TITILE_WIRELESS: 'La actualización del firmware sigue en curso. ¿Quieres volver a la pantalla de inicio?',
},
    ASSETS: {
      ASSETS_DETAILS: 'Detalles de los activos',
},
    SYSTEM_TYPE: {
      ATPLUS: 'A+',
      CGLINE: 'Línea CG+',
      DGS: 'Dirección General S',
      LPSMART: 'LP inteligente',
      LPSTAR: 'Estrella LP',
      WIRELESS: 'Inalámbrico',
      ZBS: 'ZBS',
      ATS_PLUS: 'AT-S+',
      CGLINE_160: 'CGLine 160',
      CGLINE_400: 'CGLine 400',
      WEB_CONTROLLER: 'Controlador web',
      WEB_CONTROLLER_AE: 'Controlador web AE',
      WIRELESS_LUMINAIRE: 'Luminaria inalámbrica',
      BLEDGE_GATEWAY: 'Puerta de enlace BLEdge',
      GATEWAY: 'Puerta',
      XDETECT: 'xDetectar',
},
    DEVICE_TYPE_VALUE: {
      AT: 'A+',
      ATS: 'AT-S+',
      CGLINE: 'Línea de código',
      DGS: 'Dirección General S',
      LPSMART: 'LP-INTELIGENTE',
      LPSTAR: 'LP-ESTRELLA',
      WIRELESS: 'INALÁMBRICO',
      ZBS: 'ZB-S',
      BLEDGE_GATEWAY: 'Puerta de enlace BLEdge',
      ATSPLUS: 'AT+',
},
    CONTROLLER_TYPE_VALUE: {
      AT: 'A+',
      CGLINE_PLUS: 'Línea de código+',
      DGS: 'Dirección General S',
      LP_SMART: 'LP-INTELIGENTE',
      LP_STAR: 'LP-ESTRELLA',
      WIRELESS: 'INALÁMBRICO',
      ZBS: 'ZBS',
},
    ACTIONS: {
      BACK: 'Atrás',
      CANCEL: 'Cancelar',
      CHANGE_LANGUAGE: '¡Cambia el idioma aquí!',
      CLICK_BUTTON: 'Haga clic en el botón',
      UPDATE_REDUX: '¡Haga clic en el botón para actualizar el valor de la tienda redux!',
      CONFIRM: 'Confirmar',
      CONTINUE: 'Continuar',
      DELETE: 'Borrar',
      RESEND_VERIFICATION_EMAIL_LABEL: '¿No recibiste el correo electrónico?',
      DISABLE: 'Desactivar',
      DONE: 'Hecho',
      DOWNLOAD_DATA: 'Descargar datos',
      EDIT: 'Editar',
      ENABLE: 'Permitir',
      EXTEND: 'Extender',
      FINISH: 'Finalizar',
      GO_HOME: 'Ir a Inicio',
      GO_TO_DASHBOARD: 'Ir a mi panel de control',
      GO_TEST: 'Ir a la página de prueba',
      LOG_IN: 'Acceso',
      LOG_OUT: 'Finalizar la sesión',
      NEXT: 'Próximo',
      OKAY: 'De acuerdo',
      QUIT: 'Abandonar',
      REMEMBER: 'Acuérdate de mí',
      RETRY: 'Rever',
      SAVE: 'Ahorrar',
      SAVE_ADD_ANOTHER: 'Guardar y agregar otro',
      SEND: 'Enviar',
      RESEND: 'Enviar de nuevo',
      RESEND_VERIFICATION_EMAIL: 'Enviar de nuevo',
      SUBMIT: 'Entregar',
      SUBMITCHANGES: 'Enviar cambios',
      TRANSFER: 'Transferir',
      UPDATE: 'Actualizar',
},
    NETWORK: {
      BAD_REQUEST_MESSAGE: 'Solicitud incorrecta',
      INTERNAL_SERVER_ERROR_MESSAGE: 'Error Interno del Servidor',
      NO_DATA_FOUND: 'No se encontraron datos',
      REQUEST_NOT_FOUND_MESSAGE: 'Extraviado',
      ERROR_INTERNET_CONNECTION: 'Parece que no tienes conexión a Internet. Inténtalo de nuevo.',
      SERVICE_UNAVAILABLE: 'Servicio No Disponible',
      ERROR_NO_RESPONSE: 'Algo salió mal',
      ERROR_MESSAGE_SENDING_REQUEST: 'Lo sentimos, hubo un problema al enviar su solicitud.',
      ERROR_INVALID_REQUEST: 'Lo sentimos, su solicitud no es válida.',
      NETWORK_ALERT_SUBTITILE: 'El panel de control no está disponible porque ya no estás conectado a internet',
      ERROR_NOT_FOUND: 'No se encuentra el recurso.',
      ERROR_ALERT_TITLTE: 'No se puede conectar al Dashboard',
      UNAUTHORISED_REQUEST_MESSAGE: 'No autorizado: se ha denegado la autorización para esta solicitud.',
      ERROR_RESTRICTED_USER_ACCESS: 'El usuario no tiene acceso al recurso.',
},
    CONNECTION_TYPE_VALUE: {
      BLE: 'BLE',
      BLUETOOTH: 'Bluetooth',
      CELLULAR: 'Celular',
      ETHERNET: 'Ethernet',
      MODBUS: 'Modbus',
      MQTT: 'MQTT',
      RS485: 'RS485',
      WIFI: 'Wifi',
      WIREPAS: 'Pasador de alambre',
      NO_ACTIVE_CONNECTION: 'No hay conexión activa',
},
    STATUS: {
      STATUS_BLOCK: 'Obstruido',
      BLOCKED: 'Obstruido',
      STATUS_EMPTY: 'Vacío',
      STATUS_ERROR: 'Error',
      ERROR: 'Error',
      EVENT: 'Evento',
      DT: 'En DT',
      STATUS_DT: 'En prueba',
      INTEST: 'En prueba',
      STATUS_OFFLINE: 'Desconectado',
      STATUS_READY: 'Listo',
      READY: 'Listo',
      TOTAL_LUMINAIRES: 'Luminarias Totales',
      TOTAL_SYSTEM: 'Sistemas totales',
      STATUS_WARNING: 'Advertencia',
      WARNING: 'Advertencia',
},
    UNSUPPORTED_BROWSER: {
      NOT_SUPPORTED: 'Navegador no compatible',
      INCOMPATIBLE_BROWSER: 'Esta aplicación web es incompatible con su navegador actual.',
      RECOMMENDED_BROWSER: 'Recomendamos actualizar a la última versión de Microsoft Edge, Safari, Firefox o Chrome para utilizar esta herramienta.',
},
    ENTITY_TYPE: {
      BUILDING: 'Edificio',
      DEVICE: 'Dispositivo',
      DEVICE_TYPE: 'Tipo de dispositivo',
      GATEWAY: 'Puerta',
      LUMINARY: 'Luminaria',
      MASTER_ROLE: 'Rol de maestro',
      ORGANIZATION: 'Organización',
      ORGANIZATION_STATISTIC_DETAIL: 'Detalle estadístico de la organización',
      PLATFORM: 'Plataforma',
      SYSTEM: 'Sistema',
      USER: 'Usuario',
},
    LOGSOURSE_DEVICE_TYPE: {
      BUILDING: 'Edificio',
      DEVICE: 'Dispositivo',
      DEVICETYPE: 'Tipo de dispositivo',
      GATEWAY: 'Puerta',
      LUMINARY: 'Luminaria',
      MASTERROLE: 'Rol maestro',
      ORGANIZATION: 'Organización',
      ORGANIZATIONSTATISTICALDETAIL: 'Detalle estadístico de la organización',
      SYSTEM: 'Sistema',
      USER: 'Usuario',
},
    TECHNICIAN_DETAILS: {
      BUILD_ADMIN: 'Administración del edificio',
      BUILD_VIEWER: 'Visor de edificios',
      CUST_VIEWER: 'Visor de clientes',
      INDIVIDUAL_DETAILS: 'Detalles individuales',
      LIMT_ACCESS: 'Acceso limitado',
      ORG_ADMIN: 'Administrador de la organización',
      ORG_VIEWER: 'Visor de la organización',
      PASS_SERVICE_MANAGER: 'Gerente de servicio de pases',
      PROJ_OWNER: 'Propietario del proyecto',
      REMOVE_USER: 'Eliminar usuario',
      SERVICE_MANAGER: 'Gerente de servicio',
      SYSTM_ADMIN: 'Administrador del sistema',
      SYSTM_VIEWER: 'Visor del sistema',
      TECHNICIAN: 'Técnico',
      USER_DETAILS: 'Detalles del usuario',
      COMPANY_DETAILS: 'Datos de la empresa',
      COMPANY: 'Compañía',
      STATUS: 'Estado',
},
    TRANSFER_BUILDING_TO_ORGANIZATION: {
      TRANSFER_SUCCESS: 'Edificio transferido exitosamente a otra organización',
      CONFIRM_PASSWORD: 'confirmar Contraseña',
      INSTRUCTIONS: 'Transferir de forma permanente todos los {{buildingCount}} edificios, incluidas todas las {{systemCount}} gateway y {{gatewayCount}} sistemas.',
      ORG_SELECT: 'Seleccione una organización válida',
      INSTRUCTION_TWO: 'Escriba la contraseña de su cuenta de administrador de la organización para confirmar la acción',
      TRANSFER: 'Transferir',
      HEADER_TITLE: 'Transferencia de edificio a otra organización \n \n Organización',
      DROPDOWN_LABEL: 'Transferir a...',
},
    CHANGE_PASSWORD_SCREEN: {
      CHANGE_PASSWORD: 'Cambiar la contraseña',
      CONFIRM_PASSWORD: 'confirmar Contraseña',
      NEW_PASSWORD: 'Nueva contraseña',
},
    MESSAGES: {
      CONGRATS: '¡Felicidades!',
      CONTACT: 'Comuníquese con un representante de soporte de Eaton',
      EMAIL_SENT: 'Correo electrónico enviado',
      ERROR: '¡Error!',
      FAILURE: 'Fallo',
      LOADING: 'Cargando...',
      EMAIL_ENTRY_ERROR: 'Por favor, introduzca un correo electrónico válido',
      SUCCESS: 'Éxito',
      WELCOME: '¡Bienvenido!',
      LOGIN_MESSAGE: 'Estás \'conectado\'',
},
    LANDING_SCREEN: {
      CONNECT_NOW: 'Conectarse ahora',
      CONNECT_TO_SYSTEM: 'Conectarse a los sistemas',
      CONTINUE_TO_DASHBOARD: 'Continuar al Tablero',
      DASHBOARD_UNAVAILABLE: 'Panel de control no disponible',
      NO_INTERNET_CONNECTION: 'Sin conexión a Internet',
      VIEW_DASHBOARD: 'Ver el panel de control',
      IN_PROGRESS: 'Trabajo en progreso...',
},
    USERS: {
      CREATE_NEW_CUSTOMER: 'Crear nuevo cliente',
      EDIT_PLATFORM_HEADER: 'Editar Plataforma',
      EDIT_PLATFORM_SUCCESS_200: 'Plataforma actualizada exitosamente',
      LOADER_HELPER_TEXT: 'Espere por favor',
      MANAGE_PLATFORM_ERROR_CODE_3047: 'El administrador de servicios principal no está registrado en BSMS. No se puede crear la plataforma',
},
    LABELS: {
      CSV: 'CSV',
      EMAIL: 'Dirección de correo electrónico',
      EXCEL: 'Archivo de Excel',
      FORGOT_PASSWORD: '¿Olvidaste tu contraseña?',
      GROUP_BY: 'Agrupar por:',
      ITEMS_PER_PAGE: 'Elementos por página',
      LOGGING_IN: 'Iniciar sesión',
      NEED_ACCOUNT: '¿Necesitas una cuenta?',
      NEW_PASSWORD: 'Nueva contraseña',
      PASSWORD: 'Contraseña',
      PDF: 'PDF',
      SHOW: 'Espectáculo:',
      SIGN_UP: 'Inscribirse',
      TIME_RANGE: 'Intervalo de tiempo:',
      TO_BE_IMPLEMENTED: 'Para implementar',
      VIEW_ALL_EVENTS: 'Ver todos los {{count}} eventos',
      SIGN_IN_WITH_OKTA: 'Iniciar sesión con Okta',
},
    AUTO_LOGOUT_DISABLED: {
      AUTO_LOGOUT_DISABLED: 'Desactivado',
},
    TIMELINE_EXPORT: {
      DOWNLOAD_TITLE: 'Descargar datos de la línea de tiempo',
      DOWNLOAD_SUBTITLE_SITE: 'Seleccione el rango de fechas del historial de alarmas que desea exportar.',
      DOWNLOAD_SUBTITLE_TIMELINE: 'Seleccione la ubicación y el rango de fechas del historial de alarmas que desea exportar.',
},
    AUTO_LOGOUT_ENABLED: {
      AUTO_LOGOUT_ENABLED: 'Habilitado (recomendado)',
},
    LEAGAL: {
      END_USER_AGREEMENT: 'Acuerdo de usuario final',
      LICENCE_AGREEMENT: 'Acuerdo de licencia de usuario final',
      LEAGAL: 'Legal',
      MANUALS: 'MANUALES',
      OPEN_SOURCE: 'Licencias de código abierto',
      INSTRUCTION_EATON_BSMS_GATEWAY: 'Instrucciones de funcionamiento de la gateway BSMS de Eaton',
      QUICK_START_GUIDE: 'Guía de inicio rápido',
      REMOTE_MONITORING_GUIDE: 'Guía de monitoreo remoto',
      TERMS_CONDITIONS: 'Términos y condiciones',
},
    LEGAL: {
      EULA: 'Acuerdo de licencia de usuario final',
      TITLE: 'Legal',
      OPENSOURCELICENSES: 'Licencias de código abierto',
      TERMSANDCONDITIONS: 'Términos y condiciones',
      REACT_NATIVE: 'Reaccionar nativo',
      EULA_WIRELESS: 'EULA - Eaton Wireless Controller',
      OSS: 'Open source licensing - Eaton Wireless Controller',
      OPEN_SOURCE_BSM: 'Open source licensing - Building Safety Manager',
},
    EVENT_TIMELINE: {
      ERROR_LOADING_MORE_EVENTS: 'Error al cargar más eventos',
      LOAD_MORE_EVENTS: 'Cargar {{count}} eventos más',
},
    ASSETS_SCREEN: {
      FAVORITE_LIMIT_REACHED: 'Se alcanzó el límite de favoritos',
      NOBUILDINGFOUND: 'No se encontraron edificios',
      NOGATEWAYFOUND: 'No se encontraron gateway',
      NOORGANIZATIONFOUND: 'No se encontró ninguna organización',
      NOREPORTFOUND: 'No se encontraron informes',
      NOSYSTEMS: 'No se encontraron sistemas',
      OTHERS: 'OTROS',
      SHOW_ONLY_STARRED_BUILDING: 'Mostrar solo edificios destacados',
      STARRED: 'SEMBRADO DE ESTRELLAS',
      MARK_AS_FAV_API_SUCCESS: 'Agregado a favoritos exitosamente',
      REMOVE_MARK_AS_FAV_API_SUCCESS: 'Eliminado de favoritos exitosamente',
      MARK_AS_FAV_API_FAILURE_MESSAGE: 'Elimine algunos de sus favoritos existentes antes de agregar otros nuevos, ya que el límite máximo es 10.',
},
    ADDLOCATION: {
      ASTERIKSINFO: 'Los campos marcados con un asterisco (*) son campos obligatorios {{entity}}.',
      ADDLOCATIONINFORMATION: 'Información del perfil de ubicación',
},
    HEADER: {
      FORGOT_PASSWORD: 'Has olvidado tu contraseña',
},
    LOGIN: {
      INVALID_CREDENTIALS: 'No se reconoce su combinación de nombre de usuario y contraseña.',
      GENERIC_ERROR: 'Su solicitud no pudo ser procesada en este momento.',
      UNAUTHORIZED_ACCESS: 'Acceso no autorizado',
      UNAUTHORIZED_ACCESS_MESSAGE: 'No estás autorizado para acceder a esta aplicación. Regístrate',
},
    TABS: {
      LIST_VIEW: 'Vista de lista',
      SUMMARY_VIEW: 'Vista de resumen',
},
    NAVIGATION_TABS: {
      LOGBOOK: 'CUADERNO',
      STATUS: 'ESTADO',
},
    HELPANDFEEDBACK: {
      MANUALS: 'Manuales',
      TITLE: 'Instrucciones de funcionamiento de la gateway BSMS de Eaton',
},
    OPERATING_SYSTEM_THEME: {
      OPERATING_SYSTEM_THEME: 'Tema del sistema operativo',
},
    EULA: {
      OTHER_LANGUAGE: 'Acuerdo de licencia de usuario final en otros idiomas',
},
    LOCATIONS: {
      SITES: 'Sitios',
},
    COUNTER: 'El valor es: {{count}}',
    RESPONSE: {
      USER_REGISTERED: 'El usuario puede registrarse',
},
    PASSWORD_RESET: {
      SUCCESS_MESSAGE: 'Su contraseña fue restablecida exitosamente.',
      FAILURE_MESSAGE: 'No se pudo restablecer su contraseña. Inténtelo nuevamente más tarde.',
},
    LICENCE: {
       LICENCE_AGREEMENT: 'Acuerdo de licencia',
      OPEN_SOURCE: 'Licencias de código abierto',
      REACT_NATIVE_LICENCE: {
        MIT_LICENSE: 'Licencia MIT',
        COPYRIGHT_TEXT: 'Copyright (c) Facebook, Inc. y sus afiliados.',
        MIT_LICENSE_TEXT: 'Por la presente se concede permiso, sin cargo, a cualquier persona que obtenga una copia de este software y los archivos de documentación asociados (el "Software"), para tratar el Software sin restricción, incluyendo, sin limitación, los derechos para usar, copiar, modificar, fusionar, publicar, distribuir, sublicenciar y/o vender copias del Software, y para permitir que las personas a quienes se les proporciona el Software lo hagan, sujeto a las siguientes condiciones:',
        MIT_LICENSE_TEXT_ONE: 'El aviso de derechos de autor anterior y este aviso de permiso se incluirán en todas las copias o partes sustanciales del Software.',
        MIT_LICENSE_TEXT_TWO: 'EL SOFTWARE SE PROPORCIONA "TAL CUAL", SIN GARANTÍA DE NINGÚN TIPO, EXPRESA O IMPLÍCITA, INCLUYENDO, ENTRE OTRAS, LAS GARANTÍAS DE COMERCIABILIDAD, IDONEIDAD PARA UN PROPÓSITO PARTICULAR Y NO INFRACCIÓN. EN NINGÚN CASO LOS AUTORES O TITULARES DE LOS DERECHOS DE AUTOR SERÁN RESPONSABLES DE NINGUNA RECLAMACIÓN, DAÑO U OTRA RESPONSABILIDAD, YA SEA EN UNA ACCIÓN CONTRACTUAL, EXTRACONTRACTUAL O DE OTRO MODO, QUE SURJA DE, A PARTIR DE O EN CONEXIÓN CON EL SOFTWARE O EL USO U OTRAS OPERACIONES EN EL SOFTWARE.',
},
},
    WIRELESS_GATEWAY: {
      WIRELESS_SEARCHLUMINAIRE_HEADLINE: 'La búsqueda de todas las luminarias creará una nueva configuración haciendo lo siguiente:',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_ONE: 'Búsqueda de todas las luminarias instaladas y direccionadas',
      WIRELESS_SEARCHLUMINAIRE_PAGE_CONTAINT_TEXT_TWO: 'Al iniciar la búsqueda se eliminarán todas las luminarias activadas y defectuosas de su configuración.',
      WIRELESS_SEARCH_ALL_LUMINARIES_WARNING: 'Si solo necesita agregar luminarias, utilice la opción Buscar nuevas luminarias.',
      WIRELESS_SEARCH_ALL_LUMINARIES_ACTION_NON_CANCELLABLE: 'Esta acción no se puede deshacer.',
      WIRELESS_SEARCH_ALL_LUMINARIES_DIALOG_TEXT: 'Al iniciar la búsqueda se eliminarán de su configuración todas las luminarias activadas con un defecto.',
      WIRELESS_RETRY_SEARCH: 'Reintentar búsqueda',
      WIRELESS_CONFIGURE_LUMINARIES: 'Configurar luminarias',
      WIRELESS_VISIBILITY_PLUS_TITLE: 'Esto aumentará la disponibilidad de iluminación de emergencia en caso de una situación de emergencia.',
      LUMINAIRE_NAME: 'Nombre actualizado exitosamente',
      CONFIGURE_LUMINAIRES: 'Configurar luminarias',
      TEST_GROUP: 'Grupo de prueba',
      CONFIGURE_ZONE: 'Configurar zona',
      CANCEL_GO_BACK: 'Cancelar y volver atrás',
      TRANSFER_ANOTHER_ZONE: 'Transferencia a otra zona',
      SELECT_ZONE_TO_TRANSFER_LUM: 'Seleccione la zona a la que desea transferir',
      FULL: 'LLENO',
      TOTAL_LUMINARIES_COUNT: 'de 64 Luminarias',
      NOT_ENOUGH_SPACE: 'NO HAY SUFICIENTE ESPACIO',
      NO_ZONE_NAME_AVAILABLE: 'Sin nombre de zona',
      SUCCESSFULLY_TRANSFERRED_ZONE: 'Zona transferida exitosamente',
      FAILED_TO_TRANSFER_ZONE: 'Error en la transferencia de zona',
      NO_LUMINAIRES_NAME_AVAILABLE: 'Sin nombre de luminaria',
      NO_EPAS_AVAILABLE: 'Sin EPAS',
      NO_ZONE_DESCRIPTION_AVAILABLE: 'Sin descripción de zona',
      WIRELESS_EDIT_LUMINARIES: 'Editar luminarias asignadas',
      WIRELESS_GROUP: 'Grupo {{item}}',
      WIRELESS_TEST_GROUP_LUMINARIES: 'Luminarias del grupo de prueba {{item}}',
      WIRELESS_TEST_GROUP_SUBTITLE: 'Haga clic o toque luminarias individuales para asignarlas al grupo de prueba {{item}}',
      WIRELESS_ASSIGNED_CURRENT_GROUP: ' {{currentGroupLumCount}} Asignado al grupo actual',
      WIRELESS_ASSIGNED_OTHER_GROUP: ' {{otherGroupLumCount}} Asignado a otros grupos',
      WIRELESS_EMPTY: ' {{emptyGroupLumCount}} Vacío',
      INVALID_LUM_NAME: 'Nombre de luminaria no válido',
      INVALID_ZONE_NAME: 'Nombre de zona no válido',
      ZONE_NAME: 'Nombre de la zona',
      NO_LUMINAIRES_FOUND: 'No se encontraron luminarias',
      GET_GROUP_LUMS_FAILURE: 'No se pudieron obtener los detalles de Luminary',
      NEW_LUMINAIRES_FOUND: 'Nuevas luminarias encontradas',
      VIEW_CONFIGURATION: 'Ver configuración',
      POSTPONE_FT_DT_TEXT: 'Posponer FT/DT por 24 horas en caso de falla.',
      TEST_GROUPS: 'Grupos de prueba',
      TEST_GROUPS_DESCRIPTION: 'Las luminarias se clasifican automáticamente para garantizar que, en caso de emergencia, al menos la mitad de todas las luminarias tengan una carga completa, independientemente de cuándo se realizó la última prueba.',
      COMMISSION_LOGIN: 'Inicio de sesión de la Comisión',
      COMMISSION_LOGIN_FAILED: 'Error al iniciar sesión, inténtelo nuevamente.',
      TURN_ON_LUM: 'Encender las luminarias',
      TURN_OFF_LUM: 'Apague las luminarias',
      TURN_ON_DESC: 'Utilice "Luminarias encendidas" para anular la configuración de las luminarias. Utilice "Restablecer valores predeterminados" para restablecer todas las luminarias a su estado predeterminado.',
      TURN_OFF_DESC: 'Utilice "Luminarias apagadas" para anular la configuración de las luminarias. Utilice "Restablecer valores predeterminados" para restablecer todas las luminarias a su estado predeterminado.',
      RESET_LIMINARIES: 'Restablecer luminaria',
      RESET_LUMINARIES_DESC: 'El reinicio borrará todos los fallos almacenados en la luminaria. Esto no se puede deshacer.',
      RESET_LUMINARIES_SUCESS: 'Reinicio exitoso de la luminaria',
      ZONE_DESCRIPTION: 'Descripción',
      LUMINAIRE_TYPE: 'Tipo de luminaria',
      TRANSFER_LUM_LOADING_MSG: 'Este proceso puede tardar aproximadamente 2 minutos. Espere.',
},
    STAGE_GROUP: {
      SELECT_STAGE_GROUP: 'Seleccionar grupo de etapa',
      STAGE_GROUP: 'Grupo',
},
    NOTIFICATION_KEYS: {
      NOTIFICATION_ALARM_BODY: 'Se ha producido un error {{logType}} con el siguiente sistema',
      NOTIFICATION_HEALTH_REPORT_TITLE: 'Nuevo informe disponible - {{org}}',
      NOTIFICATION_HEALTH_REPORT_BODY: 'Ya está disponible para ver un nuevo informe mensual de {{building}}',
},
    ERROR: {
      NOT_SYNC_DEVICE_PROFILE: 'No se puede sincronizar el perfil del dispositivo con la nube. Puede sincronizar el perfil del dispositivo desde la página de inicio más tarde.',
},
    DRY_CONTACT: {
      DRY_CONTACT: 'Contacto seco',
      DRY_CONTACT_STATUS: 'Estado del contacto seco',
      DRY_CONTACT_INFO: 'Estas configuraciones son de solo lectura y solo se pueden cambiar en la HMI del sistema.',
      SYSTEM_INPUT: 'Entradas del sistema',
      SYSTEM_OUTPUT: 'Salidas del sistema',
      S1S2: 'S1 / S2',
      INPUT_1: 'Entrada 1',
      INPUT_2: 'Entrada 2',
      OUTPUT_1: 'Salida 1',
      OUTPUT_2: 'Salida 2',
      REST_ORDER: 'Orden de descanso',
      MAINTAINED_MODE_OFF_LINE1: 'Modo mantenido fuera de línea 1',
      MAINTAINED_MODE_OFF_LINE2: 'Modo mantenido fuera de línea 2',
      ACTIVATE_IA_MODE_LINE1: 'Activar modo IA Línea 1',
      ACTIVATE_IA_MODE_LINE2: 'Activar modo IA Línea 2',
      STOP_FT_DT: 'Detener FT/DT',
      EXTERNAL_FIALURE: 'Falla externa',
      ONE_LUMINAIRE_FAILURE: 'Fallo de una luminaria',
      FUNCTION_TEST: 'Prueba de función',
      CHARGING_FAILURE: 'Fallo de carga',
      FAILURE_FT_DT: 'Falla FT DT',
      NOT_AVAILABLE: 'N / A',
      BLOCK_THE_SYSTEM: 'Bloquear el sistema',
      SWITCH_MAINTAINED_MODE_OFF: 'Desactivar el modo mantenido para',
      ACTIVATE_IA_MODE: 'Activar el modo IA para',
      STOP_FTDT_TEST: 'Detener la prueba funcional/de duración',
      LUMINAIRE_ALERTS_THRESHOLD: 'Umbral de alertas de luminarias',
      RELAY_NO_1_FUNCTIONS: 'Funciones del relé n.º 1',
      RELAY_FUCTION: 'Funciones de relé',
      RELAY_NAME: 'Nombre del relé',
      MAINTAINED_MODE_OFF_LINE3: 'Modo mantenido fuera de línea 3',
      MAINTAINED_MODE_OFF_LINE4: 'Modo mantenido fuera de línea 4',
      ACTIVATE_IA_MODE_LINE3: 'Activar modo IA Línea 3',
      ACTIVATE_IA_MODE_LINE4: 'Activar modo IA Línea 4',
      DEFAULT_SETTINGS: 'Configuración predeterminada',
      IOSTATUS: {
        REST_ORDER: 'Orden de descanso',
        START_FUNCTIONAL_TEST: 'Iniciar prueba funcional',
        EXTERNAL_FAILURE: 'Falla externa',
},
      START_FUNCTIONAL_TEST: 'Iniciar prueba funcional',
      STOP_FT_DT_MODE: 'Detener FT/DT',
      EXTERNAL_FAILURE: 'Falla externa',
      NOT_CONFIGURED: 'No configurado',
      NORMALLY_OPEN: 'Normalmente abierto',
      BATTERY_OPERATION: 'Funcionamiento con batería',
      IOTSTATUS: {
        ONE_LUMINAIRE_FAILURE: 'Fallo de una luminaria',
        CHARGING_FAILURE: 'Fallo de carga',
        FAILURE_FT_DT: 'Falla FT DT',
},
},
    WIRELESS_ZONE: {
      ZONE_SELECTION: 'Seleccione todas las zonas o 1 zona para la',
      ZONE_NAME: 'Zona 1, "Nombre personalizado"',
      ZONE_NO: 'Zona No.',
      ZONE_FAILURE: 'Fallo de zona',
      ZONE_READY: 'Zona lista',
      ZONE_LUM_LIST: ' Lista de luminarias de la zona',
      SET_RELAY: 'Establecer relé',
      INPUT_NO: 'Entrada n.° 1',
      INFO_CONFIGURE_INPUT: 'Toque para editar o agregar funciones a los relés.',
      NO_OF_OPTIONS_SELECTED: '{{selected}} de {{total}} seleccionados',
      ASSIGN_ALL: 'Asignar todo',
      DIMMING_LEVEL: 'Nivel de atenuación',
      WIRELESS_FUCTIONAL_TEST_TEXT: ' Duración estimada de la prueba: 00:08:00\n\n\' + \'Tiempo de entrega: Estándar\n',
      EDIT_ZONE: 'Zona de edición',
},
    WIRELESS: {
      VISIBILITY_TEST: 'Prueba de visibilidad Plus',
      REFERESH_LUM_TEST: 'Actualizar luminarias',
},
    ACCOUNT_PREFERENCES: {
      LIGHT_THEME: 'Tema de luz',
      DARK_THEME: 'Tema oscuro',
      SYSTEM_THEME: 'Tema del sistema',
      GMT: 'Hora media de Greenwich',
      IST: 'Hora estándar de la India',
      UTC: 'Tiempo Universal Coordinado',
      CST: 'Hora estándar central',
      MST: 'Hora estándar de la montaña',
      EST: 'Zona horaria del este',
      CEST: 'Hora de Europa Central (GMT-1:00)',
      IMPERIAL_UNITS: 'Unidades Imperiales',
      BRITISH_IMPERIAL_SYSTEM: 'Sistema Imperial Británico',
      PER_SYSTEM: 'Por sistema',
      PER_BUILDING: 'Por edificio',
      EMAIL_PUSH_NOTIFICATION: 'Correo electrónico, notificaciones push',
      EMAIL_ONLY: 'Solo correo electrónico',
      DONT_NOTIFY: 'No notificar',
      SAVE_TO_DEVICE_CLOUD: 'Guardar en el dispositivo + Nube',
      SAVE_TO_DEVICE: 'Guardar en el dispositivo',
      SAVE_TO_CLOUD: 'Nube',
},
    LINE_ZONE: {
      LINE: 'Línea',
      ZONE: 'Zona',
},
    SLA: {
      SLAS: 'Acuerdos de nivel de servicio',
      TECHNICIAN: 'Técnico',
      UNASSIGNED: 'Sin asignar',
      NOT_SCHEDULED: 'No programado',
      ALL_CUSTOMERS: 'Todos los clientes',
      STATUS_TODAY: 'Hoy',
      STATUS_SCHEDULED: 'Programado',
      STATUS_DUE: 'Vencido',
      STATUS_IN_FEW_DAYS: 'En {{days}} días',
},
    CONNECTION_TYPE: {
      IP_NETWORK: 'Red IP',
      ELE_SYSTEM: 'Conectarse directamente al sistema EL',
},
    REPLACE_COMPONENT_FEATURE: {
      REPLACE_COMPONENT: 'Reemplazar un componente',
      UPDATE_EPAS_NUMBER: 'Actualizar el número EPAS',
      VALID_EPAS_NUMBER: 'Por favor, introduzca un número EPAS válido',
      WHAT_WAS_REPLACED: '¿Qué fue reemplazado?',
      ENTER_EPAS_NEW_RADIO: 'Por favor ingrese el EPAS de la nueva radio',
      NEW_EPAS_NUMBER: 'Nuevo número EPAS',
      REPLACE_LUMINAIRE: 'Reemplazar una luminaria',
      REPLACE_MODULE: 'Reemplazar un módulo',
      PREVIOUS_EPAS_NUMBER: 'Número EPAS anterior',
      EPAS_UPDTAED_SUCCESS: 'Número EPAS actualizado con éxito',
      EPAS_UPDTAED_FAILED: 'No se pudo actualizar el número EPAS',
},
    CONFIG_IO: {
      REST_ORDER: 'Orden de descanso',
      SWITCH_MAINTAINED_MODE_OFF_FOR: 'Desactivar el modo mantenido para',
      ACTIVATE_IA_MODE_FOR: 'Activar el modo IA para',
      START_FUNCTIONAL_TEST_OR_DURATION_TEST: 'Detener la prueba funcional/de duración',
},
},
};
 export default resources;
